var _polygon, _polygon2, _polygon3, _polygon4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _ellipse, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _polygon28, _path399, _polygon29, _path400;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormgroupPerformance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 208.86 246.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_3",
    "data-name": "Ebene 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LOGISTICS"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "48.48 102.09 96.46 129.79 96.47 185.2 48.48 212.9 0.5 185.2 0.5 129.79 48.48 102.09",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.6,185.32l47.82-27.57m.18-.87V102.32m0,55.18,47.54,27.59",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.77,187.85a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,21.77,187.85Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,187.13a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0c-.14-.08-.14-.2,0-.28A.51.51,0,0,1,23,187.13Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.28,186.41a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,24.28,186.41Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.53,185.68a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,25.53,185.68Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.78,185c.14.08.14.2,0,.28a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,26.78,185Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,184.25a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,28,184.25Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.29,183.52c.14.08.14.2,0,.28a.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,29.29,183.52Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.55,182.8a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0c-.14-.08-.14-.2,0-.28A.51.51,0,0,1,30.55,182.8Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8,182.08a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,31.8,182.08Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.05,181.35a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,33.05,181.35Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3,180.63c.14.08.14.2,0,.28a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,34.3,180.63Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.56,179.91a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,35.56,179.91Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.81,179.18a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,36.81,179.18Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.82,
    cy: 178.6,
    rx: 0.34,
    ry: 0.2,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.31,177.74c.14.07.14.2,0,.27a.49.49,0,0,1-.47,0c-.14-.07-.14-.2,0-.27A.49.49,0,0,1,39.31,177.74Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.57,177a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,40.57,177Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.82,176.29a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,41.82,176.29Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.07,175.57c.14.07.14.2,0,.27a.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,43.07,175.57Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.56,178.46a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,35.56,178.46Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.81,177.74a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,36.81,177.74Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.06,177a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,38.06,177Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.31,176.29c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0c-.14-.08-.14-.2,0-.28A.49.49,0,0,1,39.31,176.29Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.57,175.57a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27.51.51,0,0,1,.48,0Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3,177.74c.14.07.14.2,0,.27a.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,34.3,177.74Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.56,177a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,35.56,177Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.81,176.29a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,36.81,176.29Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.06,175.57a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,38.06,175.57Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.05,177a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,33.05,177Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3,176.29c.14.08.14.2,0,.28a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,34.3,176.29Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.32,
    cy: 175.71,
    rx: 0.34,
    ry: 0.2,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.57,
    cy: 174.98,
    rx: 0.34,
    ry: 0.2,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8,176.29a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,31.8,176.29Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.81,
    cy: 175.71,
    rx: 0.34,
    ry: 0.2,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3,174.84c.14.08.14.2,0,.28a.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,34.3,174.84Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.56,174.12a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28.51.51,0,0,1,.48,0Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.53,175.56c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0c-.14-.08-.14-.2,0-.28A.49.49,0,0,1,30.53,175.56Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.79,174.84a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,31.79,174.84Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,174.11a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,33,174.11Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.29,173.39c.14.08.14.2,0,.28a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,34.29,173.39Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.53,174.11c.14.08.14.2,0,.28a.49.49,0,0,1-.47,0c-.14-.08-.14-.2,0-.28A.55.55,0,0,1,30.53,174.11Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.79,173.39a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,31.79,173.39Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,172.67a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27.51.51,0,0,1,.48,0Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.53,172.67c.14.07.14.2,0,.27a.49.49,0,0,1-.47,0c-.14-.07-.14-.2,0-.27A.49.49,0,0,1,30.53,172.67Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.79,171.94a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,31.79,171.94Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.62,
    cy: 198.1,
    rx: 0.34,
    ry: 0.2,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.12,197.24a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0c-.14-.07-.14-.2,0-.27A.51.51,0,0,1,48.12,197.24Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.36,198a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,44.36,198Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.61,197.24a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,45.61,197.24Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.86,196.51a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,46.86,196.51Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1,197.24c.14.07.14.2,0,.27a.49.49,0,0,1-.47,0c-.14-.07-.14-.2,0-.27A.49.49,0,0,1,43.1,197.24Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.36,196.51a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,44.36,196.51Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.61,195.79a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,45.61,195.79Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.85,196.51a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,41.85,196.51Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1,195.79c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0c-.14-.08-.14-.2,0-.28A.49.49,0,0,1,43.1,195.79Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.36,195.07a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,44.36,195.07Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.61,
    cy: 195.21,
    rx: 0.34,
    ry: 0.2,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1,194.34c.14.08.14.2,0,.28a.49.49,0,0,1-.47,0c-.14-.08-.14-.2,0-.28A.55.55,0,0,1,43.1,194.34Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.84,193.61a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0C41.23,193.81,41.71,193.54,41.84,193.61Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.31,195.06c.14.08.14.2,0,.28a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,29.31,195.06Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.57,194.34a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0c-.14-.07-.14-.2,0-.27A.51.51,0,0,1,30.57,194.34Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.82,193.61a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,31.82,193.61Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.07,192.89a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,33.07,192.89Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.32,192.17c.14.07.14.2,0,.27a.49.49,0,0,1-.47,0c-.14-.07-.14-.2,0-.27A.49.49,0,0,1,34.32,192.17Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.58,191.44a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,35.58,191.44Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.83,190.72a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,36.83,190.72Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.81,195.06a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,26.81,195.06Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.06,194.34a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,28.06,194.34Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.31,193.61c.14.08.14.2,0,.28a.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,29.31,193.61Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.57,192.89a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0c-.14-.08-.14-.2,0-.28A.51.51,0,0,1,30.57,192.89Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.82,192.17a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,31.82,192.17Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.83,
    cy: 191.58,
    rx: 0.34,
    ry: 0.2,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.32,190.72c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0c-.14-.08-.14-.2,0-.28A.49.49,0,0,1,34.32,190.72Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.58,190a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,35.58,190Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3,195.06a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,24.3,195.06Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.32,
    cy: 194.47,
    rx: 0.34,
    ry: 0.2,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.81,193.61a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,26.81,193.61Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.05,194.34a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,23.05,194.34Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3,193.61a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,24.3,193.61Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.79,193.61a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0c-.14-.07-.14-.2,0-.27A.51.51,0,0,1,21.79,193.61Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,192.88a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,23,192.88Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.53,192.88c.14.08.14.2,0,.28a.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,20.53,192.88Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.79,192.16a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0c-.14-.08-.14-.2,0-.28A.51.51,0,0,1,21.79,192.16Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.28,192.16a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,19.28,192.16Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.53,191.44c.14.07.14.2,0,.27a.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,20.53,191.44Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.28,190.71a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,19.28,190.71Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.31,189.27a.51.51,0,0,1,.48,0,.14.14,0,0,1,0,.27C21.65,189.62,21.17,189.34,21.31,189.27Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,188.54a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,23,188.54Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.29,187.82a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,24.29,187.82Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.54,187.1c.14.07.14.2,0,.27a.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,25.54,187.1Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8,186.37a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,26.8,186.37Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.05,185.65a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,28.05,185.65Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.37,196.8a.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28.57.57,0,0,1,.48,0,.15.15,0,0,1,0,.28Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.62,195.8c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0c-.14-.08-.14-.2,0-.28A.49.49,0,0,1,50.62,195.8Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.88,195.08a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,51.88,195.08Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.13,194.35a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,53.13,194.35Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.38,193.63c.14.08.14.2,0,.28a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,54.38,193.63Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.64,192.91a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0c-.14-.07-.14-.2,0-.27A.51.51,0,0,1,55.64,192.91Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.89,192.18a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,56.89,192.18Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.14,191.46a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,58.14,191.46Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.39,190.74c.14.07.14.2,0,.27a.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,59.39,190.74Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.65,190a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,60.65,190Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.64,195.8a.51.51,0,0,1,.48,0,.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0A.15.15,0,0,1,47.64,195.8Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.37,195.08a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,49.37,195.08Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.62,194.35c.14.08.14.2,0,.28a.49.49,0,0,1-.47,0c-.14-.08-.14-.2,0-.28A.55.55,0,0,1,50.62,194.35Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.88,193.63a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,51.88,193.63Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.13,192.91a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,53.13,192.91Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.38,192.18c.14.08.14.2,0,.28a.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,54.38,192.18Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.64,191.46a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0c-.14-.08-.14-.2,0-.28A.51.51,0,0,1,55.64,191.46Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.65,
    cy: 190.88,
    rx: 0.34,
    ry: 0.2,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.14,190a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,58.14,190Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.39,189.29c.14.08.14.2,0,.28a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,59.39,189.29Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.39,195.08a.49.49,0,0,1,.47,0c.14.07.14.2,0,.27a.51.51,0,0,1-.48,0C46.25,195.28,46.25,195.15,46.39,195.08Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.12,194.35a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,48.12,194.35Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.37,193.63a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,49.37,193.63Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.62,192.91c.14.07.14.2,0,.27a.49.49,0,0,1-.47,0c-.14-.07-.14-.2,0-.27A.49.49,0,0,1,50.62,192.91Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.88,192.18a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,51.88,192.18Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.65,191.46a.51.51,0,0,1,.48,0,.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.38,190.74c.14.07.14.2,0,.27a.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,54.38,190.74Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.64,190a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0c-.14-.08-.14-.2,0-.28A.57.57,0,0,1,55.64,190Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.89,189.29a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,56.89,189.29Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.13,194.35a.57.57,0,0,1,.48,0,.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0A.15.15,0,0,1,45.13,194.35Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.36,193.91a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28C44,193.55,44.49,193.83,44.36,193.91Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.35,192.18a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,44.35,192.18Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6,191.45c.14.08.14.2,0,.28a.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,45.6,191.45Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.86,190.73a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0c-.14-.08-.14-.2,0-.28A.51.51,0,0,1,46.86,190.73Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.11,190a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,48.11,190Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.12,
    cy: 189.42,
    rx: 0.34,
    ry: 0.2,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.61,188.56c.14.08.14.2,0,.28a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,50.61,188.56Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.87,187.84a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,51.87,187.84Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.12,187.11a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,53.12,187.11Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1,191.45a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,43.1,191.45Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.35,190.73a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,44.35,190.73Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6,190c.14.07.14.2,0,.27a.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,45.6,190Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.86,189.28a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0c-.14-.08-.14-.2,0-.28A.57.57,0,0,1,46.86,189.28Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.11,188.56a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,48.11,188.56Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.36,187.84a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,49.36,187.84Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.61,187.11c.14.08.14.2,0,.28a.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,50.61,187.11Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.87,186.39a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,51.87,186.39Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.12,185.67a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,53.12,185.67Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.37,190.73a.49.49,0,0,1,.47,0c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0C41.23,190.93,41.23,190.81,41.37,190.73Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1,190a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,43.1,190Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.87,189.28a.57.57,0,0,1,.48,0,.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28C44,189.21,43.74,189.36,43.87,189.28Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6,188.56c.14.08.14.2,0,.28a.57.57,0,0,1-.48,0C45,188.76,45.47,188.48,45.6,188.56Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.86,187.84a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0C46.24,188,46.72,187.76,46.86,187.84Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.13,185.94a.14.14,0,0,1,0-.27.51.51,0,0,1,.48,0C50.75,185.74,50.27,186,50.13,185.94Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.36,184.94a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,49.36,184.94Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.61,184.22c.14.08.14.2,0,.28a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,50.61,184.22Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.61,190a.49.49,0,0,1,.47,0c.14.07.14.2,0,.27a.51.51,0,0,1-.48,0C37.47,190.21,37.47,190.08,37.61,190Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.34,189.28a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,39.34,189.28Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.59,188.56a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,40.59,188.56Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.84,187.84c.14.07.14.2,0,.27a.49.49,0,0,1-.47,0c-.14-.07-.14-.2,0-.27A.49.49,0,0,1,41.84,187.84Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1,187.11a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,43.1,187.11Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.35,186.39a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,44.35,186.39Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6,185.67c.14.07.14.2,0,.27a.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,45.6,185.67Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.86,184.94a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0c-.14-.08-.14-.2,0-.28A.57.57,0,0,1,46.86,184.94Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.11,184.22a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,48.11,184.22Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.36,183.5a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,49.36,183.5Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,189.28a.57.57,0,0,1,.48,0,.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0A.15.15,0,0,1,36.35,189.28Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.09,188.56a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0c-.14-.08-.14-.2,0-.28A.51.51,0,0,1,38.09,188.56Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.34,187.84a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,39.34,187.84Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.59,187.11a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,40.59,187.11Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.84,186.39c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0c-.14-.08-.14-.2,0-.28A.49.49,0,0,1,41.84,186.39Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1,185.67a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,43.1,185.67Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.35,184.94a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,44.35,184.94Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6,184.22c.14.08.14.2,0,.28a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,45.6,184.22Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.86,183.5a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0c-.14-.07-.14-.2,0-.27A.51.51,0,0,1,46.86,183.5Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.11,182.77a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,48.11,182.77Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.11,181.33a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,48.11,181.33Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.36,180.6a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,49.36,180.6Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.61,179.88c.14.08.14.2,0,.28a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,50.61,179.88Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.87,179.16a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,51.87,179.16Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.12,178.43a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,53.12,178.43Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.37,177.71a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,54.37,177.71Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.62,177c.14.07.14.2,0,.27a.49.49,0,0,1-.47,0c-.14-.07-.14-.2,0-.27A.49.49,0,0,1,55.62,177Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.62,183.05a.15.15,0,0,1,0-.28.57.57,0,0,1,.48,0,.15.15,0,0,1,0,.28A.51.51,0,0,1,42.62,183.05Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.35,182.05a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,44.35,182.05Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6,181.33c.14.07.14.2,0,.27a.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,45.6,181.33Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.86,180.6a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0c-.14-.08-.14-.2,0-.28A.57.57,0,0,1,46.86,180.6Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.11,179.88a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,48.11,179.88Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.36,179.16a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,49.36,179.16Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.61,178.43c.14.08.14.2,0,.28a.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,50.61,178.43Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.87,177.71a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,51.87,177.71Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.12,177a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,53.12,177Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.37,176.26a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,54.37,176.26Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.83,182c.14.08.14.2,0,.28a.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,41.83,182Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.09,181.32a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,43.09,181.32Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.34,180.6a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,44.34,180.6Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.59,179.87a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,45.59,179.87Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.61,
    cy: 179.29,
    rx: 0.34,
    ry: 0.2,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1,178.43a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,48.1,178.43Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.35,177.7a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,49.35,177.7Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6,177c.14.08.14.2,0,.28a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,50.6,177Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.62,
    cy: 176.39,
    rx: 0.34,
    ry: 0.2,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.11,175.53a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,53.11,175.53Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.58,181.32a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,40.58,181.32Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.83,180.6c.14.07.14.2,0,.27a.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,41.83,180.6Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.85,
    cy: 180.01,
    rx: 0.34,
    ry: 0.2,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.34,179.15a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,44.34,179.15Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.59,178.43a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,45.59,178.43Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.61,
    cy: 177.84,
    rx: 0.34,
    ry: 0.2,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1,177a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,48.1,177Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.35,176.26a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,49.35,176.26Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6,175.53c.14.08.14.2,0,.28a.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,50.6,175.53Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.86,174.81a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0c-.14-.08-.14-.2,0-.28A.51.51,0,0,1,51.86,174.81Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.33,180.6a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,39.33,180.6Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.58,179.87a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,40.58,179.87Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.83,179.15c.14.08.14.2,0,.28a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,41.83,179.15Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.09,178.43a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,43.09,178.43Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.34,177.7a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,44.34,177.7Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.59,177a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,45.59,177Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.84,176.26c.14.07.14.2,0,.27a.49.49,0,0,1-.47,0c-.14-.07-.14-.2,0-.27A.49.49,0,0,1,46.84,176.26Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1,175.53a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,48.1,175.53Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.35,174.81a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,49.35,174.81Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.83,184.94a.49.49,0,0,1,.47,0c.14.07.14.2,0,.27a.51.51,0,0,1-.48,0C28.69,185.14,28.69,185,28.83,184.94Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.56,184.21a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,30.56,184.21Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.81,183.49a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,31.81,183.49Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.06,182.77c.14.07.14.2,0,.27a.49.49,0,0,1-.47,0c-.14-.07-.14-.2,0-.27A.49.49,0,0,1,33.06,182.77Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.08,
    cy: 182.18,
    rx: 0.34,
    ry: 0.2,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.57,181.32a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,35.57,181.32Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.82,180.6c.14.07.14.2,0,.27a.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,36.82,180.6Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.08,179.87a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0c-.14-.08-.14-.2,0-.28A.57.57,0,0,1,38.08,179.87Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.33,179.15a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,39.33,179.15Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.58,178.43a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,40.58,178.43Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.83,177.7c.14.08.14.2,0,.28a.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,41.83,177.7Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.09,177a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,43.09,177Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.34,176.26a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,44.34,176.26Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.59,175.53a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,45.59,175.53Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.73,198.58c.13.08.13.21,0,.28a.51.51,0,0,1-.48,0c-.13-.07-.13-.2,0-.28A.57.57,0,0,1,70.73,198.58Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,197.86a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,72,197.86Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.23,197.14c.14.07.14.2,0,.27a.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,73.23,197.14Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.49,196.41c.13.08.13.21,0,.28a.51.51,0,0,1-.48,0c-.13-.07-.13-.2,0-.28A.57.57,0,0,1,74.49,196.41Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.22,198.58c.14.08.14.21,0,.28a.51.51,0,0,1-.48,0c-.13-.07-.13-.2,0-.28A.57.57,0,0,1,68.22,198.58Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.48,197.86a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0c-.14-.08-.14-.2,0-.28A.57.57,0,0,1,69.48,197.86Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.73,197.14a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,70.73,197.14Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,196.41c.13.08.13.21,0,.28a.51.51,0,0,1-.48,0c-.13-.07-.13-.2,0-.28A.57.57,0,0,1,72,196.41Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.23,195.69c.14.08.14.2,0,.28a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,73.23,195.69Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.49,195c.13.07.13.2,0,.28a.57.57,0,0,1-.48,0c-.13-.08-.13-.21,0-.28A.51.51,0,0,1,74.49,195Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.72,198.58c.13.08.13.21,0,.28a.51.51,0,0,1-.48,0c-.13-.07-.13-.2,0-.28A.57.57,0,0,1,65.72,198.58Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,197.86a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,67,197.86Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.22,197.14c.14.07.14.2,0,.27a.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,68.22,197.14Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.48,196.41c.13.08.13.21,0,.28a.51.51,0,0,1-.48,0c-.14-.07-.14-.2,0-.28A.57.57,0,0,1,69.48,196.41Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.73,195.69a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,70.73,195.69Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,195c.13.07.13.2,0,.28a.57.57,0,0,1-.48,0c-.13-.08-.13-.21,0-.28A.51.51,0,0,1,72,195Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.23,194.25c.14.07.14.2,0,.27a.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,73.23,194.25Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.46,197.86c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0c-.14-.08-.14-.2,0-.28A.55.55,0,0,1,64.46,197.86Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.72,197.14a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,65.72,197.14Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,196.41c.13.08.13.21,0,.28a.51.51,0,0,1-.48,0c-.13-.07-.13-.2,0-.28A.57.57,0,0,1,67,196.41Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.22,195.69c.14.08.14.2,0,.28a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,68.22,195.69Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.21,197.14a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,63.21,197.14Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.46,196.41c.14.08.14.21,0,.28a.49.49,0,0,1-.47,0c-.14-.07-.14-.2,0-.28A.55.55,0,0,1,64.46,196.41Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.72,195.69a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,65.72,195.69Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.21,195.69a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,63.21,195.69Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.23,
    cy: 195.11,
    rx: 0.34,
    ry: 0.2,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2,194.24a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,63.2,194.24Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,193.51a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,62,193.51Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2,192.79a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,63.2,192.79Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7,192.79a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0c-.14-.08-.14-.2,0-.28A.51.51,0,0,1,60.7,192.79Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,192.07a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,62,192.07Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2,191.34a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,63.2,191.34Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.44,192.07c.14.07.14.2,0,.27a.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,59.44,192.07Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7,191.34a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0c-.14-.08-.14-.2,0-.28A.57.57,0,0,1,60.7,191.34Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,190.62a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,62,190.62Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.41,176.27a.51.51,0,0,1,.48,0,.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0C56.28,176.47,56.27,176.35,56.41,176.27Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.14,175.55a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,58.14,175.55Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.39,174.82c.14.08.14.2,0,.28a.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,59.39,174.82Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.15,175.55a.51.51,0,0,1,.48,0c.14.07.14.2,0,.27a.49.49,0,0,1-.47,0C55,175.75,55,175.62,55.15,175.55Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.89,174.82a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,56.89,174.82Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.14,174.1a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,58.14,174.1Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.39,173.38c.14.07.14.2,0,.27a.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,59.39,173.38Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.89,174.82a.51.51,0,0,1,.48,0,.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0A.14.14,0,0,1,53.89,174.82Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.62,174.09c.14.08.14.2,0,.28a.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,55.62,174.09Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.88,173.37a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,56.88,173.37Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.13,172.65a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,58.13,172.65Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.64,174.09a.57.57,0,0,1,.48,0,.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0A.15.15,0,0,1,52.64,174.09Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.37,173.37a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,54.37,173.37Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.62,172.65c.14.07.14.2,0,.27a.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,55.62,172.65Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.88,171.92a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,56.88,171.92Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.68,189.8a7,7,0,0,0-6.49,0l-7,4a6,6,0,0,1-5.32,0,1.24,1.24,0,0,1,0-2.39l8.06-4.65a2.37,2.37,0,0,0,0-4.43l-.17-.1a7,7,0,0,0-6.5,0l-15.57,9a6,6,0,0,1-5.32,0l-2.83-1.63a1.56,1.56,0,0,1-.93-1.2c0-.42.34-.85.93-1.19l24.42-14a3.74,3.74,0,0,0,3.06-.13,1,1,0,0,0,0-1.92,3.62,3.62,0,0,0-3.33,0c-.57.33-.79.79-.65,1.21L20,186.21a2.38,2.38,0,0,0,0,4.43l2.83,1.63a7.08,7.08,0,0,0,6.49,0l15.58-9a5.93,5.93,0,0,1,5.32,0l.17.1c.59.34.93.77.93,1.19a1.56,1.56,0,0,1-.93,1.2l-8.05,4.65a2.37,2.37,0,0,0,0,4.43,7.08,7.08,0,0,0,6.49,0l7-4a6,6,0,0,1,5.31,0l3.16,2,.56-1.57Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "ACTIVE",
    d: "M61.82,188.82a7,7,0,0,0-6.5,0l-7,4a6,6,0,0,1-5.32,0,1.56,1.56,0,0,1-.93-1.2c0-.42.34-.85.93-1.19l8.06-4.65a2.37,2.37,0,0,0,0-4.43l-.18-.11a7.08,7.08,0,0,0-6.49,0l-15.58,9a6,6,0,0,1-5.31,0l-2.83-1.63a1.56,1.56,0,0,1-.93-1.2c0-.42.34-.85.93-1.19l24.67-14.17a3.74,3.74,0,0,0,2.67-.26,1,1,0,0,0,0-1.93,3.69,3.69,0,0,0-3.33,0c-.7.41-.86,1-.5,1.5L20.1,185.23a2.37,2.37,0,0,0,0,4.43l2.83,1.63a7.08,7.08,0,0,0,6.49,0l15.58-9a6,6,0,0,1,5.31,0l.18.11c.59.34.93.77.93,1.19s-.34.85-.93,1.2l-8.06,4.65a2.38,2.38,0,0,0,0,4.43,7.1,7.1,0,0,0,6.5,0l7-4a5.94,5.94,0,0,1,5.31,0l3.16,2,1.31-.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "ACTIVE-2",
    "data-name": "ACTIVE",
    d: "M67.7,166.81c-3.35,1.54-6.35,6.22-6.64,10.54a6.29,6.29,0,0,0,.91,4.07l4.82,9.15,2.31,1.13c.21-.47,3.59-16.54,3.74-17h0c.36-1.13,2.83-1.84,2.85-2.94C75.76,167.72,71,165.31,67.7,166.81Zm-.42,10.31C66,177.78,65,177,65,175.33a5.13,5.13,0,0,1,2.48-4c1.28-.6,2.26.17,2.21,1.75A5.13,5.13,0,0,1,67.28,177.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.49,192.89a2.48,2.48,0,0,0-2.25,0c-.62.35-.62.93,0,1.29a2.48,2.48,0,0,0,2.25,0C70.11,193.82,70.11,193.24,69.49,192.89Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.93,191.23a7.77,7.77,0,0,0-7.13,0,2.46,2.46,0,0,0,0,4.61,7.82,7.82,0,0,0,7.13,0,2.46,2.46,0,0,0,0-4.61Zm-.42,3.87a7,7,0,0,1-6.29,0,1.64,1.64,0,0,1,0-3.14,7,7,0,0,1,6.29,0,2,2,0,0,1,1.17,1.57A1.93,1.93,0,0,1,71.51,195.1Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.49,192a2.48,2.48,0,0,0-2.25,0c-.62.35-.62.93,0,1.29a2.48,2.48,0,0,0,2.25,0C70.11,193,70.11,192.39,69.49,192Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.93,190.38a7.77,7.77,0,0,0-7.13,0,2.46,2.46,0,0,0,0,4.61,7.82,7.82,0,0,0,7.13,0,2.46,2.46,0,0,0,0-4.61Zm-.42,3.87a7,7,0,0,1-6.29,0,1.64,1.64,0,0,1,0-3.14,7,7,0,0,1,6.29,0,1.64,1.64,0,0,1,0,3.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.23,192.05l-2.63-1.29,0-.07-4.83-9.15a6.47,6.47,0,0,1-.93-4.21c.28-4.34,3.33-9.16,6.78-10.75h0a6.18,6.18,0,0,1,5.8.59A5.36,5.36,0,0,1,76,171.74c0,.71-.78,1.24-1.52,1.74s-1.2.82-1.35,1.28c-.06.19-.69,3.12-1.35,6.23-1.32,6.15-2.27,10.53-2.39,10.81ZM67,190.38l2,1c.31-1.25,1.44-6.51,2.29-10.46.81-3.76,1.31-6.08,1.37-6.28.2-.62.88-1.09,1.55-1.54s1.28-.88,1.29-1.32a4.84,4.84,0,0,0-2.33-4.14,5.64,5.64,0,0,0-5.3-.56h0c-3.31,1.52-6.22,6.15-6.49,10.32a6,6,0,0,0,.86,3.92ZM66.4,177.6a1.46,1.46,0,0,1-.82-.24,2.21,2.21,0,0,1-.81-2,5.35,5.35,0,0,1,2.63-4.26,1.77,1.77,0,0,1,1.77,0,2.17,2.17,0,0,1,.81,2,5.45,5.45,0,0,1-2.59,4.31h0A2.23,2.23,0,0,1,66.4,177.6Zm1.94-6.26a1.73,1.73,0,0,0-.72.18,4.87,4.87,0,0,0-2.34,3.82,1.72,1.72,0,0,0,.58,1.6,1.29,1.29,0,0,0,1.3-.05A4.86,4.86,0,0,0,69.47,173a1.7,1.7,0,0,0-.58-1.53A.94.94,0,0,0,68.34,171.34Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.74,172.43c.07-4-2.46-6-5.73-4.49s-6.35,6.22-6.63,10.53a6.24,6.24,0,0,0,.9,4.08l4.82,9.15,5.51-14.46c.21-.47.39-1,.55-1.43h0A11.59,11.59,0,0,0,75.74,172.43Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.23,192.05l-.31-.15-4.86-9.23a6.53,6.53,0,0,1-.94-4.21c.29-4.34,3.33-9.16,6.79-10.75a4.21,4.21,0,0,1,4.14,0c1.29.85,2,2.51,2,4.7h0a12.1,12.1,0,0,1-.6,3.45c-.16.49-.35,1-.56,1.46Zm2.87-24.36a4.74,4.74,0,0,0-2,.48c-3.31,1.52-6.22,6.15-6.49,10.32a6,6,0,0,0,.86,3.92l4.58,8.67,5.3-13.93a13.73,13.73,0,0,0,.54-1.42,11.42,11.42,0,0,0,.58-3.3c0-2-.59-3.53-1.72-4.26A3,3,0,0,0,72.1,167.69Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3,181.39l-2.46-1.67c-.34-.23-.32-.92.06-1.53h0c.37-.62,1-.93,1.3-.69l1.24.84,2.28-4.64c.32-.64.9-1,1.3-.9h0c.39.14.45.78.13,1.42l-3.42,6.91C69.62,181.35,69.41,181.47,69.3,181.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.39 156.61 44.13 148.95 30.88 156.61 30.88 156.61 30.88 171.91 44.13 179.57 44.13 164.3 57.39 156.61",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.88 171.86 44.13 179.52 44.13 164.25 30.88 156.56 30.88 156.56 30.88 171.86",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.66,156.45l-13.53-7.8-13.48,7.78,0,0h0v.31h0v15.31l13.26,7.65h0l.26.15.27-.15h0l13.12-7.58.14-.07V156.76h0Zm-13.53-7.19,6.23,3.6L37.64,160.2l-6.23-3.59Zm-.26,29.85-12.73-7.35V157.07l12.73,7.34Zm5.66-18.27L44.13,164l-6.23-3.59L50.63,153l6.23,3.6Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.87,164.28l-2.46-1.42a.76.76,0,0,0-.78,0,1,1,0,0,0-.4.86,2.14,2.14,0,0,0,.91,1.72l2.46,1.42a1,1,0,0,0,.45.13.66.66,0,0,0,.33-.09,1,1,0,0,0,.4-.86A2.12,2.12,0,0,0,38.87,164.28Zm.24,2.12c-.07,0-.18,0-.24,0l-2.46-1.42a1.62,1.62,0,0,1-.65-1.26c0-.24.08-.37.14-.4a.23.23,0,0,1,.24,0l.17.1a2,2,0,0,0,.84,1.42l2.1,1.21A.48.48,0,0,1,39.11,166.4Z",
    style: {
      fill: "#111"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.48,102.09l-48,27.7,48,27.71,48-27.71Zm48,27.7-48,27.71v55.4l48-27.7Zm-48,27.71L.5,129.79V185.2l48,27.7Z",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "PURCHASE"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "104.85 69.82 152.84 97.52 152.84 152.93 104.86 180.63 56.87 152.93 56.87 97.52 104.85 69.82",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,153.05l48-27.82m0,0-.12-55.41m.15,55.41,47.55,27.59",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "PURCHASE-2",
    "data-name": "PURCHASE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_7",
    "data-name": 7
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.76,
    cy: 162.08,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.24,161.23c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.14-.08-.14-.2,0-.27A.49.49,0,0,1,92.24,161.23Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.48,160.51c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.57.57,0,0,1,93.48,160.51Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.76,161.23c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,89.76,161.23Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,160.51c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,91,160.51Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92,
    cy: 159.93,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.53,160.51c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.57.57,0,0,1,88.53,160.51Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.53,
    cy: 159.93,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,159.08a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,91,159.08Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.29,159.8c.13.07.13.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,87.29,159.8Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.53,159.08a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,88.53,159.08Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.53,
    cy: 158.5,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.05,159.08a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,86.05,159.08Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.05,
    cy: 158.5,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.53,157.65a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,88.53,157.65Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8,158.36c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,84.8,158.36Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,157.65c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,86,157.65Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.28,156.93a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0c-.14-.08-.14-.2,0-.28A.55.55,0,0,1,87.28,156.93Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.57,157.65c.13.07.13.19,0,.27a.57.57,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,83.57,157.65Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8,156.93a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,84.8,156.93Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,156.22a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,86,156.22Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.33,156.93a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0c-.14-.08-.14-.2,0-.28A.55.55,0,0,1,82.33,156.93Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.57,156.22a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,83.57,156.22Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8,155.5a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,84.8,155.5Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.09,156.22a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,81.09,156.22Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.09,
    cy: 155.64,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 83.33,
    cy: 154.93,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.62,
    cy: 155.64,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.09,154.79a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,81.09,154.79Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.33,154.07a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0c-.14-.08-.14-.2,0-.28A.55.55,0,0,1,82.33,154.07Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.62,154.79a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,78.62,154.79Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.85,154.07a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,79.85,154.07Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.85,
    cy: 153.5,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.38,154.07a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,77.38,154.07Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.62,153.36c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.51.51,0,0,1,78.62,153.36Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.85,152.65c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,79.85,152.65Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.14,153.36c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.49.49,0,0,1,76.14,153.36Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.38,152.65c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,77.38,152.65Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.62,151.93c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.57.57,0,0,1,78.62,151.93Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.89,152.64a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,74.89,152.64Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.13,151.92a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,76.13,151.92Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.37,151.21a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0c-.14-.07-.14-.2,0-.27A.49.49,0,0,1,77.37,151.21Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.89,151.21a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,74.89,151.21Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.13,150.49a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.52,161.83c.14.07.14.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,93.52,161.83Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.76,161.11c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,94.76,161.11Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.72,159.81c.13.07.13.19,0,.27a.57.57,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,94.72,159.81Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,159.09c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,96,159.09Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.19,158.38a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,97.19,158.38Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.43,157.66a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,98.43,157.66Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.67,157a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,99.67,157Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.9,156.23a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,100.9,156.23Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.14,155.52c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.49.49,0,0,1,102.14,155.52Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.38,154.81c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,103.38,154.81Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.62,154.09c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.57.57,0,0,1,104.62,154.09Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.85,153.38c.13.07.13.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,105.85,153.38Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.85,
    cy: 152.8,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.33,152a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0c-.14-.07-.14-.2,0-.27A.49.49,0,0,1,108.33,152Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.57,151.23a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,109.57,151.23Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.8,150.52a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,110.8,150.52Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.8,
    cy: 149.94,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.28,149.09c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.14-.07-.14-.19,0-.27A.49.49,0,0,1,113.28,149.09Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.52,148.38c.13.07.13.19,0,.27a.57.57,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,114.52,148.38Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,159.09a.55.55,0,0,1,.47,0,.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0C92.88,159.29,92.87,159.17,93,159.09Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.72,158.38a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,94.72,158.38Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,157.66c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,96,157.66Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.19,157a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,97.19,157Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.43,156.23a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,98.43,156.23Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.67,155.52c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.51.51,0,0,1,99.67,155.52Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.67,
    cy: 154.94,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.14,154.09c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,102.14,154.09Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.38,153.38c.13.07.13.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,103.38,153.38Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.62,152.66a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,104.62,152.66Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.85,152a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,105.85,152Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.09,151.23a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,107.09,151.23Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.33,150.52a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0c-.14-.07-.14-.2,0-.27A.49.49,0,0,1,108.33,150.52Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.57,149.8a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,109.57,149.8Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.8,149.09c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.49.49,0,0,1,110.8,149.09Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,148.38c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,112,148.38Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.04,
    cy: 147.8,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.77,158.38a.49.49,0,0,1,.47,0,.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0A.14.14,0,0,1,91.77,158.38Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.48,157.66a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,93.48,157.66Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.72,157a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,94.72,157Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,156.23c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,96,156.23Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.96,
    cy: 155.66,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.43,154.81c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,98.43,154.81Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.67,154.09c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.57.57,0,0,1,99.67,154.09Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.9,153.38c.14.07.14.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,100.9,153.38Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.91,
    cy: 152.8,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.38,152a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,103.38,152Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.62,151.23a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,104.62,151.23Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.85,150.52a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,105.85,150.52Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.85,
    cy: 149.94,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.33,149.09c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.14-.07-.14-.19,0-.27A.49.49,0,0,1,108.33,149.09Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.57,148.38c.13.07.13.19,0,.27a.57.57,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,109.57,148.38Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.8,147.66c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,110.8,147.66Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,147c.13.07.13.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,112,147Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.53,157.66a.55.55,0,0,1,.47,0,.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0A.15.15,0,0,1,90.53,157.66Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.24,157a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,92.24,157Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.48,156.23a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,93.48,156.23Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.72,155.52c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.51.51,0,0,1,94.72,155.52Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,154.81c.14.07.14.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,96,154.81Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.19,154.09c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,97.19,154.09Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.43,153.38c.13.07.13.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,98.43,153.38Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.67,152.66a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,99.67,152.66Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.9,152c.14.07.14.2,0,.27a.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,100.9,152Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.91,
    cy: 151.37,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.38,150.52a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,103.38,150.52Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.62,149.8a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,104.62,149.8Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.85,149.09c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.49.49,0,0,1,105.85,149.09Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.09,148.38c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,107.09,148.38Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.33,147.66c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.14-.07-.14-.19,0-.27A.55.55,0,0,1,108.33,147.66Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.57,147c.13.07.13.19,0,.27a.51.51,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,109.57,147Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.8,146.23a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,110.8,146.23Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.29,157a.51.51,0,0,1,.48,0,.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0C89.16,157.15,89.16,157,89.29,157Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,156.23a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,91,156.23Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.01,
    cy: 155.66,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 93.24,
    cy: 154.94,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.72,154.09c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.57.57,0,0,1,94.72,154.09Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,153.38c.14.07.14.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,96,153.38Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.19,152.66a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,97.19,152.66Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.43,152a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,98.43,152Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.43,
    cy: 151.37,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.9,150.52c.14.07.14.2,0,.27a.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,100.9,150.52Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.91,
    cy: 149.94,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.38,149.09c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.49.49,0,0,1,103.38,149.09Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.62,148.38c.13.07.13.19,0,.27a.57.57,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,104.62,148.38Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.85,147.66c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,105.85,147.66Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.09,147c.13.07.13.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,107.09,147Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.33,146.23a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0c-.14-.08-.14-.2,0-.28A.55.55,0,0,1,108.33,146.23Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.57,145.52a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,109.57,145.52Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,156.23a.51.51,0,0,1,.48,0c.13.07.13.19,0,.27a.49.49,0,0,1-.47,0C87.91,156.43,87.91,156.3,88,156.23Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.76,155.51a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,89.76,155.51Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,154.8c.14.07.14.2,0,.27a.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,91,154.8Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92,
    cy: 154.22,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 93.23,
    cy: 153.51,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.71,152.65a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,94.71,152.65Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.94,151.94c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.49.49,0,0,1,95.94,151.94Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.18,151.23c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,97.18,151.23Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.42,150.51c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.14-.07-.14-.19,0-.27A.55.55,0,0,1,98.42,150.51Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.66,149.8c.13.07.13.19,0,.27a.51.51,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,99.66,149.8Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.89,149.08a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,100.89,149.08Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.13,148.37a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,102.13,148.37Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.13,
    cy: 147.79,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.61,146.94a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,104.61,146.94Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.84,146.22a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,105.84,146.22Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.08,145.51c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,107.08,145.51Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.32,144.8c.13.07.13.19,0,.27a.57.57,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,108.32,144.8Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.81,155.51a.55.55,0,0,1,.47,0,.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0A.15.15,0,0,1,86.81,155.51Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.52,154.8a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,88.52,154.8Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.76,154.08a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,89.76,154.08Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.76,
    cy: 153.51,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.23,152.65a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,92.23,152.65Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.47,151.94c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.49.49,0,0,1,93.47,151.94Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.47,
    cy: 151.36,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.94,150.51c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,95.94,150.51Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.18,149.8c.13.07.13.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,97.18,149.8Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.42,149.08a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0c-.14-.08-.14-.2,0-.28A.55.55,0,0,1,98.42,149.08Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.66,148.37a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,99.66,148.37Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.89,147.65a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,100.89,147.65Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.13,146.94a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,102.13,146.94Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.37,146.22a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0c-.14-.08-.14-.2,0-.28A.55.55,0,0,1,103.37,146.22Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.13,145.51a.57.57,0,0,1,.48,0c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.84,144.8c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.57,154.8a.49.49,0,0,1,.47,0,.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0A.14.14,0,0,1,85.57,154.8Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.28,154.08a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,87.28,154.08Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.52,153.37a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,88.52,153.37Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.76,152.65a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,89.76,152.65Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,151.94c.14.08.14.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.76,151.23a.49.49,0,0,1,.47,0c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,150.51a.55.55,0,0,1,.47,0c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.23,149.8a.51.51,0,0,1,.48,0c.13.07.13.19,0,.27a.51.51,0,0,1-.48,0c-.13-.08-.13-.2,0-.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.94,149.08a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.33,154.08a.57.57,0,0,1,.48,0,.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0A.15.15,0,0,1,84.33,154.08Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.81,
    cy: 153.51,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.81,152.65a.55.55,0,0,1,.47,0,.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1,153.37a.49.49,0,0,1,.47,0,.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0C83,153.57,83,153.45,83.1,153.37Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.33,152.93a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.09,152.21a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,168.28c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.49.49,0,0,1,122,168.28Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.25,167.57c.13.07.13.19,0,.27a.57.57,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,123.25,167.57Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.48,166.85c.14.08.14.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,124.48,166.85Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.72,166.14c.13.07.13.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,125.72,166.14Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,165.42a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,127,165.42Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.2,164.71a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,128.2,164.71Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.43,164a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,129.43,164Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.3,
    cy: 168.42,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.54,
    cy: 167.7,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,166.85c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,122,166.85Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.25,166.14c.13.07.13.19,0,.27a.51.51,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,123.25,166.14Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.48,165.42c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,124.48,165.42Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.72,164.71a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,125.72,164.71Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,164a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,127,164Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.2,163.28a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,128.2,163.28Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.43,162.56a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,129.43,162.56Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.3,167.57c.13.07.13.19,0,.27a.57.57,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,118.3,167.57Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.54,166.85c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.57.57,0,0,1,119.54,166.85Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.77,166.14c.13.07.13.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,120.77,166.14Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,165.42a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,122,165.42Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.25,164.71a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,123.25,164.71Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.48,164c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,124.48,164Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 125.49,
    cy: 163.42,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,162.56a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,127,162.56Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.2,161.85c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.51.51,0,0,1,128.2,161.85Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.06,166.85c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,117.06,166.85Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 118.06,
    cy: 166.27,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.54,165.42a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,119.54,165.42Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.77,164.71a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,120.77,164.71Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,164a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,122,164Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.25,163.28a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,123.25,163.28Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.48,162.56c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,124.48,162.56Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.72,161.85c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.49.49,0,0,1,125.72,161.85Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,161.14c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,127,161.14Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.82,166.14c.13.07.13.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,115.82,166.14Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.06,165.42a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,117.06,165.42Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.3,164.71a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,118.3,164.71Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.54,164a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,119.54,164Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.54,
    cy: 163.42,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,162.56a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,122,162.56Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.01,
    cy: 161.99,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.48,161.14c.14.07.14.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,124.48,161.14Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.72,160.42c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.57,165.41c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,114.57,165.41Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.81,164.7c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.49.49,0,0,1,115.81,164.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.05,164c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,117.05,164Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.29,163.27c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.57.57,0,0,1,118.29,163.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.29,
    cy: 162.69,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.76,161.84a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,120.76,161.84Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,161.13a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,122,161.13Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 123,
    cy: 160.55,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.47,160a.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.34,164.7c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.51.51,0,0,1,113.34,164.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.57,164c.14.07.14.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,114.57,164Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.81,163.27c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,115.81,163.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.05,162.56c.13.07.13.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,117.05,162.56Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.29,161.84a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,118.29,161.84Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.52,161.13c.14.07.14.2,0,.27a.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,119.52,161.13Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.76,160.41a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,120.76,160.41Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,159.7a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,122,159.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.1,164c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,112.1,164Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.34,163.27c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.57.57,0,0,1,113.34,163.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.57,162.56c.14.07.14.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,114.57,162.56Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.81,161.84a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,115.81,161.84Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.05,161.13a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,117.05,161.13Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 118.05,
    cy: 160.55,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.29,
    cy: 159.84,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.76,159a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,120.76,159Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.1,162.56c.13.07.13.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,112.1,162.56Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.34,161.84a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,113.34,161.84Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.34,
    cy: 161.26,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.81,160.41a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,115.81,160.41Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.05,159.7a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,117.05,159.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.29,159a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,118.29,159Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.29,
    cy: 158.41,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.53,
    cy: 157.69,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,156.84c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,122,156.84Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.24,156.13a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,123.24,156.13Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.1,161.13a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,112.1,161.13Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.34,160.41a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,113.34,160.41Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.57,159.7c.14.07.14.2,0,.27a.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,114.57,159.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.81,159a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,115.81,159Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.05,158.27c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,117.05,158.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.29,157.56c.13.07.13.19,0,.27a.57.57,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,118.29,157.56Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.52,156.84c.14.08.14.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,119.52,156.84Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.76,156.13a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,120.76,156.13Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.76,
    cy: 155.55,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.63,161.13a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,109.63,161.13Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.86,160.41a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,110.86,160.41Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.1,159.7a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,112.1,159.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.34,159a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,113.34,159Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.57,158.27c.14.08.14.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,114.57,158.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.58,
    cy: 157.69,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.05,156.84c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,117.05,156.84Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.29,156.13a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,118.29,156.13Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.52,155.41c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,119.52,155.41Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.53,
    cy: 154.84,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,154.26a.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.91,
    cy: 161.26,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.39,160.41a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,108.39,160.41Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.63,159.7a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,109.63,159.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.86,159a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,110.86,159Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.1,158.27c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,112.1,158.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.34,157.56c.13.07.13.19,0,.27a.57.57,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,113.34,157.56Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.34,
    cy: 156.98,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.81,156.13a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,115.81,156.13Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.05,155.41a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,117.05,155.41Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.29,154.7a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,118.29,154.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.52,154c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,119.52,154Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 105.68,
    cy: 160.55,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.15,159.7a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,107.15,159.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.39,159a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,108.39,159Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.63,158.27c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.57.57,0,0,1,109.63,158.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.86,157.56c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,110.86,157.56Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.86,
    cy: 156.98,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.34,156.13a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,113.34,156.13Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.34,
    cy: 155.55,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.81,154.7a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,115.81,154.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.05,154a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,117.05,154Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.29,153.27c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.51.51,0,0,1,118.29,153.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.66,159.69c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,104.66,159.69Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.9,159a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,105.9,159Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.14,158.26a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,107.14,158.26Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.38,157.55a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,108.38,157.55Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.61,156.83c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,109.61,156.83Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.85,156.12c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.49.49,0,0,1,110.85,156.12Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.09,155.41c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,112.09,155.41Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.33,154.69c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.57.57,0,0,1,113.33,154.69Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.56,154c.13.07.13.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,114.56,154Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.56,
    cy: 153.4,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.8,
    cy: 152.68,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.28,151.83a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28.57.57,0,0,1,.48,0Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.43,159a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,103.43,159Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.66,158.26c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,104.66,158.26Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 105.67,
    cy: 157.69,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.9,
    cy: 156.97,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.38,156.12c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.51.51,0,0,1,108.38,156.12Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.61,155.41c.14.07.14.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,109.61,155.41Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.85,154.69c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,110.85,154.69Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.09,154c.13.07.13.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,112.09,154Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.33,153.26a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,113.33,153.26Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.56,152.55a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,114.56,152.55Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.8,151.83a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,115.8,151.83Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,151.12a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,117,151.12Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.28,150.68a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28.57.57,0,0,1,.48,0Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.19,158.26a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,102.19,158.26Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.43,157.55a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,103.43,157.55Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.66,156.83c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,104.66,156.83Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.9,156.12c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.49.49,0,0,1,105.9,156.12Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.14,155.41c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,107.14,155.41Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.38,154.69c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.57.57,0,0,1,108.38,154.69Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.61,154c.14.07.14.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,109.61,154Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.85,153.26a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,110.85,153.26Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.85,
    cy: 152.68,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.33,151.83a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,113.33,151.83Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.56,151.12a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,114.56,151.12Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.8,150.4a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,115.8,150.4Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,149.69c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.49.49,0,0,1,117,149.69Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.53,160.41a.49.49,0,0,1,.47,0c.13.07.13.19,0,.27a.49.49,0,0,1-.47,0A.14.14,0,0,1,95.53,160.41Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.24,159.69a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,97.24,159.69Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.48,159a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,98.48,159Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.48,
    cy: 158.4,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,157.55a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,101,157.55Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.19,156.83a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,102.19,156.83Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.19,
    cy: 156.26,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.66,155.41c.14.07.14.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,104.66,155.41Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.9,154.69c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,105.9,154.69Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.14,154c.13.07.13.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,107.14,154Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.38,153.26a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,108.38,153.26Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.61,152.55c.14.07.14.2,0,.27a.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,109.61,152.55Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.85,151.83a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,110.85,151.83Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.85,
    cy: 151.26,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.09,
    cy: 150.54,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.33,
    cy: 149.83,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.8,149c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,115.8,149Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.76,147.67a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,115.76,147.67Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.76,
    cy: 147.09,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.24,146.24a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,118.24,146.24Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.24,
    cy: 145.66,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.48,
    cy: 144.95,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,144.1c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,122,144.1Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.19,143.38c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.57.57,0,0,1,123.19,143.38Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.05,147a.55.55,0,0,1,.47,0c.14.08.14.2,0,.28a.57.57,0,0,1-.48,0A.15.15,0,0,1,114.05,147Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.76,146.24a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,115.76,146.24Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,145.52a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,117,145.52Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.24,144.81c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.51.51,0,0,1,118.24,144.81Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.48,144.1c.13.07.13.19,0,.27a.57.57,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,119.48,144.1Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.71,143.38c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,120.71,143.38Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,142.67c.13.07.13.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,122,142.67Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.81,146.24a.51.51,0,0,1,.48,0,.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0A.14.14,0,0,1,112.81,146.24Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.53,145.52a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,114.53,145.52Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.53,
    cy: 144.95,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,144.1c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,117,144.1Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.24,143.38c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.57.57,0,0,1,118.24,143.38Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.48,142.67c.13.07.13.19,0,.27a.51.51,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,119.48,142.67Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.48,
    cy: 142.09,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.58,145.52a.55.55,0,0,1,.47,0,.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0A.15.15,0,0,1,111.58,145.52Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.29,144.81c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.14-.07-.14-.19,0-.27A.49.49,0,0,1,113.29,144.81Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.53,144.1c.13.07.13.19,0,.27a.57.57,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,114.53,144.1Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.76,143.38c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,115.76,143.38Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,142.67c.13.07.13.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,117,142.67Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 118,
    cy: 142.09,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.34,144.81a.49.49,0,0,1,.47,0c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0C110.21,145,110.21,144.89,110.34,144.81Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.05,144.1c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,112.05,144.1Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.29,143.38c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.14-.07-.14-.19,0-.27A.55.55,0,0,1,113.29,143.38Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.53,142.67c.13.07.13.19,0,.27a.51.51,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,114.53,142.67Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.29,142a.55.55,0,0,1,.47,0,.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.09,144.09a.49.49,0,0,1,.47,0c.13.07.14.2,0,.27a.49.49,0,0,1-.47,0A.14.14,0,0,1,109.09,144.09Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.8,143.37a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.29,149.26a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28.55.55,0,0,1,.47,0c.14.08.14.2,0,.28Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.57,148.27a.51.51,0,0,1,.48,0,.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0A.14.14,0,0,1,116.57,148.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.29,147.55a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,118.29,147.55Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.52,146.84a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,119.52,146.84Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.76,146.12a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,120.76,146.12Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.76,
    cy: 145.55,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.24,144.7c.13.07.13.19,0,.27a.57.57,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,123.24,144.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.12,146.2a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,81.12,146.2Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.35,145.76a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27a.49.49,0,0,1,.47,0c.13.08.13.2,0,.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.59,145.05a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27a.49.49,0,0,1,.47,0Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.88,145.49c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.49.49,0,0,1,79.88,145.49Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.12,144.78c.13.07.13.19,0,.27a.57.57,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,81.12,144.78Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.35,144.06c.14.08.14.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,82.35,144.06Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.59,143.35c.13.07.13.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,83.59,143.35Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.64,144.78c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,78.64,144.78Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.88,144.06c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,79.88,144.06Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.12,143.35c.13.07.13.19,0,.27a.51.51,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,81.12,143.35Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.35,142.63c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.41,
    cy: 143.48,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.88,142.63a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.56,138.57h0l0,0-13.27-7.71a2.78,2.78,0,0,0-2.64.08L75.74,148.1l-.15.12a1.93,1.93,0,0,0,.29,3.14h0l0,0,13.27,7.69A2.73,2.73,0,0,0,91.8,159l29.74-17.15.16-.11A1.88,1.88,0,0,0,121.56,138.57Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.59,138.51l0,0h0l0,0,0,0,0,0-13.28-7.71a2.84,2.84,0,0,0-2.7.08L75.7,148.05l-.15.11a1.89,1.89,0,0,0-.7,1.63,2,2,0,0,0,1,1.63h0l0,0,13.28,7.69a2.74,2.74,0,0,0,1.25.3,2.84,2.84,0,0,0,1.41-.38l29.74-17.15.16-.12a1.88,1.88,0,0,0,.83-1.64A1.94,1.94,0,0,0,121.59,138.51Zm-30,17a5.87,5.87,0,0,1,.09,2.5,1.58,1.58,0,0,1-1.14.94,2.75,2.75,0,0,1-1.34-.29l-13.28-7.69,0,0h0a1.87,1.87,0,0,1-.87-1.1v0a1.75,1.75,0,0,1,.66-1.51l.13-.11L105.63,131a3,3,0,0,1,.52-.23,2.79,2.79,0,0,1,2.33.49l.25.19a.25.25,0,0,1,0,.07Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.18,156.68l-.44.26c-.13.07-.24,0-.24-.18h0a.58.58,0,0,1,.24-.45l.44-.25c.13-.08.24,0,.24.17h0A.55.55,0,0,1,95.18,156.68Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.74,156.32a.55.55,0,0,0-.24.44.31.31,0,0,0,0,.11l.06,0,.45-.26a.54.54,0,0,0,.23-.45.31.31,0,0,0,0-.1l-.07,0Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5,156.91v0a.37.37,0,0,1,0-.12.59.59,0,0,1,.25-.47h0l.45-.26.07,0h0v0a.5.5,0,0,1,0,.12.57.57,0,0,1-.26.48l-.44.26-.07,0Zm.25-.56a.51.51,0,0,0-.21.41.15.15,0,0,0,0,.07h0l.45-.26a.53.53,0,0,0,.22-.42.13.13,0,0,0,0-.06h0Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.39,156.84h0c-.13.08-.24,0-.24-.17h0a.55.55,0,0,1,.24-.45h0c.13-.08.23,0,.23.18h0A.54.54,0,0,1,95.39,156.84Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.29,156.91a.12.12,0,0,1-.08,0,.25.25,0,0,1-.1-.22.62.62,0,0,1,.25-.49.21.21,0,0,1,.2,0,.27.27,0,0,1,.1.23.59.59,0,0,1-.25.48h0A.27.27,0,0,1,95.29,156.91Zm.19-.68a.09.09,0,0,0-.07,0,.5.5,0,0,0-.22.41.16.16,0,0,0,.06.15.11.11,0,0,0,.11,0h0a.55.55,0,0,0,.21-.41c0-.08,0-.14-.06-.16Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.16,156.67a.57.57,0,0,1,.23-.45.16.16,0,0,1,.15,0h0l-.17-.12v0h0s-.08,0-.14,0a.58.58,0,0,0-.24.45.22.22,0,0,0,.07.18h0l.18.14A.24.24,0,0,1,95.16,156.67Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.19,156.88l-.18-.13v0h0a.27.27,0,0,1-.08-.21.6.6,0,0,1,.26-.48.17.17,0,0,1,.18,0l0,0a0,0,0,0,1,0,0l.19.13,0,.07,0,0a.14.14,0,0,0-.11,0,.52.52,0,0,0-.21.41.17.17,0,0,0,0,.14Zm-.14-.21h0l.06,0v-.05a.59.59,0,0,1,.25-.48l0,0-.06,0h0l0,0s0,0-.1,0a.52.52,0,0,0-.21.41c0,.07,0,.12,0,.14Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.07,156.19a.54.54,0,0,1,.23-.45l1.34-.78a.17.17,0,0,1,.17,0l-.23-.16h0a.13.13,0,0,0-.17,0l-1.34.78a.55.55,0,0,0-.24.45.22.22,0,0,0,0,.17h0l.26.18A.2.2,0,0,1,96.07,156.19Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.11,156.4l-.27-.19a.25.25,0,0,1-.07-.2.62.62,0,0,1,.25-.49l1.35-.77a.17.17,0,0,1,.22,0l.24.16h0l0,.07h0a.09.09,0,0,0-.11,0l-1.35.77a.55.55,0,0,0-.21.42.17.17,0,0,0,0,.14Zm1.37-1.6a.11.11,0,0,0-.07,0l-1.34.77a.53.53,0,0,0-.22.42c0,.07,0,.11,0,.13h0l.13.09v-.05a.61.61,0,0,1,.25-.49l1.34-.77,0,0-.12-.09Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.64,155.59l-1.34.77c-.13.08-.23,0-.23-.17h0a.54.54,0,0,1,.23-.45l1.34-.78c.13-.07.24,0,.24.18h0A.58.58,0,0,1,97.64,155.59Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.21,156.43a.11.11,0,0,1-.08,0,.24.24,0,0,1-.1-.22.61.61,0,0,1,.25-.49l1.34-.77a.21.21,0,0,1,.2,0,.27.27,0,0,1,.1.23.59.59,0,0,1-.25.48l-1.35.78A.23.23,0,0,1,96.21,156.43ZM97.74,155l-.07,0-1.35.77a.55.55,0,0,0-.21.42.16.16,0,0,0,.06.15.14.14,0,0,0,.11,0l1.34-.78a.5.5,0,0,0,.22-.41q0-.12-.06-.15Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.25,154.92a.54.54,0,0,1,.23-.45l1.34-.78a.17.17,0,0,1,.17,0l-.23-.16h0a.13.13,0,0,0-.17,0l-1.34.78a.55.55,0,0,0-.24.45.22.22,0,0,0,.05.17h0l.26.18A.2.2,0,0,1,98.25,154.92Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.29,155.13l-.27-.19a.25.25,0,0,1-.07-.2.62.62,0,0,1,.25-.49l1.35-.77a.17.17,0,0,1,.22,0l.24.16h0l-.05.07h0a.09.09,0,0,0-.11,0l-1.35.77a.55.55,0,0,0-.21.42.17.17,0,0,0,0,.14Zm1.37-1.6a.1.1,0,0,0-.07,0l-1.34.77a.53.53,0,0,0-.22.42c0,.07,0,.11,0,.13h0l.13.09v-.05a.61.61,0,0,1,.25-.49l1.34-.77,0,0-.12-.09Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.82,154.32l-1.34.77c-.13.08-.23,0-.23-.17h0a.54.54,0,0,1,.23-.45l1.34-.78c.13-.07.24,0,.24.18h0A.58.58,0,0,1,99.82,154.32Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.39,155.16a.11.11,0,0,1-.08,0,.24.24,0,0,1-.1-.22.61.61,0,0,1,.25-.49l1.34-.77a.21.21,0,0,1,.2,0,.27.27,0,0,1,.1.23.59.59,0,0,1-.25.48l-1.35.78A.23.23,0,0,1,98.39,155.16Zm1.53-1.45-.07,0-1.35.77a.55.55,0,0,0-.21.42.16.16,0,0,0,.06.15.14.14,0,0,0,.11,0l1.34-.78a.5.5,0,0,0,.22-.41q0-.12-.06-.15Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.72,148.35l29.85-17.2a2.78,2.78,0,0,1,2.64-.08l13.27,7.7a1.14,1.14,0,0,1,.06,1.94L91.8,157.86a2.68,2.68,0,0,1-2.59.08l-13.27-7.68C75,149.69,75,148.8,75.72,148.35Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.45,158a2.85,2.85,0,0,1-1.24-.29l-13.27-7.69a1.34,1.34,0,0,1-.75-1.06,1.08,1.08,0,0,1,.52-.92h0l29.85-17.2a2.8,2.8,0,0,1,2.68-.08l13.27,7.7a1.39,1.39,0,0,1,.6,1.16,1,1,0,0,1-.53.85L91.84,157.66A2.76,2.76,0,0,1,90.45,158Zm-14.69-9.89a1,1,0,0,0-.48.84,1.26,1.26,0,0,0,.7,1l13.27,7.69a2.68,2.68,0,0,0,2.55-.09l29.74-17.15a1,1,0,0,0,.5-.78,1.31,1.31,0,0,0-.56-1.09l-13.27-7.7a2.75,2.75,0,0,0-2.6.08Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.31,139.56l-12.86-7.4a1.94,1.94,0,0,0-1.84.06l-27.9,16.1c-.47.32-.51.94.16,1.34l12.85,7.39a1.9,1.9,0,0,0,1.82-.06l27.81-16.07A.77.77,0,0,0,119.31,139.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.9,134.42a.29.29,0,0,1-.16,0h0a.13.13,0,0,1-.07-.12.16.16,0,0,1,.1-.14.41.41,0,0,1,.37,0h0a.14.14,0,0,1,.08.12.17.17,0,0,1-.11.14A.37.37,0,0,1,111.9,134.42Zm.06-.28a.33.33,0,0,0-.17,0,.1.1,0,0,0-.06.07.07.07,0,0,0,0,.05h0a.33.33,0,0,0,.29,0,.1.1,0,0,0,.06-.07.09.09,0,0,0,0-.05h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.34,136.39a.47.47,0,0,1-.17,0l-3-1.69a.15.15,0,0,1-.08-.12.18.18,0,0,1,.11-.15.4.4,0,0,1,.37,0l2.95,1.69a.14.14,0,0,1,.08.12.19.19,0,0,1-.1.14A.39.39,0,0,1,115.34,136.39Zm-2.88-2a.43.43,0,0,0-.17,0s-.06,0-.06.08a0,0,0,0,0,0,0l3,1.69a.3.3,0,0,0,.29,0s.06,0,.06-.07,0,0,0-.05l-3-1.69A.24.24,0,0,0,112.46,134.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.23,153.14a.78.78,0,0,0-.83,0h0c-.8.39-1.49,2.76-1.89,4.49a1.72,1.72,0,0,1-.57,1h0l4.8-2.83A4.64,4.64,0,0,0,111.23,153.14Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.55,151.84c-1.21-1.65-1.89-5-2.51-8.15-.69-3.5-1.73-8.29-4-9.54a1.91,1.91,0,0,0-2-.16l-8.83,5.1a2,2,0,0,1,1.87.2c1.09.6,1.86,2,2.48,3.69h0a38.23,38.23,0,0,1,1.48,5.82c.69,3.5,1.45,7.19,2.92,8.61a7.15,7.15,0,0,0,2.11,1.22s1.93,1.11,2.41-1c.4-1.73,1-4.17,2-4.57l2-1.17Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.22,140.12h0L93,139.5c-1.18-.64-1.55-.85-2.33-.55a2.07,2.07,0,0,1-1.58-.15L87,137.57l-8.87,5,2.12,1.23a2.07,2.07,0,0,0,1.58.15c.78-.3,1.15-.09,2.33.55l1.18.63h0l3.26,1.88c.4.23.79.48,1.17.74.65.44,2.2,1,3-2.86a16.91,16.91,0,0,1,1.45-4.81Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.11,139.24a2.18,2.18,0,0,0-1.51-.33,1.51,1.51,0,0,0-.36.18,3.84,3.84,0,0,0-1,1h0a16.91,16.91,0,0,0-1.45,4.81c-.37,1.88-.93,2.71-1.48,3h0l8.29-5C99,141.24,98.2,139.83,97.11,139.24Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.84,159.91a6.52,6.52,0,0,1-3.16-4.7c-.51-2.63-1.09-6.37-2.49-7.18a.78.78,0,0,0-.72-.07h0l-6.88,3.92-2.19,1.24h0a.78.78,0,0,1,.83,0c1.4.81,2,4.55,2.49,7.18a6.52,6.52,0,0,0,3.16,4.7l3.6,2.07,9-5.1Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.89,159.83a6.55,6.55,0,0,1-3.12-4.64l-.15-.8c-.48-2.54-1.08-5.69-2.38-6.45a.86.86,0,0,0-.82-.06l-6.81,3.87c-1.23-1.7-1.92-5.23-2.48-8.08s-1.61-8.27-4.06-9.6a2,2,0,0,0-2-.16l-8.7,5-.13.07h0a3.91,3.91,0,0,0-1,1L93,139.38c-1.16-.62-1.55-.83-2.36-.52a1.94,1.94,0,0,1-1.5-.15L87,137.46l-9.07,5.15,2.27,1.31a2.12,2.12,0,0,0,1.67.16c.72-.28,1.06-.09,2.2.52l1.23.66,3.29,1.88c.41.24.8.5,1.17.74a1.67,1.67,0,0,0,1,.33,1.3,1.3,0,0,0,.49-.1,1.72,1.72,0,0,0,.44-.3l7.87-4.73a38.54,38.54,0,0,1,1.46,5.74c.62,3.2,1.4,7.17,2.94,8.66a7,7,0,0,0,2.13,1.23,2.43,2.43,0,0,0,1.11.31,1.44,1.44,0,0,0,.57-.11,2.56,2.56,0,0,0,.25-.16l4.71-2.77c.32,1.12.56,2.4.78,3.55q.07.42.15.81a6.65,6.65,0,0,0,3.21,4.76l3.65,2.11,9.16-5.22Zm-30.6-20.66a1.88,1.88,0,0,1,1.77.21c.92.5,1.68,1.62,2.4,3.51L92,147.36a6.82,6.82,0,0,0,.84-2.4,17.41,17.41,0,0,1,1.45-4.79l0-.07,0-.08h0A3.73,3.73,0,0,1,95.29,139.17Zm-5.42,8.55c-.37-.25-.76-.51-1.17-.75l-3.32-1.89h0l-1.21-.66c-1.16-.62-1.55-.83-2.36-.52a1.94,1.94,0,0,1-1.5-.15l-2-1.14L87,137.68l2.07,1.2a2.12,2.12,0,0,0,1.67.16c.72-.28,1.06-.09,2.2.52l1.12.6a18,18,0,0,0-1.39,4.7c-.31,1.61-.8,2.6-1.43,2.95l-.09.07h0A1.37,1.37,0,0,1,89.87,147.72Zm17.78,11a2,2,0,0,1-1.51-.19,7.26,7.26,0,0,1-2.08-1.2c-1.5-1.45-2.27-5.39-2.89-8.56A39.94,39.94,0,0,0,99.71,143h0l0-.07c-.75-2-1.55-3.21-2.53-3.74a2.66,2.66,0,0,0-1.2-.37l8.15-4.7a1.84,1.84,0,0,1,1.87.16c2.36,1.29,3.4,6.61,4,9.47s1.24,6.37,2.49,8.12l-2,1.12c-.92.38-1.52,2.41-2,4.42,0,.07,0,.15,0,.22s-.06.23-.07.25,0,.08,0,.12l0,.06a.54.54,0,0,1,0,.11.08.08,0,0,1,0,0,2.06,2.06,0,0,1-.11.18l-.1.12-.06.07,0,0A1,1,0,0,1,107.65,158.73Zm5-2.94-4.26,2.51h0l0-.07.06-.1,0-.08s0-.08,0-.12a.25.25,0,0,0,0-.07l.06-.21c.58-2.53,1.25-4.15,1.84-4.43l.06,0,0,0,0,0h0l.09,0h.15l.09,0h0l.1,0a.2.2,0,0,0,.08,0h0l.11.07,0,0,.08.06,0,0,.06.05,0,.06,0,0,.07.08,0,0a.86.86,0,0,1,.07.1l0,0,.08.13h0A8.11,8.11,0,0,1,112.63,155.79Zm4.3,9.14a6.46,6.46,0,0,1-3.12-4.63l-.15-.8c-.22-1.18-.47-2.48-.8-3.62h0l0-.07a6.64,6.64,0,0,0-1.1-2.37h0l-.1-.11h0l-.1-.09h0l-.1-.08h0l-.12-.08-.15-.07h0l-.12,0h0l8.55-4.88a.69.69,0,0,1,.65.06c1.22.71,1.81,3.82,2.28,6.31q.07.42.15.81A6.69,6.69,0,0,0,125.8,160l3.44,2-8.76,5Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "ACTIVE-3",
    "data-name": "ACTIVE",
    d: "M93,140.05l1,.56a20.5,20.5,0,0,0-1.21,4.33c-.76,3.85-2.31,3.3-3,2.86-.38-.26-.77-.51-1.17-.74l-3.26-1.88h0l-1.19-.63c-1.18-.64-1.55-.85-2.33-.55a2.07,2.07,0,0,1-1.58-.15l-1.68-1L87,138.12l2.11,1.23a2.07,2.07,0,0,0,1.59.16C91.47,139.21,91.84,139.42,93,140.05Zm12.69-5.15a1.91,1.91,0,0,0-2-.17L96.44,139a3,3,0,0,1,.66.28c1.1.6,1.87,2,2.49,3.69a40.73,40.73,0,0,1,1.48,5.82c.68,3.5,1.44,7.19,2.91,8.61a7.15,7.15,0,0,0,2.12,1.22s1.4.81,2.11-.28a19.16,19.16,0,0,1,1-3.23c.34-1,.77-1.86,1.31-2.08l1.46-.83c-1-1.75-1.66-4.8-2.23-7.72C109,140.93,108,136.14,105.71,134.9Zm8,25.41a6.48,6.48,0,0,0,3.17,4.7l3.59,2.08,8-4.54-2.94-1.69a6.5,6.5,0,0,1-3.17-4.7c-.51-2.63-1.08-6.38-2.48-7.18a.75.75,0,0,0-.73-.07h0l-6.88,3.92-.8.45C112.67,154.32,113.21,157.82,113.7,160.31Z",
    style: {
      fill: "#fff"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "121.22 161.41 118.43 163.02 118 162.76 120.79 161.15 121.22 161.41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "118.03 163.26 117.19 163.74 116.76 163.49 117.6 163 118.03 163.26"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "121.99 161.87 117.97 164.19 117.54 163.94 121.56 161.62 121.99 161.87"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "120.36 163.7 118.72 164.64 118.29 164.39 119.92 163.45 120.36 163.7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.62,165.48a.5.5,0,0,1-.51,0c-.18-.1-.21-.21-.06-.3a.54.54,0,0,1,.52,0C120.74,165.29,120.78,165.39,120.62,165.48Zm-.51-.29c-.12.07-.09.15,0,.23a.39.39,0,0,0,.4,0c.12-.07.09-.15,0-.23A.39.39,0,0,0,120.11,165.19Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121.13,165.18a.48.48,0,0,1-.51,0c-.17-.1-.21-.2-.05-.29a.5.5,0,0,1,.51,0C121.26,165,121.29,165.1,121.13,165.18Zm-.51-.29c-.12.07-.08.15.06.23a.39.39,0,0,0,.4,0c.12-.07.09-.15-.06-.23A.39.39,0,0,0,120.62,164.89Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M121.64,164.89a.5.5,0,0,1-.51,0c-.17-.1-.21-.21,0-.3a.5.5,0,0,1,.51,0C121.77,164.7,121.8,164.8,121.64,164.89Zm-.51-.3c-.12.07-.08.16.06.24a.39.39,0,0,0,.4,0c.12-.07.09-.15,0-.23A.39.39,0,0,0,121.13,164.59Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M122.16,164.59a.49.49,0,0,1-.52,0c-.17-.1-.2-.2,0-.29a.5.5,0,0,1,.51,0C122.28,164.4,122.31,164.5,122.16,164.59Zm-.51-.29c-.12.07-.09.15,0,.23a.39.39,0,0,0,.4,0c.12-.07.09-.15,0-.23A.39.39,0,0,0,121.65,164.3Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.67,164.3a.5.5,0,0,1-.51,0c-.18-.1-.21-.21-.06-.3a.5.5,0,0,1,.51,0C122.79,164.11,122.82,164.21,122.67,164.3Zm-.51-.3c-.12.07-.09.15,0,.24a.39.39,0,0,0,.4,0c.12-.07.09-.15,0-.24A.39.39,0,0,0,122.16,164Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M123.18,164a.5.5,0,0,1-.51,0c-.18-.1-.21-.2-.06-.29a.51.51,0,0,1,.52,0C123.3,163.81,123.33,163.91,123.18,164Zm-.51-.29c-.12.07-.09.15,0,.23a.39.39,0,0,0,.4,0c.12-.07.09-.15-.05-.23A.39.39,0,0,0,122.67,163.71Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M123.92,163.57a.48.48,0,0,1-.51,0c-.18-.1-.21-.2,0-.29a.5.5,0,0,1,.51,0C124.05,163.38,124.08,163.48,123.92,163.57Zm-.51-.29c-.12.07-.08.15,0,.23a.41.41,0,0,0,.41,0c.12-.07.09-.15-.06-.23A.39.39,0,0,0,123.41,163.28Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M124.43,163.28a.5.5,0,0,1-.51,0c-.17-.1-.21-.21,0-.3a.5.5,0,0,1,.51,0C124.56,163.09,124.59,163.19,124.43,163.28Zm-.51-.3c-.12.07-.08.16.06.24a.39.39,0,0,0,.4,0c.12-.07.09-.15-.06-.23A.37.37,0,0,0,123.92,163Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M124.94,163a.48.48,0,0,1-.51,0c-.17-.1-.21-.2-.05-.29a.5.5,0,0,1,.51,0C125.07,162.79,125.1,162.89,124.94,163Zm-.51-.29c-.12.07-.08.15.06.23a.39.39,0,0,0,.4,0c.12-.07.09-.15,0-.23A.41.41,0,0,0,124.43,162.69Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M125.54,162.63h-.05l-.47-.27,0,0h0a0,0,0,0,1,0,0l.07,0h0l.49.29s0,0,0,0Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "84.65 140.62 80.64 142.94 80.2 142.69 84.22 140.37 84.65 140.62"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "86.18 139.74 85.05 140.39 84.61 140.14 85.74 139.49 86.18 139.74"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "83.02 142.45 81.39 143.39 80.95 143.14 82.58 142.2 83.02 142.45"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "86.94 140.19 83.42 142.22 82.99 141.97 86.51 139.93 86.94 140.19"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "89.15 141.58 86.36 143.19 85.92 142.94 88.71 141.33 89.15 141.58"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "85.96 143.43 85.12 143.92 84.68 143.67 85.52 143.18 85.96 143.43"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "89.92 142.05 85.9 144.37 85.46 144.11 89.48 141.79 89.92 142.05"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.34 144.79 87.5 145.27 87.06 145.02 87.9 144.54 88.34 144.79"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.5 144.44 88.28 145.72 87.84 145.47 90.07 144.18 90.5 144.44"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.28 143.88 86.65 144.82 86.21 144.57 87.84 143.62 88.28 143.88"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "92.2 141.61 88.68 143.64 88.25 143.39 91.77 141.36 92.2 141.61"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "100.54 142.55 100.39 141.99 106.92 138.27 107.07 138.83 100.54 142.55"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "100.91 143.58 100.76 143.02 102.69 141.92 102.83 142.48 100.91 143.58"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "103.47 142.12 103.33 141.56 107.21 139.38 107.35 139.94 103.47 142.12"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "101.17 144.67 101.02 144.11 104.9 141.93 105.05 142.49 101.17 144.67"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "101.45 145.77 101.31 145.21 102.4 144.59 102.55 145.15 101.45 145.77"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "103.02 144.84 102.88 144.27 106.48 142.28 106.62 142.84 103.02 144.84"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "102.28 150.04 102.13 149.45 108.38 145.89 108.53 146.48 102.28 150.04"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "102.45 151.13 102.31 150.54 104.16 149.49 104.3 150.08 102.45 151.13"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    points: "104.91 149.73 104.77 149.14 108.48 147.06 108.62 147.65 104.91 149.73"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    points: "113.3 154.42 113.14 153.88 115.03 152.8 115.2 153.34 113.3 154.42"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    points: "115.83 152.98 115.66 152.44 119.48 150.29 119.65 150.83 115.83 152.98"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    points: "113.65 155.46 113.48 154.92 117.3 152.78 117.47 153.32 113.65 155.46"
  })), /*#__PURE__*/React.createElement("path", {
    id: "ACTIVE-4",
    "data-name": "ACTIVE",
    d: "M87.44,152.7,83,150.14c-.78-.45-.68-1.23.22-1.76h0a3.4,3.4,0,0,1,3-.12l4.47,2.56c.78.45.68,1.24-.22,1.76h0A3.4,3.4,0,0,1,87.44,152.7Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.76,153a2.72,2.72,0,0,1-1.35-.31l-4.47-2.56a1,1,0,0,1-.56-.82,1.32,1.32,0,0,1,.78-1.06,3.46,3.46,0,0,1,3.11-.12l4.47,2.56a1,1,0,0,1,.56.82,1.31,1.31,0,0,1-.78,1A3.62,3.62,0,0,1,88.76,153Zm-1.29-.43a3.34,3.34,0,0,0,3-.12,1.22,1.22,0,0,0,.72-.94.87.87,0,0,0-.5-.71l-4.46-2.56a3.31,3.31,0,0,0-3,.13,1.19,1.19,0,0,0-.72.94.84.84,0,0,0,.5.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.38,149.37c.29.17.3.4,0,.56a1,1,0,0,1-1,0l-.35-.2-.52.29a.12.12,0,0,1-.14,0h0s0,0,0-.08l1.41-.81a.12.12,0,0,1,.14,0Zm-.81.47a.7.7,0,0,0,.66,0c.19-.11.2-.27,0-.38l-.35-.2-.66.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.35,150.56s0-.06,0-.07l2.05-.45a.19.19,0,0,1,.13,0l.06,0s0,0,0,.07l-.78,1.19s-.08,0-.14,0h0s0,0,0-.08l.31-.47-.66-.38-.82.17a.19.19,0,0,1-.13,0Zm2.05-.38-.86.19.53.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.09,151.57s0-.06,0-.07l.55-.11.52-.87a.09.09,0,0,1,.13,0h0s0,.05,0,.08l-.45.75,1.3-.26a.19.19,0,0,1,.13,0h0c.06,0,0,.06,0,.08l-2.11.41a.15.15,0,0,1-.13,0Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.85,69.82l-48,27.7,48,27.71,48-27.71Zm48,27.7-48,27.71v55.4l48-27.7Zm-48,27.71-48-27.71v55.41l48,27.7Z",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "SALES"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "104.02 134.94 152 162.64 152 218.05 104.02 245.75 56.03 218.05 56.03 162.64 104.02 134.94",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.93,218.22l48-27.83m0,0-.12-55.4m.15,55.4L151.5,218",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "_8",
    "data-name": 8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.85,232.23c.21.13.21.33,0,.45a.85.85,0,0,1-.79,0c-.21-.12-.21-.32,0-.45A.91.91,0,0,1,107.85,232.23Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.76,232.23c.21.13.21.33,0,.45a.83.83,0,0,1-.78,0c-.22-.12-.22-.32,0-.45A.89.89,0,0,1,103.76,232.23Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.8,231.05c.22.13.22.33,0,.45a.83.83,0,0,1-.78,0c-.22-.12-.22-.32,0-.45A.89.89,0,0,1,105.8,231.05Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.32,
    cy: 231.28,
    rx: 0.55,
    ry: 0.32,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.76,229.87c.21.13.21.33,0,.45a.83.83,0,0,1-.78,0c-.22-.12-.22-.32,0-.45A.89.89,0,0,1,103.76,229.87Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.65,229.86a.24.24,0,0,1,0,.45.83.83,0,0,1-.78,0,.24.24,0,0,1,0-.45A.89.89,0,0,1,99.65,229.86Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.7,228.68a.24.24,0,0,1,0,.45.85.85,0,0,1-.79,0,.24.24,0,0,1,0-.45A.91.91,0,0,1,101.7,228.68Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.22,
    cy: 228.91,
    rx: 0.55,
    ry: 0.32,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.65,227.5a.24.24,0,0,1,0,.45.83.83,0,0,1-.78,0,.24.24,0,0,1,0-.45A.89.89,0,0,1,99.65,227.5Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.56,227.5a.24.24,0,0,1,0,.45.83.83,0,0,1-.78,0,.24.24,0,0,1,0-.45A.89.89,0,0,1,95.56,227.5Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.61,226.32a.24.24,0,0,1,0,.45.83.83,0,0,1-.78,0,.24.24,0,0,1,0-.45A.89.89,0,0,1,97.61,226.32Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.52,226.32a.24.24,0,0,1,0,.45.83.83,0,0,1-.78,0,.24.24,0,0,1,0-.45A.89.89,0,0,1,93.52,226.32Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.17,
    cy: 225.37,
    rx: 0.55,
    ry: 0.32,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.48,225.14a.24.24,0,0,1,0,.45.85.85,0,0,1-.79,0,.24.24,0,0,1,0-.45A.85.85,0,0,1,91.48,225.14Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.52,224a.24.24,0,0,1,0,.45.83.83,0,0,1-.78,0,.24.24,0,0,1,0-.45A.83.83,0,0,1,93.52,224Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.04,
    cy: 224.18,
    rx: 0.55,
    ry: 0.32,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.48,222.78a.24.24,0,0,1,0,.45.85.85,0,0,1-.79,0,.24.24,0,0,1,0-.45A.85.85,0,0,1,91.48,222.78Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.39,222.78a.24.24,0,0,1,0,.45.83.83,0,0,1-.78,0,.24.24,0,0,1,0-.45A.83.83,0,0,1,87.39,222.78Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.43,221.6a.24.24,0,0,1,0,.45.89.89,0,0,1-.78,0,.24.24,0,0,1,0-.45A.83.83,0,0,1,89.43,221.6Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.34,221.6a.24.24,0,0,1,0,.45.89.89,0,0,1-.78,0,.24.24,0,0,1,0-.45A.83.83,0,0,1,85.34,221.6Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.39,220.42a.24.24,0,0,1,0,.45.89.89,0,0,1-.78,0,.24.24,0,0,1,0-.45A.83.83,0,0,1,87.39,220.42Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.33,219.23c.21.12.21.32,0,.45a.91.91,0,0,1-.79,0c-.21-.13-.21-.33,0-.45A.85.85,0,0,1,85.33,219.23Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.11,231.07a.83.83,0,0,1,.78,0,.24.24,0,0,1,0,.45.85.85,0,0,1-.79,0A.24.24,0,0,1,109.11,231.07Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.94,229.89c.22.12.22.32,0,.45a.89.89,0,0,1-.78,0c-.22-.13-.22-.33,0-.45A.83.83,0,0,1,111.94,229.89Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,229.16a.91.91,0,0,1-.79,0c-.21-.13-.21-.33,0-.45a.85.85,0,0,1,.79,0c.21.12.21.32,0,.45Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,227.53c.22.12.22.32,0,.45a.89.89,0,0,1-.78,0c-.22-.13-.22-.33,0-.45A.83.83,0,0,1,116,227.53Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.07,226.35c.22.12.22.32,0,.45a.89.89,0,0,1-.78,0c-.21-.13-.21-.33,0-.45A.83.83,0,0,1,118.07,226.35Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.12,225.17c.21.12.21.32,0,.45a.89.89,0,0,1-.78,0c-.22-.13-.22-.33,0-.45A.83.83,0,0,1,120.12,225.17Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.16,224c.22.12.22.32,0,.45a.89.89,0,0,1-.78,0c-.22-.13-.22-.33,0-.45A.83.83,0,0,1,122.16,224Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.21,222.81c.21.12.21.32,0,.45a.91.91,0,0,1-.79,0c-.21-.13-.21-.33,0-.45A.85.85,0,0,1,124.21,222.81Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.07,229.89a.83.83,0,0,1,.78,0,.24.24,0,0,1,0,.45.86.86,0,0,1-.78,0A.24.24,0,0,1,107.07,229.89Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.9,228.71c.21.12.21.32,0,.45a.89.89,0,0,1-.78,0c-.22-.13-.22-.33,0-.45A.83.83,0,0,1,109.9,228.71Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.94,227.53c.22.12.22.32,0,.45a.89.89,0,0,1-.78,0c-.22-.13-.22-.33,0-.45A.83.83,0,0,1,111.94,227.53Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,226.35c.21.12.21.32,0,.45a.91.91,0,0,1-.79,0c-.21-.13-.21-.33,0-.45A.85.85,0,0,1,114,226.35Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,225.17c.22.12.22.32,0,.45a.89.89,0,0,1-.78,0c-.22-.13-.22-.33,0-.45A.83.83,0,0,1,116,225.17Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.07,224c.22.12.22.32,0,.45a.89.89,0,0,1-.78,0c-.21-.13-.21-.33,0-.45A.83.83,0,0,1,118.07,224Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.12,222.81c.21.12.21.32,0,.45a.89.89,0,0,1-.78,0c-.22-.13-.22-.33,0-.45A.83.83,0,0,1,120.12,222.81Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.16,221.63c.22.12.22.32,0,.45a.89.89,0,0,1-.78,0c-.22-.13-.22-.33,0-.45A.83.83,0,0,1,122.16,221.63Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.82,
    cy: 220.67,
    rx: 0.55,
    ry: 0.32,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,228.71a.85.85,0,0,1,.79,0c.21.12.21.32,0,.45a.86.86,0,0,1-.78,0A.24.24,0,0,1,105,228.71Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.85,227.53c.22.12.22.32,0,.45a.89.89,0,0,1-.78,0c-.21-.13-.21-.33,0-.45A.83.83,0,0,1,107.85,227.53Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.9,226.35c.21.12.21.32,0,.45a.89.89,0,0,1-.78,0c-.22-.13-.22-.33,0-.45A.83.83,0,0,1,109.9,226.35Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.94,225.17c.22.12.22.32,0,.45a.89.89,0,0,1-.78,0c-.22-.13-.22-.33,0-.45A.83.83,0,0,1,111.94,225.17Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,224c.21.12.21.32,0,.45a.91.91,0,0,1-.79,0c-.21-.13-.21-.33,0-.45A.85.85,0,0,1,114,224Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,222.81c.22.12.22.32,0,.45a.89.89,0,0,1-.78,0c-.22-.13-.22-.33,0-.45A.83.83,0,0,1,116,222.81Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.07,221.63c.22.12.22.32,0,.45a.89.89,0,0,1-.78,0c-.21-.13-.21-.33,0-.45A.83.83,0,0,1,118.07,221.63Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.12,220.45c.21.12.21.32,0,.45a.89.89,0,0,1-.78,0c-.22-.13-.22-.33,0-.45A.83.83,0,0,1,120.12,220.45Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.16,219.27c.22.12.22.32,0,.45a.89.89,0,0,1-.78,0c-.22-.13-.22-.33,0-.45A.83.83,0,0,1,122.16,219.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103,227.52a.83.83,0,0,1,.78,0c.22.12.22.32,0,.45a.91.91,0,0,1-.79,0C102.75,227.84,102.75,227.64,103,227.52Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.33,187.65c0-.7-.85-2.19-3.1-3.49l-12-7a7.69,7.69,0,0,0-6.91-.29l-4.75,2.75s-2.43,1.45-6.94,4h0c-2.64,1.49-3.94,2.94-3.94,4.18v25.9a6.59,6.59,0,0,0,3.11,5.15l12,6.94a7.67,7.67,0,0,0,6.9.28l12.47-7.2h0l.11-.06a6.42,6.42,0,0,0,3-5.43l0-25.58h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.68,227.12a8.34,8.34,0,0,1-4.06-1l-12-6.94a6.85,6.85,0,0,1-3.27-5.4V187.85c0-1.4,1.41-2.94,4.09-4.45,4.46-2.53,6.92-4,6.94-4l4.76-2.75a8,8,0,0,1,7.21.29l12.06,7c2.19,1.27,3.22,2.83,3.25,3.75l0,25.79a6.77,6.77,0,0,1-3.2,5.7l-12.58,7.26A6.39,6.39,0,0,1,103.68,227.12Zm-.41-50.59a5.87,5.87,0,0,0-2.84.65l-4.75,2.75s-2.49,1.48-7,4c-2.44,1.38-3.78,2.77-3.78,3.91l0,25.9a6.34,6.34,0,0,0,2.94,4.88l12,6.94a7.38,7.38,0,0,0,6.6.28l12.58-7.26a6.15,6.15,0,0,0,2.89-5.16l0-25.77c0-.61-.84-2-2.94-3.23l-12.06-7A7.7,7.7,0,0,0,103.27,176.53Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.17,
    y: 202.18,
    width: 0.62,
    height: 20.24,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.25,176.89l-4.75,2.74s-2.44,1.46-7,4h0a19.87,19.87,0,0,0-2,1.44c-.14.14-2.77,2.71,3,6l10.36,6a7,7,0,0,0,7.55-.16c3.54-2.09,9.47-5.53,11.48-6.69a4.36,4.36,0,0,0,1.44-1.36c.75-1.18,1.44-3.19-1.16-4.69l-12.06-6.95A7.67,7.67,0,0,0,100.25,176.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.45,198.35a6.73,6.73,0,0,1-3.73-1.07l-10.34-6c-2.35-1.33-3.65-2.73-3.83-4.16a2.81,2.81,0,0,1,.79-2.3c.14-.1.26-.2.38-.3a14.87,14.87,0,0,1,1.67-1.18c4.46-2.53,6.92-4,6.94-4l4.76-2.75a8,8,0,0,1,7.22.29l12,7a3.71,3.71,0,0,1,1.93,2.24,3.87,3.87,0,0,1-.65,2.89,4.63,4.63,0,0,1-1.55,1.46c-2.89,1.67-8.21,4.77-11.48,6.69A8.1,8.1,0,0,1,103.45,198.35Zm-3-21.19-4.75,2.75s-2.49,1.48-7,4a15.13,15.13,0,0,0-1.6,1.13l-.35.28a2.13,2.13,0,0,0-.58,1.74c.15,1.2,1.37,2.48,3.52,3.69l10.36,6c.16.11,3.16,2.24,7.23-.16,3.27-1.92,8.59-5,11.48-6.69a3.9,3.9,0,0,0,1.33-1.25,3.22,3.22,0,0,0,.57-2.4,3.1,3.1,0,0,0-1.62-1.84l-12.06-7a7.34,7.34,0,0,0-6.58-.29Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.83,185.75v-6.28l-4.51,0a18.35,18.35,0,0,0-13.5-.07l-4.67,0v6.48h0c.06,1.63,1.16,3.25,3.32,4.5a17.71,17.71,0,0,0,16,0c2.15-1.25,3.26-2.8,3.32-4.43v-.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.5,192.56a16.71,16.71,0,0,1-8.18-1.95c-2.17-1.26-3.41-3-3.47-4.76v-6.8l4.92,0a18.8,18.8,0,0,1,13.63.07l4.76,0v6.74c-.06,1.81-1.26,3.43-3.48,4.71A16.7,16.7,0,0,1,103.5,192.56Zm-11-12.88v6.13c0,1.61,1.17,3.12,3.15,4.26a17.43,17.43,0,0,0,15.73,0c2-1.17,3.11-2.61,3.17-4.17v-6.12l-4.32-.05a18.12,18.12,0,0,0-13.26-.06l-.06,0Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.52,174.73c4.43,2.56,4.43,6.71,0,9.26a17.71,17.71,0,0,1-16,0c-4.43-2.55-4.43-6.7,0-9.26A17.77,17.77,0,0,1,111.52,174.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.5,186.22a16.72,16.72,0,0,1-8.18-2c-2.24-1.29-3.48-3-3.48-4.9s1.24-3.6,3.48-4.9c4.51-2.6,11.84-2.6,16.35,0h0c2.24,1.3,3.48,3,3.48,4.9s-1.24,3.61-3.48,4.9A16.71,16.71,0,0,1,103.5,186.22Zm0-13.09A16.12,16.12,0,0,0,95.63,175c-2,1.18-3.16,2.73-3.16,4.36s1.12,3.18,3.16,4.36a17.37,17.37,0,0,0,15.73,0c2-1.18,3.17-2.72,3.17-4.36s-1.13-3.18-3.17-4.36h0A16.11,16.11,0,0,0,103.5,173.13Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.22,175.66c3.71,2.05,3.71,5.36,0,7.4a15.48,15.48,0,0,1-13.45,0c-3.71-2-3.71-5.35,0-7.4A15.54,15.54,0,0,1,110.22,175.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.5,184.89a14.7,14.7,0,0,1-6.89-1.56c-1.89-1.05-2.94-2.46-2.94-4s1-2.92,2.94-4a15.9,15.9,0,0,1,13.77,0c1.89,1,2.94,2.45,2.94,4s-1,2.92-2.94,4A14.69,14.69,0,0,1,103.5,184.89Zm0-10.46a13.93,13.93,0,0,0-6.57,1.5c-1.69.93-2.62,2.15-2.62,3.43s.93,2.51,2.62,3.44a15.18,15.18,0,0,0,13.13,0c1.69-.93,2.62-2.15,2.62-3.44s-.93-2.5-2.62-3.43A13.92,13.92,0,0,0,103.5,174.43Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.61,181.34a8.2,8.2,0,0,0-1.17.78c.15.14.32.27.49.4a7.37,7.37,0,0,1,1-.65,15.12,15.12,0,0,1,13.13,0,8,8,0,0,1,1,.66c.18-.13.34-.26.5-.39a8.23,8.23,0,0,0-1.19-.8A15.88,15.88,0,0,0,96.61,181.34Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.65 182.3 99.82 180.3 101.64 180.3 101.67 174.61 98.25 175.04 95.6 176.45 93.99 179.06 94.31 180.9 95.65 182.3",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.64 185.88 104.64 192.26 108.87 191.47 112.42 189.81 114.24 187.84 115.02 186.22 114.84 180.69 112.85 183.21 110.73 184.6 106.06 185.77 104.64 185.88",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.27 185.87 102.27 192.22 100.3 192.07 100.3 185.6 102.27 185.87",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.47,225.64a3.39,3.39,0,0,1-1.83-.48c-1-.62-1.46-1.79-1.46-3.48l0-19.5c0-.08-.44-3,3.38-5.21l12.26-7.08a2.39,2.39,0,0,1,2.4-.31c1.19.65,1.36,2.65,1.38,3.25v20.6a6.77,6.77,0,0,1-3.2,5.7l-10.44,6,0,0A7,7,0,0,1,106.47,225.64Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.49,225.63a7.62,7.62,0,0,1-2.78-.63L87.6,219.16a6.83,6.83,0,0,1-3.26-5.4v-20.9c0-.61.18-2.62,1.38-3.27a2.38,2.38,0,0,1,2.41.31L100.4,197c3.82,2.17,3.4,5.12,3.38,5.25v19.46c0,1.68-.49,2.85-1.45,3.47A3.37,3.37,0,0,1,100.49,225.63ZM98,224.44s2.5,1.14,4,.18c.77-.49,1.16-1.48,1.16-2.94V202.17c0-.16.36-2.71-3.07-4.66h0L87.8,190.44a1.83,1.83,0,0,0-1.79-.31c-.93.51-1,2.37-1.06,2.74v20.87a6.29,6.29,0,0,0,3,4.88L98,224.44Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.93,215.36a2.88,2.88,0,0,1-1.51-.39,4,4,0,0,1-1.69-3.67,12.15,12.15,0,0,1,5.47-9.48,3.49,3.49,0,0,1,5.71,3.3,12.11,12.11,0,0,1-5.47,9.48A5.09,5.09,0,0,1,110.93,215.36Zm4.78-13.84a4.59,4.59,0,0,0-2.27.71,11.6,11.6,0,0,0-5.24,9.07,3,3,0,0,0,5,2.9,11.61,11.61,0,0,0,5.25-9.08,3.54,3.54,0,0,0-1.46-3.27A2.52,2.52,0,0,0,115.71,201.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.55,211.54v.23a.47.47,0,0,1-.22.43c-.14.08-.22,0-.22-.19v-.23c-.78.36-1.41.14-1.62-.54a.42.42,0,0,1,.24-.47l.1-.06c.16-.09.24-.06.3.08.16.36.53.46,1,.29v-2.67c-1,.19-1.47,0-1.47-1a3.5,3.5,0,0,1,1.47-2.68v-.23a.47.47,0,0,1,.22-.43c.14-.08.22,0,.22.19v.23c.62-.28,1.13-.13,1.34.37a.39.39,0,0,1-.23.47l-.13.08c-.16.09-.24.06-.31,0a.57.57,0,0,0-.67-.16v2.3c1-.18,1.71-.09,1.71,1A3.86,3.86,0,0,1,113.55,211.54Zm-.44-3.91v-2.15a2.23,2.23,0,0,0-.84,1.6C112.27,207.61,112.55,207.71,113.11,207.63Zm.44,3.21a2.51,2.51,0,0,0,1.08-1.9c0-.59-.3-.75-1.08-.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.82,208.19v-7.05l-10.29-6v7.37c0,.92-.11,3.45-1.2,4.06l-1.87,1,10.3,6,1.6-.89C91.94,211.84,91.83,208.4,91.82,208.19Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Active-5",
    "data-name": "Active",
    d: "M83.58,202.12c-.06-1.91,2.3-1,2.93,1,.62-1.27,3,.23,2.93,2.33-.06,1.51-2.63,2.68-2.92,2.8,0,0,0,0,0,0l0,0C86.2,207.81,83.64,203.69,83.58,202.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.51,208.56l-.05,0h-.1l-.11-.19c-.46-.72-2.87-4.63-2.93-6.23h0c0-1,.56-1.25.82-1.29a2.74,2.74,0,0,1,2.45,1.8,1.18,1.18,0,0,1,1-.17,3.08,3.08,0,0,1,2.07,3c-.06,1.57-2.4,2.73-3,3l0,.06Zm-2.67-6.46c0,1.18,1.71,4.15,2.77,5.85,1-.48,2.53-1.46,2.57-2.49A2.58,2.58,0,0,0,87.5,203a.6.6,0,0,0-.76.29l-.29.59-.19-.62c-.4-1.27-1.49-2-2-1.88-.34.06-.4.45-.39.76Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.88,170.16c-2-.64-4.89.25-7.32,2.43s-3.63,5-3.2,7l-.34.3,1,1.16c1.71,1.91,5.6,1.22,8.69-1.55s4.21-6.56,2.5-8.47l-1.05-1.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.84,179.59c-3.14,2.81-7.11,3.5-8.86,1.54l-1.13-1.25.38-.33c-.4-2.12.9-4.94,3.25-7.05s5.31-3.1,7.37-2.47l.37-.33,1.13,1.25C113.1,172.91,112,176.78,108.84,179.59Zm-9.65.31,1,1.07c1.66,1.86,5.48,1.16,8.52-1.56s4.15-6.44,2.49-8.3l-1-1.07-.29.26-.07,0c-2-.65-4.87.32-7.2,2.39s-3.59,4.85-3.17,6.9l0,.06Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.21,169.87c1.71,1.91.59,5.7-2.5,8.46s-7,3.47-8.69,1.56-.59-5.7,2.5-8.47S108.5,168,110.21,169.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "ACTIVE-6",
    "data-name": "ACTIVE",
    d: "M110.2,169.93c1.71,1.91.59,5.71-2.49,8.47s-7,3.47-8.7,1.56-.59-5.7,2.5-8.47S108.49,168,110.2,169.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.79,178.42c-3.13,2.81-7.1,3.5-8.86,1.55s-.62-5.83,2.51-8.64,7.11-3.5,8.86-1.54S110.93,175.62,107.79,178.42Zm-6.19-6.91c-3,2.72-4.15,6.44-2.49,8.3s5.49,1.15,8.52-1.56,4.16-6.45,2.49-8.3S104.64,168.79,101.6,171.51Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,170.72c1.28,1.44.33,4.39-2.14,6.6s-5.51,2.84-6.8,1.4-.33-4.39,2.14-6.6S107.66,169.28,109,170.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.89,177.41c-2.51,2.25-5.64,2.88-7,1.39s-.36-4.52,2.15-6.77,5.64-2.87,7-1.39S109.4,175.16,106.89,177.41Zm-4.66-5.2c-2.42,2.16-3.37,5-2.13,6.43s4.21.76,6.63-1.41,3.37-5,2.13-6.43S104.64,170.05,102.23,172.21Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.15,172.12c-2.47,2.21-3.43,5.17-2.14,6.6a2.5,2.5,0,0,0,.39.34c-.81-1.54.18-4.17,2.43-6.18s5-2.71,6.4-1.73a2.12,2.12,0,0,0-.28-.43C107.66,169.28,104.62,169.91,102.15,172.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.35,171.38l-.18-.13c-1.41-1-4.1-.22-6.26,1.72s-3.19,4.52-2.4,6l.13.24-.3-.09a1.66,1.66,0,0,1-.42-.35c-1.33-1.48-.36-4.52,2.15-6.77s5.64-2.87,7-1.39a2.5,2.5,0,0,1,.3.45Zm-7.12.83c-2.42,2.16-3.37,5-2.13,6.43v0c-.48-1.64.56-4,2.64-5.87s4.55-2.63,6.12-2v0C107.62,169.41,104.64,170.05,102.23,172.21Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.46 172.84 102.12 173.58 101.08 174.93 100.33 176.56 100.14 178.12 100.4 179.06 99.77 178.45 99.45 177.34 99.56 176.11 100.17 174.57 101.25 173.03 101.46 172.84",
    style: {
      fill: "#191410"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,173.9a1.12,1.12,0,0,0-.18-.76h0l-.45-.5-.46.16-.38.06a3,3,0,0,0-1.27.63,5.39,5.39,0,0,0-1.17,1.55l-1.7.39a1.77,1.77,0,0,1,.85-.67l.2-1-.42-.46-.55,1h0l-.25.21a3.47,3.47,0,0,0-.8,1.18l-.22.05v-.09l-.19-.22-.64.52.65.72.06-.33.14,0a1.53,1.53,0,0,0,0,.41l-.24.1.48.53a1.11,1.11,0,0,0,1.06.17,3,3,0,0,0,1.32-.66,4.85,4.85,0,0,0,1.12-1.38l1.82-.41a2.54,2.54,0,0,1-.49.5,3.66,3.66,0,0,1-.42.26l-.06-.13-.84.88.41.46a4.32,4.32,0,0,0,1.51-.89,3.75,3.75,0,0,0,.94-1.32l.79-.18.19-.61-.41-.46Zm-4.75,2.29a1.2,1.2,0,0,1-.47.23.5.5,0,0,1-.41,0,.4.4,0,0,1-.18-.34l1.51-.33A2.09,2.09,0,0,1,103.28,176.19Zm3.77-1.8-1.7.38a2,2,0,0,1,.5-.62,1.2,1.2,0,0,1,.55-.28.57.57,0,0,1,.51.07A.46.46,0,0,1,107.05,174.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.72,174.71l-.8.18a3.84,3.84,0,0,1-.93,1.3,4.64,4.64,0,0,1-1.55.91l-.08,0-.54-.61,1-1.07.08.17a2.43,2.43,0,0,0,.29-.2l.24-.21-1.41.32a5,5,0,0,1-1.12,1.38,3.46,3.46,0,0,1-1.37.68,1.21,1.21,0,0,1-1.17-.2l-.5-.55.07-.18-.7-.78.83-.66.29.32a3.71,3.71,0,0,1,.81-1.17l.22-.18.63-1.14.56.63-.21,1.17-.06,0a1.89,1.89,0,0,0-.58.36l1.3-.29a5.47,5.47,0,0,1,1.17-1.54,3.11,3.11,0,0,1,1.32-.66,1.73,1.73,0,0,1,.38-.05l.53-.19.5.56.08.15a1.23,1.23,0,0,1,.12.41l.27-.27.54.61Zm-1,0,.79-.18.15-.48-.28-.32-.51.5,0-.31a1,1,0,0,0-.17-.67l-.1-.14-.27-.3-.43.14-.36.06a3,3,0,0,0-1.22.6,5.51,5.51,0,0,0-1.13,1.52l0,.05-2,.46.17-.25a1.87,1.87,0,0,1,.85-.69l.17-.92-.26-.29-.41.73.07,0-.16.13-.23.2a3.3,3.3,0,0,0-.78,1.14l0,.06-.45.1,0-.22-.08-.08-.35.4.3.41,0-.17.39-.09,0,.18a2.45,2.45,0,0,0,0,.39v.08l-.17.07.37.4a1,1,0,0,0,1,.14,3.32,3.32,0,0,0,1.27-.64,4.94,4.94,0,0,0,1.09-1.35l0-.05,2.19-.49-.19.26a2.55,2.55,0,0,1-.52.52,2.23,2.23,0,0,1-.44.28l-.11.05,0-.08-.63.67.28.32a4.07,4.07,0,0,0,1.39-.84,3.67,3.67,0,0,0,.91-1.27Zm-.59-.19-2,.46.14-.24a2.41,2.41,0,0,1,.52-.66,1.54,1.54,0,0,1,.6-.3.68.68,0,0,1,.61.09.58.58,0,0,1,.19.56Zm-1.55.1,1.32-.3a.31.31,0,0,0-.1-.26.46.46,0,0,0-.4-.05,1.24,1.24,0,0,0-.51.26A1.54,1.54,0,0,0,105.61,174.59Zm-2.14,1.6-.12.1h0a1.34,1.34,0,0,1-.51.25.72.72,0,0,1-.51-.06.5.5,0,0,1-.23-.43V176l1.9-.43-.17.25A1.89,1.89,0,0,1,103.47,176.19Zm-.26-.1a1.86,1.86,0,0,0,.22-.19l-1.07.24a.22.22,0,0,0,.1.14.42.42,0,0,0,.32,0,1.35,1.35,0,0,0,.43-.22Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.38,174.52l-1.82.41a4.9,4.9,0,0,1-1.12,1.39,3.29,3.29,0,0,1-1.32.66,1.13,1.13,0,0,1-1.06-.17,1.07,1.07,0,0,1-.2-1.05l-.43.1.19-.62.44-.09a3.29,3.29,0,0,1,.8-1.18,3.57,3.57,0,0,1,1.2-.75l-.19,1a1.84,1.84,0,0,0-.85.67l1.7-.38a5.61,5.61,0,0,1,1.17-1.56,3,3,0,0,1,1.27-.63,1.32,1.32,0,0,1,1.18.17,1.19,1.19,0,0,1,.26,1.15l.81-.19-.19.62-.79.18a3.94,3.94,0,0,1-.94,1.32,4.39,4.39,0,0,1-1.51.88l.23-1.08a3.07,3.07,0,0,0,.68-.39A2.55,2.55,0,0,0,106.38,174.52Zm-4.57,1a.41.41,0,0,0,.17.33.58.58,0,0,0,.42.05,1.4,1.4,0,0,0,.47-.24,2.09,2.09,0,0,0,.45-.48Zm4.83-1.66a.48.48,0,0,0-.15-.45.58.58,0,0,0-.5-.07,1.35,1.35,0,0,0-.56.28,2.16,2.16,0,0,0-.49.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "ACTIVE-7",
    "data-name": "ACTIVE",
    d: "M106.44,174.47l-1.82.41a4.76,4.76,0,0,1-1.12,1.39,3.29,3.29,0,0,1-1.32.66,1.24,1.24,0,0,1-1.12-.12,1.18,1.18,0,0,1-.14-1.1l-.35.12.12-.63.43-.1a3.38,3.38,0,0,1,.8-1.18,3.33,3.33,0,0,1,1.17-.64l-.16.94a1.81,1.81,0,0,0-.85.66l1.7-.38A5.39,5.39,0,0,1,105,173a2.82,2.82,0,0,1,1.27-.63,1.29,1.29,0,0,1,1.18.16,1.19,1.19,0,0,1,.26,1.15l.78-.1-.16.53-.79.18a3.94,3.94,0,0,1-.94,1.32,4.67,4.67,0,0,1-1.57.93l.29-1.13A3.07,3.07,0,0,0,106,175,2.3,2.3,0,0,0,106.44,174.47Zm-4.57,1a.37.37,0,0,0,.18.33.5.5,0,0,0,.41,0,1.36,1.36,0,0,0,.47-.23,2,2,0,0,0,.45-.49Zm4.83-1.66a.48.48,0,0,0-.14-.45.6.6,0,0,0-.51-.07,1.44,1.44,0,0,0-.55.28,2.07,2.07,0,0,0-.5.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.31,174.21l-.8.18a3.87,3.87,0,0,1-.94,1.3,4.24,4.24,0,0,1-1.55.91l-.07,0-.13-.14.12-.37.16-.8.06,0a2.44,2.44,0,0,0,.65-.37l.24-.21-1.41.32a5.12,5.12,0,0,1-1.12,1.37,3.33,3.33,0,0,1-1.37.68,1.24,1.24,0,0,1-1.18-.2,1.09,1.09,0,0,1-.26-1l-.45.1.27-.88.44-.1a3.56,3.56,0,0,1,.81-1.16A3.92,3.92,0,0,1,103,173h0l.15.17-.21,1.16-.06,0a1.61,1.61,0,0,0-.58.35l1.3-.29a5.78,5.78,0,0,1,1.17-1.54,3.15,3.15,0,0,1,1.32-.65,1.42,1.42,0,0,1,1.29.19,1.2,1.2,0,0,1,.32,1.08l.68-.2.13.14Zm-1,0,.78-.17.13-.41-.8.23,0-.17a1.08,1.08,0,0,0-.22-1,1.2,1.2,0,0,0-1.08-.14,2.87,2.87,0,0,0-1.22.61,5.56,5.56,0,0,0-1.14,1.52l0,0-2,.46.17-.25a1.91,1.91,0,0,1,.85-.68l.15-.83a3.75,3.75,0,0,0-1,.7,3.36,3.36,0,0,0-.78,1.14l0,.06-.42.1-.11.35.41-.1,0,.19a1,1,0,0,0,.16.93,1,1,0,0,0,1,.14,3,3,0,0,0,1.27-.63,4.65,4.65,0,0,0,1.09-1.36l0,0,2.19-.5-.19.26a2.33,2.33,0,0,1-.52.52,2.88,2.88,0,0,1-.65.39l-.17.8a4,4,0,0,0,1.27-.78,3.71,3.71,0,0,0,.91-1.28Zm-.6-.19-2,.46.13-.24a2.4,2.4,0,0,1,.53-.65,1.44,1.44,0,0,1,.6-.31.72.72,0,0,1,.61.1.56.56,0,0,1,.18.56Zm-1.55.1,1.33-.3a.29.29,0,0,0-.1-.25.45.45,0,0,0-.41,0,1.24,1.24,0,0,0-.5.25A2.22,2.22,0,0,0,105.19,174.09Zm-2.13,1.61-.12.09a1.24,1.24,0,0,1-.52.25.61.61,0,0,1-.5-.06.49.49,0,0,1-.23-.43v-.1l1.9-.42-.17.25A3,3,0,0,1,103.06,175.7Zm-1.11-.06a.2.2,0,0,0,.1.14.42.42,0,0,0,.32,0,1.14,1.14,0,0,0,.43-.21,1.94,1.94,0,0,0,.21-.2Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.32 177.75 109.39 178.94 110.52 177.53 111.46 176.01 112.03 173.98 111.93 172.24 111.54 171.35 110.69 170.44 111.13 172.18 110.64 174.15 109.38 176.51 108.32 177.75",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.53 178.52 108.57 179.69 107.99 180.13 106.89 178.91 107.53 178.52",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,162.49c.23-2.06-1.23-4.73-3.85-6.67s-5.61-2.54-7.51-1.72l-.36-.27-.93,1.26c-1.52,2.06-.05,5.73,3.28,8.2s7.28,2.79,8.8.73l.93-1.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.58,163.38c-3.38-2.5-4.87-6.25-3.31-8.36l1-1.35.41.29c2-.82,5-.12,7.56,1.77s4.11,4.56,3.91,6.71l.4.29-1,1.36C106,166.2,102,165.89,98.58,163.38ZM96.32,154l-.85,1.16c-1.49,2,0,5.61,3.25,8s7.15,2.76,8.63.76l.86-1.17-.32-.23v-.07c.23-2.07-1.3-4.71-3.8-6.56s-5.48-2.54-7.39-1.71l-.07,0Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.38,162.76c-1.52,2.06-5.46,1.73-8.8-.73s-4.8-6.13-3.28-8.2,5.46-1.73,8.8.73S109.9,160.7,108.38,162.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "ACTIVE-8",
    "data-name": "ACTIVE",
    d: "M108.38,162.78c-1.52,2.06-5.46,1.74-8.8-.73s-4.8-6.13-3.28-8.19,5.46-1.74,8.8.73S109.9,160.72,108.38,162.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.51,162.13c-3.38-2.5-4.87-6.26-3.31-8.37s5.59-1.79,9,.71,4.87,6.25,3.31,8.36S102.89,164.63,99.51,162.13Zm5.52-7.47c-3.28-2.42-7.15-2.76-8.63-.75s0,5.6,3.25,8,7.15,2.76,8.63.76S108.3,157.08,105,154.66Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.29,161.69c-1.15,1.55-4.24,1.22-6.9-.75s-3.9-4.82-2.75-6.38,4.23-1.21,6.9.76S108.43,160.14,107.29,161.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.32,161c-2.72-2-4-4.93-2.78-6.54s4.36-1.27,7.07.73,4,4.94,2.77,6.54S103,163,100.32,161Zm4.15-5.61c-2.61-1.93-5.63-2.28-6.73-.78s.11,4.27,2.72,6.2,5.63,2.28,6.73.78S107.07,157.34,104.47,155.42Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.54,155.32c-2.67-2-5.75-2.31-6.9-.76a2.55,2.55,0,0,0-.25.46c1.35-1.11,4.12-.67,6.54,1.12s3.66,4.31,3,5.92a2.1,2.1,0,0,0,.36-.37C108.43,160.14,107.2,157.29,104.54,155.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.72,162.22l.1-.21c.64-1.57-.63-4-3-5.78s-5.08-2.2-6.39-1.12l-.21.17,0-.31a2.4,2.4,0,0,1,.26-.48c1.19-1.6,4.36-1.27,7.07.73s4,4.94,2.77,6.54a1.68,1.68,0,0,1-.37.39Zm-2.25-6.8c-2.61-1.93-5.63-2.28-6.73-.78h0c1.51-.8,4-.26,6.29,1.39s3.49,3.92,3.17,5.6v0C108.3,160.13,107.07,157.34,104.47,155.42Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.69 154.79 103.11 155.59 101.57 154.84 99.83 154.44 98.25 154.57 97.39 155.02 97.86 154.27 98.88 153.74 100.11 153.59 101.74 153.88 103.46 154.62 103.69 154.79",
    style: {
      fill: "#191410"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,161.44a1.08,1.08,0,0,0,.7-.33h0l.4-.54-.26-.42a1.74,1.74,0,0,0-.13-.36,3.06,3.06,0,0,0-.87-1.12,5.79,5.79,0,0,0-1.76-.83l-.72-1.59a1.81,1.81,0,0,1,.82.71l1.06,0,.37-.49-1.08-.34h0l-.26-.2a3.37,3.37,0,0,0-1.32-.55l-.09-.21H101l.18-.23-.63-.53-.58.79h.33l.06.12a1.64,1.64,0,0,0-.41,0c-.09-.12-.15-.22-.15-.22l-.42.58a1.08,1.08,0,0,0,0,1.07,3.13,3.13,0,0,0,.91,1.16,5,5,0,0,0,1.58.81l.77,1.71a2.68,2.68,0,0,1-.58-.39,3,3,0,0,1-.35-.36l.11-.08-1-.64-.37.49a4.23,4.23,0,0,0,1.17,1.3,3.81,3.81,0,0,0,1.49.65l.33.74.64.06.37-.49Zm-3.21-4.19a1.31,1.31,0,0,1-.32-.41.58.58,0,0,1,0-.42.37.37,0,0,1,.29-.23l.64,1.41A2,2,0,0,1,100.78,157.25Zm2.53,3.33-.72-1.59a2.24,2.24,0,0,1,.71.36,1.29,1.29,0,0,1,.39.49.58.58,0,0,1,0,.51A.47.47,0,0,1,103.31,160.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.34,162.28l-.34-.74a4.06,4.06,0,0,1-1.47-.66,4.56,4.56,0,0,1-1.2-1.33l0-.07.48-.65,1.26.79-.15.11a2.94,2.94,0,0,0,.25.25c.09.07.17.14.25.19l-.59-1.32a5,5,0,0,1-1.58-.82,3.26,3.26,0,0,1-.94-1.2,1.23,1.23,0,0,1,0-1.19l.43-.59.19,0,.62-.84.82.68-.25.35a3.62,3.62,0,0,1,1.3.56l.23.17,1.24.39-.5.68-1.19,0,0-.06a1.8,1.8,0,0,0-.46-.49l.55,1.22a5.32,5.32,0,0,1,1.74.83,3,3,0,0,1,.91,1.16,1.74,1.74,0,0,1,.13.36l.29.48-.44.6-.13.11a1.37,1.37,0,0,1-.38.2l.31.21-.48.65Zm-.17-.95.33.73.51.05.25-.34-.59-.4.3,0a1,1,0,0,0,.63-.3l.11-.13.24-.33-.22-.38a2.37,2.37,0,0,0-.13-.34,2.82,2.82,0,0,0-.84-1.07A5.31,5.31,0,0,0,102,158l-.05,0-.87-1.91.29.11a2,2,0,0,1,.84.7l.93,0,.23-.32-.79-.25v.07l-.16-.12-.25-.19a3.44,3.44,0,0,0-1.27-.54h-.06l-.19-.42h.21L101,155l-.47-.26-.33.37h.17l.17.37h-.19a2.72,2.72,0,0,0-.39,0l-.07,0-.1-.14-.33.44a1,1,0,0,0,.07.95,3.1,3.1,0,0,0,.87,1.12,4.79,4.79,0,0,0,1.55.79l0,0,.92,2-.29-.13a3,3,0,0,1-.61-.41,2.55,2.55,0,0,1-.36-.37l-.08-.1.07-.05-.78-.49-.25.34a4.1,4.1,0,0,0,1.09,1.2,3.69,3.69,0,0,0,1.44.62Zm.07-.63-.87-1.91.26.09a2.2,2.2,0,0,1,.75.38,1.41,1.41,0,0,1,.42.53.66.66,0,0,1,0,.61.57.57,0,0,1-.51.3Zm-.42-1.49.56,1.24a.34.34,0,0,0,.24-.16.45.45,0,0,0,0-.4,1.15,1.15,0,0,0-.35-.45A2.22,2.22,0,0,0,102.82,159.21Zm-2-1.77-.12-.1h0a1.31,1.31,0,0,1-.35-.45.66.66,0,0,1,0-.51.5.5,0,0,1,.37-.31l.1,0,.8,1.77-.28-.11A2.73,2.73,0,0,1,100.82,157.44Zm0-.28a1.5,1.5,0,0,0,.24.18l-.45-1a.24.24,0,0,0-.12.13.43.43,0,0,0,0,.32,1.21,1.21,0,0,0,.29.37Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103,160l-.77-1.7a4.6,4.6,0,0,1-1.58-.82,3.18,3.18,0,0,1-.92-1.16,1.14,1.14,0,0,1,0-1.07,1.06,1.06,0,0,1,1-.4l-.18-.41.64.07.18.4a3.52,3.52,0,0,1,1.32.55,3.42,3.42,0,0,1,1,1l-1.06,0a1.78,1.78,0,0,0-.82-.7l.72,1.59a5.51,5.51,0,0,1,1.75.82,3,3,0,0,1,.88,1.12,1.3,1.3,0,0,1,.07,1.19,1.15,1.15,0,0,1-1.06.49l.34.76-.64-.07-.34-.74a3.75,3.75,0,0,1-1.48-.64,4.48,4.48,0,0,1-1.17-1.3h1.1a2.93,2.93,0,0,0,.52.59A2.66,2.66,0,0,0,103,160Zm-1.93-4.27a.38.38,0,0,0-.29.24.5.5,0,0,0,0,.41,1.12,1.12,0,0,0,.32.42,2.2,2.2,0,0,0,.57.34Zm2.6,4.39a.47.47,0,0,0,.41-.23.58.58,0,0,0,0-.51,1.36,1.36,0,0,0-.39-.49,2,2,0,0,0-.71-.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "ACTIVE-9",
    "data-name": "ACTIVE",
    d: "M102.94,160l-.77-1.7a5,5,0,0,1-1.58-.81,3.23,3.23,0,0,1-.91-1.16,1,1,0,0,1,0-1,1,1,0,0,1,.91-.47l0-.33h.44l.18.4a3.41,3.41,0,0,1,1.32.56,3.13,3.13,0,0,1,.86,1l-.94,0a1.83,1.83,0,0,0-.83-.71l.72,1.59a5.56,5.56,0,0,1,1.76.83,3.06,3.06,0,0,1,.87,1.12,1.31,1.31,0,0,1,.08,1.19A1.18,1.18,0,0,1,104,161l.25.75-.55,0-.33-.74a3.81,3.81,0,0,1-1.49-.65,3.53,3.53,0,0,1-1.06-1.19l1-.11a2.43,2.43,0,0,0,.52.59A2.3,2.3,0,0,0,102.94,160ZM101,155.73a.37.37,0,0,0-.29.23.58.58,0,0,0,0,.42,1.31,1.31,0,0,0,.32.41,2,2,0,0,0,.57.34Zm2.6,4.38a.45.45,0,0,0,.41-.22.58.58,0,0,0,0-.51,1.21,1.21,0,0,0-.39-.49,2.24,2.24,0,0,0-.71-.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.71,161.79l-.34-.75a3.88,3.88,0,0,1-1.47-.65,4.59,4.59,0,0,1-1.2-1.34l0-.07.12-.15.39,0H102l0,0a2.67,2.67,0,0,0,.5.56,2.07,2.07,0,0,0,.25.19l-.6-1.32a5,5,0,0,1-1.57-.81,3.43,3.43,0,0,1-1-1.21,1.24,1.24,0,0,1,0-1.18,1.06,1.06,0,0,1,.9-.46l-.19-.43.92.1.18.4a3.85,3.85,0,0,1,1.31.56,4.26,4.26,0,0,1,1.1,1.06h0l-.14.19-1.18,0,0-.05a1.7,1.7,0,0,0-.47-.49l.55,1.21a5.39,5.39,0,0,1,1.75.83,3.2,3.2,0,0,1,.91,1.16,1.44,1.44,0,0,1,.07,1.3,1.19,1.19,0,0,1-1,.54l.33.62-.11.15Zm-.17-1,.33.73.42,0-.39-.74h.18a1.06,1.06,0,0,0,1-.43,1.21,1.21,0,0,0-.08-1.08,2.82,2.82,0,0,0-.84-1.07,5.53,5.53,0,0,0-1.72-.81h0l-.87-1.92.28.12a1.87,1.87,0,0,1,.84.69l.85,0a3.61,3.61,0,0,0-.89-.81,3.27,3.27,0,0,0-1.27-.53h-.06l-.18-.4-.37,0,.17.39h-.18a.94.94,0,0,0-.88.34,1,1,0,0,0,0,1,3.13,3.13,0,0,0,.88,1.12,4.79,4.79,0,0,0,1.55.79l0,0,.92,2-.29-.13a2.78,2.78,0,0,1-1.12-1H101a4.07,4.07,0,0,0,1,1.08,3.87,3.87,0,0,0,1.44.63Zm.06-.62-.86-1.91.26.08a2.39,2.39,0,0,1,.75.38,1.49,1.49,0,0,1,.42.53.69.69,0,0,1,0,.62.58.58,0,0,1-.51.29Zm-.41-1.5.56,1.24a.28.28,0,0,0,.23-.15.44.44,0,0,0,0-.41,1.2,1.2,0,0,0-.35-.44A1.77,1.77,0,0,0,103.19,158.71Zm-2-1.77-.12-.09a1.44,1.44,0,0,1-.35-.46.64.64,0,0,1,0-.5.5.5,0,0,1,.38-.31l.1,0,.8,1.78-.28-.12A2.73,2.73,0,0,1,101.19,156.94Zm-.18-1.1a.21.21,0,0,0-.11.13.42.42,0,0,0,0,.32,1,1,0,0,0,.29.38,1.46,1.46,0,0,0,.24.17Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.28 162.51 99.33 163.79 100.94 164.61 102.62 165.23 104.72 165.38 106.41 164.93 107.19 164.36 107.91 163.35 106.3 164.13 104.27 164.05 101.71 163.28 100.28 162.51",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.36 161.88 98.43 163.14 97.88 162.66 98.85 161.34 99.36 161.88",
    style: {
      fill: "#16110d"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103.81,135l-48,27.7,48,27.7,48-27.7Zm48,27.7-48,27.7V245.8l48-27.7Zm-48,27.7-48-27.7v55.4l48,27.71Z",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Change"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "160.21 101.93 208.2 129.63 208.2 185.04 160.22 212.74 112.23 185.04 112.23 129.63 160.21 101.93",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.23,185.5l48-27.82m0,0-.12-55.41m.15,55.41,47.54,27.59",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.48,150.72l-6.47-4a3.53,3.53,0,0,0-.57-.38l-.36-.2h0c-2.87-1.5-6.75-1.2-11,1.27-8.85,5.11-16,17.54-16,27.75,0,5.08,1.77,8.65,4.63,10.34h0l6.85,4.26,1.43-3.16.57-1A17.84,17.84,0,0,0,158,184.4c8.85-5.11,16-17.53,16-27.75,0-.61,0-1.2-.08-1.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.69,190.39l-7.35-4.58c-3.07-1.87-4.76-5.65-4.76-10.66,0-10.34,7.29-23,16.24-28.12,4.11-2.38,8.05-2.89,11.13-1.45h0l.69.37a2.81,2.81,0,0,1,.45.28l.17.13,6.81,4.22L174.43,155c0,.55.07,1.11.07,1.67,0,10.34-7.29,23-16.24,28.13a18.54,18.54,0,0,1-2.46,1.2l-.5.83Zm-6.6-5.14,6.22,3.87,1.22-2.71.67-1.13.14-.05a18.85,18.85,0,0,0,2.48-1.21c8.72-5,15.81-17.31,15.81-27.37,0-.58,0-1.17-.08-1.74v-.14l2.35-3.91-6.32-3.94a1.92,1.92,0,0,0-.33-.21l-.37-.2c-2.85-1.48-6.62-1-10.61,1.27-8.71,5-15.8,17.31-15.8,27.37,0,4.74,1.57,8.28,4.42,10Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 165.19,
    cy: 170.36,
    rx: 22.66,
    ry: 13.08,
    transform: "translate(-64.94 228.23) rotate(-60)",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,191.49a8.63,8.63,0,0,1-4.39-1.14c-3.17-1.82-4.91-5.64-4.91-10.74,0-10.34,7.29-23,16.24-28.13,4.42-2.55,8.6-2.95,11.76-1.12s4.92,5.64,4.92,10.75c0,10.34-7.29,22.95-16.24,28.12A15,15,0,0,1,158,191.49Zm14.31-41.39a14.16,14.16,0,0,0-6.93,2.13c-8.72,5-15.81,17.31-15.81,27.38,0,4.77,1.59,8.32,4.48,10s6.75,1.26,10.89-1.12c8.71-5,15.8-17.31,15.8-27.37,0-4.78-1.59-8.33-4.47-10A7.88,7.88,0,0,0,172.34,150.1Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "ACTIVE-10",
    "data-name": "ACTIVE",
    cx: 165.25,
    cy: 170.47,
    rx: 19.55,
    ry: 11.23,
    transform: "translate(-65.46 226.48) rotate(-59.54)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.8,171l5.81-10.45c.16-.29.45-.25.36.06l-4.31,10.76Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.87,171.78l-2.58-.51,6-10.84a.59.59,0,0,1,.72-.33.49.49,0,0,1,.24.64Zm-1.57-1,1.16.23,3.29-8.22Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.37,169.08a4.76,4.76,0,0,1-2.16,3.74c-1.2.69-2.17.14-2.17-1.24a4.78,4.78,0,0,1,2.17-3.75C166.4,167.14,167.37,167.7,167.37,169.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 165.25,
    cy: 170.41,
    rx: 3.06,
    ry: 1.77,
    transform: "translate(-64.95 228.32) rotate(-60)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.24,173.45a1.42,1.42,0,0,1-.73-.19,1.83,1.83,0,0,1-.79-1.68,5.07,5.07,0,0,1,2.32-4,1.64,1.64,0,0,1,2.66,1.53,5.05,5.05,0,0,1-2.33,4A2.36,2.36,0,0,1,164.24,173.45Zm1.93-5.59a1.71,1.71,0,0,0-.8.25,4.44,4.44,0,0,0-2,3.47,1,1,0,0,0,1.67,1,4.4,4.4,0,0,0,2-3.46,1.21,1.21,0,0,0-.47-1.12A.74.74,0,0,0,166.17,167.86Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.24,159.71l-.06,0c-.21.12-.38,0-.38-.29V157.1a.9.9,0,0,1,.38-.73l.06,0c.21-.12.38,0,.38.29V159A.92.92,0,0,1,165.24,159.71Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.58,158.72h0c-.21.05-.34-.13-.29-.42l.55-2.66a.85.85,0,0,1,.5-.62h0c.22-.06.35.12.29.41l-.54,2.66A.86.86,0,0,1,167.58,158.72Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.8,158.5h0c-.2,0-.27-.27-.15-.56l1-2.71c.11-.3.36-.52.56-.5h0c.2,0,.26.27.15.56l-1,2.71C170.24,158.29,170,158.51,169.8,158.5Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.7,159.08h0c-.16-.09-.16-.39,0-.67l1.49-2.57c.16-.28.42-.43.58-.34h0c.16.09.16.39,0,.67l-1.49,2.58C172.12,159,171.86,159.18,171.7,159.08Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.16,160.44h0a.69.69,0,0,1,.15-.74l1.82-2.26c.2-.25.45-.31.56-.15h0a.69.69,0,0,1-.15.73l-1.82,2.27C173.52,160.53,173.27,160.6,173.16,160.44Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.08,162.46h0a.83.83,0,0,1,.29-.74l2-1.81c.22-.19.44-.17.5.05h0a.85.85,0,0,1-.29.75l-2,1.8C174.36,162.7,174.13,162.68,174.08,162.46Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.39,165h0a.86.86,0,0,1,.35-.68l2.22-1.28c.19-.11.35,0,.35.27h0a.88.88,0,0,1-.35.68l-2.22,1.28C174.55,165.41,174.39,165.29,174.39,165Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.08,168h0a.81.81,0,0,1,.5-.62l2-.55c.22-.06.35.13.29.41h0a.85.85,0,0,1-.5.63l-2,.54C174.15,168.42,174,168.24,174.08,168Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.16,171h0c.11-.29.36-.52.56-.5l1.82.16c.2,0,.26.27.15.56h0c-.11.3-.36.52-.56.5l-1.82-.16C173.11,171.58,173,171.33,173.16,171Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.26,180.22h0a.71.71,0,0,1-.15.73l-1.82,2.27c-.2.24-.45.31-.57.15h0a.73.73,0,0,1,.15-.74l1.83-2.26C156.89,180.12,157.14,180.06,157.26,180.22Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.34,178.19h0a.85.85,0,0,1-.29.75l-2,1.8c-.22.19-.45.17-.5,0h0a.84.84,0,0,1,.29-.75l2-1.8C156.06,178,156.28,178,156.34,178.19Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,175.63h0a.86.86,0,0,1-.36.68l-2.21,1.27c-.2.12-.36,0-.36-.26h0a.83.83,0,0,1,.36-.68l2.21-1.28C155.87,175.25,156,175.37,156,175.63Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.34,172.7h0a.85.85,0,0,1-.5.63l-2,.54c-.22.06-.35-.12-.29-.41h0a.8.8,0,0,1,.5-.62l2-.55C156.27,172.23,156.4,172.42,156.34,172.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.26,169.62h0c-.12.29-.37.51-.56.49l-1.83-.16c-.19,0-.26-.27-.15-.56h0c.12-.29.37-.51.57-.5l1.82.17C157.3,169.07,157.37,169.33,157.26,169.62Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.72,166.58h0c-.16.28-.42.43-.58.33l-1.49-.85c-.16-.1-.16-.4,0-.67h0c.16-.28.42-.43.58-.34l1.49.86C158.88,166,158.88,166.3,158.72,166.58Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.62,163.8h0c-.2.24-.45.31-.56.15l-1.05-1.5a.67.67,0,0,1,.15-.73h0c.19-.25.44-.31.56-.15l1.05,1.49A.73.73,0,0,1,160.62,163.8Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.83,161.46h0c-.22.19-.44.17-.5-.05l-.55-2a.88.88,0,0,1,.29-.74h0c.22-.2.45-.18.51,0l.54,2A.84.84,0,0,1,162.83,161.46Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.24,159.71l-.06,0c-.21.12-.38,0-.38-.29V157.1a.9.9,0,0,1,.38-.73l.06,0c.21-.12.38,0,.38.29V159A.92.92,0,0,1,165.24,159.71Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.61,178.6l-8.94,5.16c-.47.27-.85,0-.85-.64v-1a2,2,0,0,1,.85-1.62l8.94-5.16c.47-.28.86,0,.86.64v1A2,2,0,0,1,169.61,178.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.4,184.61a.8.8,0,0,1-.38-.1,1.08,1.08,0,0,1-.46-1v-1a2.39,2.39,0,0,1,1-1.91l8.94-5.16a.87.87,0,0,1,.89,0,1.06,1.06,0,0,1,.46,1v1a2.37,2.37,0,0,1-1,1.91l-8.94,5.16A1,1,0,0,1,160.4,184.61ZM170,176a.43.43,0,0,0-.17.06l-8.94,5.16a1.75,1.75,0,0,0-.69,1.34v1a.51.51,0,0,0,.13.4c.08,0,.19,0,.23,0l8.94-5.17a1.72,1.72,0,0,0,.69-1.34v-1c0-.23-.06-.37-.13-.41Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.67,145.92l1.81-2.14a.19.19,0,0,0,0-.31L164,140.94l0,0,0,0-.13-.06a1.55,1.55,0,0,0-1.49.06l-6.71,4a3.14,3.14,0,0,0-1.53,2.7v4.13l4.52,2.56,5.47-7.2,1-.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.76,154.93l-5.07-2.87v-4.38a3.59,3.59,0,0,1,1.73-3.07l6.71-4a2,2,0,0,1,1.91-.09l.09.05h0l4.54,2.57a.64.64,0,0,1,.31.48.62.62,0,0,1-.21.53l-1.85,2.21-1.64.43-.85.73Zm-4.2-3.37,4,2.24,5.29-7,1-.9,1.57-.4,1.54-1.83-4.31-2.44a1.1,1.1,0,0,0-1.07,0l-6.72,4a2.7,2.7,0,0,0-1.31,2.32Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,143.58l-6.71,4a3.16,3.16,0,0,0-1.51,2.48v4.34a26,26,0,0,1,5.32-4.2,16.15,16.15,0,0,1,5.3-2.17v-3.13A1.59,1.59,0,0,0,167,143.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.85,155l-.49-.3V150.1a3.6,3.6,0,0,1,1.72-2.85l6.72-4a2,2,0,0,1,3,1.73v3.51l-.37.06a15.17,15.17,0,0,0-5.15,2.11,25.26,25.26,0,0,0-5.22,4.13Zm8.4-11-6.72,4a2.73,2.73,0,0,0-1.3,2.13v3.27a24.78,24.78,0,0,1,4.66-3.53,16.87,16.87,0,0,1,5.08-2.16v-2.77a1.15,1.15,0,0,0-.58-1,1.13,1.13,0,0,0-1.15,0Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,188.59a7.39,7.39,0,0,1-3.76-1c-2.68-1.56-4.16-4.81-4.14-9.16,0-8.86,6.36-19.7,14.08-24.16,3.83-2.21,7.43-2.56,10.14-1s4.16,4.81,4.14,9.15c0,8.86-6.35,19.7-14.08,24.16A13,13,0,0,1,159,188.59ZM171.53,153a12.36,12.36,0,0,0-6.05,1.87c-7.55,4.36-13.72,14.94-13.75,23.6,0,4.1,1.34,7.15,3.81,8.58s5.87,1.1,9.48-1c7.55-4.36,13.72-14.95,13.76-23.6h0c0-4.1-1.34-7.15-3.82-8.59A6.81,6.81,0,0,0,171.53,153Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.71 165.9 150.94 170.12 149.6 174.76 149.18 178.64 149.4 182.51 150.38 185.73 151.4 188.44 144.79 183.95 142.84 180.54 142.07 176.58 142.2 172.28 142.81 169.07 143.71 165.9",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.23 147.26 158.8 149.96 158.8 154.44 154.12 151.68 154.23 147.26",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.93,
    cy: 192.08,
    rx: 0.6,
    ry: 0.35,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 152.14,
    cy: 190.8,
    rx: 0.6,
    ry: 0.35,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.15,190.56a.25.25,0,0,1,0,.48.91.91,0,0,1-.85,0,.25.25,0,0,1,0-.48A.91.91,0,0,1,148.15,190.56Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.36,189.28c.23.13.23.35,0,.49a1,1,0,0,1-.85,0c-.23-.14-.23-.36,0-.49A1,1,0,0,1,150.36,189.28Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.94,189.28c.23.13.23.35,0,.49a1,1,0,0,1-.85,0,.26.26,0,0,1,0-.49A1,1,0,0,1,145.94,189.28Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 147.72,
    cy: 188.25,
    rx: 0.6,
    ry: 0.35,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.94,186.73c.23.13.23.35,0,.49a1,1,0,0,1-.85,0c-.23-.14-.23-.36,0-.49A.91.91,0,0,1,145.94,186.73Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 161.07,
    cy: 195.7,
    rx: 0.6,
    ry: 0.35,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.28,
    cy: 194.42,
    rx: 0.6,
    ry: 0.35,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.91,192.9c.24.14.24.36,0,.49a.89.89,0,0,1-.84,0c-.23-.13-.23-.35,0-.49A1,1,0,0,1,165.91,192.9Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.12,191.63c.24.13.24.35,0,.49a1,1,0,0,1-.84,0c-.23-.14-.23-.36,0-.49A.89.89,0,0,1,168.12,191.63Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.33,190.35c.24.14.24.36,0,.49a1,1,0,0,1-.84,0c-.23-.13-.23-.35,0-.49A1,1,0,0,1,170.33,190.35Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.54,189.08c.24.13.24.35,0,.48a.89.89,0,0,1-.84,0,.25.25,0,0,1,0-.48A.89.89,0,0,1,172.54,189.08Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.33,
    cy: 188.04,
    rx: 0.6,
    ry: 0.35,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.54,
    cy: 186.77,
    rx: 0.6,
    ry: 0.35,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.07,195.46c.24.13.24.35,0,.48a.89.89,0,0,1-.84,0,.25.25,0,0,1,0-.48A.89.89,0,0,1,157.07,195.46Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.28,194.18c.24.13.24.35,0,.49a1,1,0,0,1-.84,0c-.23-.14-.23-.36,0-.49A1,1,0,0,1,159.28,194.18Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 161.07,
    cy: 193.15,
    rx: 0.6,
    ry: 0.35,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.28,
    cy: 191.87,
    rx: 0.6,
    ry: 0.35,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.91,190.35c.24.14.24.36,0,.49a1,1,0,0,1-.84,0c-.23-.13-.23-.35,0-.49A1,1,0,0,1,165.91,190.35Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 167.7,
    cy: 189.32,
    rx: 0.6,
    ry: 0.35,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.33,187.8c.24.13.24.35,0,.49a1,1,0,0,1-.84,0c-.23-.14-.23-.36,0-.49A1,1,0,0,1,170.33,187.8Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.54,186.52c.24.14.24.36,0,.49a.89.89,0,0,1-.84,0c-.23-.13-.23-.35,0-.49A1,1,0,0,1,172.54,186.52Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.75,185.25c.24.13.24.35,0,.49a1,1,0,0,1-.84,0c-.23-.14-.23-.36,0-.49A.89.89,0,0,1,174.75,185.25Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,184c.24.14.24.36,0,.49a1,1,0,0,1-.84,0c-.23-.13-.23-.35,0-.49A1,1,0,0,1,177,184Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.86,194.18c.24.13.24.35,0,.49a1,1,0,0,1-.84,0c-.23-.14-.23-.36,0-.49A1,1,0,0,1,154.86,194.18Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.07,192.9c.24.14.24.36,0,.49a.89.89,0,0,1-.84,0c-.23-.13-.23-.35,0-.49A1,1,0,0,1,157.07,192.9Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.28,191.63c.24.13.24.35,0,.49a1,1,0,0,1-.84,0c-.23-.14-.23-.36,0-.49A.89.89,0,0,1,159.28,191.63Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 172.12,
    cy: 184.22,
    rx: 0.6,
    ry: 0.35,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.33,
    cy: 182.94,
    rx: 0.6,
    ry: 0.35,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.54,
    cy: 181.66,
    rx: 0.6,
    ry: 0.35,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.65,192.9c.24.14.24.36,0,.49a.89.89,0,0,1-.84,0c-.23-.13-.23-.35,0-.49A1,1,0,0,1,152.65,192.9Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.86,191.63c.24.13.24.35,0,.49a1,1,0,0,1-.84,0c-.23-.14-.23-.36,0-.49A.89.89,0,0,1,154.86,191.63Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.12,187.8c-1.59-1.92-2.45-4.73-2.45-8.22a27.57,27.57,0,0,1,1.44-8.41l-.76-.45a28.51,28.51,0,0,0-1.55,8.86,14.85,14.85,0,0,0,1.8,7.59l1.29.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.38,102.27l-48,27.7,48,27.7,48-27.7Zm48,27.7-48,27.7v55.41l48-27.7Zm-48,27.7-48-27.7v55.41l48,27.7Z",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "104.39 0.29 152.38 27.99 152.38 83.4 104.39 111.1 56.41 83.4 56.41 27.99 104.39 0.29",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.51,83.52,104.33,56m.18-.87V.52m0,55.18,47.55,27.59",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,50.54a17.37,17.37,0,0,0-34.73,0,16.93,16.93,0,0,0,4.06,11c.06.07.12.15.19.22s.1.11.15.16l.23.24a22,22,0,0,1,4.2,6.52,8.94,8.94,0,0,0,.52,1.42s0,.08,0,.1h0a8.87,8.87,0,0,0,16.5-1.51,21.58,21.58,0,0,1,3.54-5.85A17,17,0,0,0,122,50.54Z",
    style: {
      fill: "#fff"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M104.61,75.57a9.34,9.34,0,0,1-8.25-5h0l-.11-.2,0-.14a8.42,8.42,0,0,1-.53-1.44,21.71,21.71,0,0,0-4.11-6.35l-.36-.39a2.53,2.53,0,0,1-.22-.26,17.4,17.4,0,0,1-4.15-11.25,17.79,17.79,0,0,1,35.58,0A17.27,17.27,0,0,1,117,63.14a21.12,21.12,0,0,0-3.43,5.7A9.25,9.25,0,0,1,104.61,75.57ZM97,70,97,70a8.45,8.45,0,0,0,15.72-1.44,22,22,0,0,1,3.61-6,16.46,16.46,0,0,0,5.2-12,16.95,16.95,0,0,0-33.89,0,16.55,16.55,0,0,0,4,10.73l.17.21.38.4a22.49,22.49,0,0,1,4.28,6.64,8.5,8.5,0,0,0,.51,1.4Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M104.61,82.14c-2.16,0-3.92,1.38-3.92,3.07s1.76,3.07,3.92,3.07,3.92-1.37,3.92-3.07S106.77,82.14,104.61,82.14Zm-3.08,3.07c0-1.23,1.38-2.23,3.08-2.23a4.15,4.15,0,0,1,1.48.28,2.93,2.93,0,0,0-2.7,2.58,2,2,0,0,0,.93,1.59C102.76,87.32,101.53,86.38,101.53,85.21Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110.92,82.36c0,2-2.83,3.6-6.31,3.6s-6.31-1.61-6.31-3.6,2.82-3.61,6.31-3.61S110.92,80.37,110.92,82.36Z",
    style: {
      fill: "#fff"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M104.61,86.38c-3.78,0-6.74-1.77-6.74-4s3-4,6.74-4,6.73,1.76,6.73,4S108.39,86.38,104.61,86.38Zm0-7.21c-3.19,0-5.89,1.46-5.89,3.19s2.7,3.18,5.89,3.18,5.89-1.46,5.89-3.18S107.8,79.17,104.61,79.17Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110.92,80c0,2-2.83,3.6-6.31,3.6S98.3,82,98.3,80s2.82-3.6,6.31-3.6S110.92,78,110.92,80Z",
    style: {
      fill: "#fff"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M104.61,84c-3.78,0-6.74-1.77-6.74-4s3-4,6.74-4,6.73,1.77,6.73,4S108.39,84,104.61,84Zm0-7.21c-3.19,0-5.89,1.46-5.89,3.19s2.7,3.18,5.89,3.18,5.89-1.45,5.89-3.18S107.8,76.81,104.61,76.81Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110.92,77.51c0,2-2.83,3.6-6.31,3.6s-6.31-1.61-6.31-3.6,2.82-3.6,6.31-3.6S110.92,75.52,110.92,77.51Z",
    style: {
      fill: "#fff"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M104.61,81.53c-3.78,0-6.74-1.77-6.74-4s3-4,6.74-4,6.73,1.77,6.73,4S108.39,81.53,104.61,81.53Zm0-7.21c-3.19,0-5.89,1.46-5.89,3.19s2.7,3.19,5.89,3.19,5.89-1.46,5.89-3.19S107.8,74.32,104.61,74.32Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110.92,75.15c0,2-2.83,3.6-6.31,3.6s-6.31-1.61-6.31-3.6,2.82-3.6,6.31-3.6S110.92,73.16,110.92,75.15Z",
    style: {
      fill: "#fff"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M104.61,79.17c-3.78,0-6.74-1.76-6.74-4s3-4,6.74-4,6.73,1.77,6.73,4S108.39,79.17,104.61,79.17Zm0-7.2c-3.19,0-5.89,1.46-5.89,3.18s2.7,3.19,5.89,3.19,5.89-1.46,5.89-3.19S107.8,72,104.61,72Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110.92,72.66c0,2-2.83,3.61-6.31,3.61s-6.31-1.62-6.31-3.61,2.82-3.6,6.31-3.6S110.92,70.67,110.92,72.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.59,71.83c-3.24,0-5.87,1.5-5.87,3.35a1.26,1.26,0,0,0,0,.28c.94,1.31,3.2,2.24,5.84,2.24s4.81-.89,5.78-2.16a1.53,1.53,0,0,0,.07-.36C110.46,73.33,107.83,71.83,104.59,71.83Z",
    style: {
      fill: "#fff"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M106.32,68.78a1.26,1.26,0,0,1,0,.27l0,.34a.84.84,0,0,1-.11.21c2.45.39,4.3,1.63,4.3,3.06,0,1.73-2.7,3.19-5.89,3.19s-5.89-1.46-5.89-3.19c0-1.41,1.8-2.64,4.19-3a2,2,0,0,1-.11-.26l0-.34a.78.78,0,0,1,0-.22c-2.86.46-4.91,2-4.91,3.86,0,2.26,3,4,6.74,4s6.73-1.76,6.73-4C111.34,70.77,109.24,69.22,106.32,68.78Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M104.51,73.55a2.07,2.07,0,0,1-2.18-1.92V62a2.2,2.2,0,0,1,4.37,0v9.66A2.07,2.07,0,0,1,104.51,73.55Zm0-12.71A1.28,1.28,0,0,0,103.13,62v9.66a1.41,1.41,0,0,0,2.76,0V62A1.28,1.28,0,0,0,104.51,60.84Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M105.91,61.56l-1.55-1-1.38.89-.23-.35c-5.45-8.23-5.18-10.36-4.07-11.45.82-.8,1.85-.33,2.67,0a7.93,7.93,0,0,0,3.24.86A8.17,8.17,0,0,0,108,49.8c.84-.35,1.79-.76,2.6-.07,1,.88,1.42,2.35-4.44,11.48Zm-.73-1.44.47.29c5-7.86,5-9.5,4.38-10-.39-.33-.91-.14-1.72.21a8.76,8.76,0,0,1-3.73.85,8.65,8.65,0,0,1-3.58-.93c-.92-.41-1.36-.56-1.72-.2-.7.67-1,2.46,4,10l.47-.3c-3.16-4.81-4.61-8-4.19-9.09l.14-.37.38.12a5.86,5.86,0,0,1,.7.29,9.37,9.37,0,0,0,3.84,1,9.21,9.21,0,0,0,4-.9l.68-.26.59-.19,0,.61C109.7,52.42,108.07,55.57,105.18,60.12ZM100.3,51.7c.13.83.86,2.94,4.17,8,2.92-4.59,3.93-6.77,4.28-7.78a9.36,9.36,0,0,1-8.34-.14Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M108,93.26c.3.17.3.45,0,.63a1.23,1.23,0,0,1-1.09,0c-.3-.18-.3-.46,0-.63A1.17,1.17,0,0,1,108,93.26Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M110.87,91.61a.33.33,0,0,1,0,.63,1.23,1.23,0,0,1-1.09,0,.33.33,0,0,1,0-.63A1.23,1.23,0,0,1,110.87,91.61Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M113.72,90c.3.18.3.46,0,.63a1.17,1.17,0,0,1-1.09,0c-.3-.17-.3-.45,0-.63A1.23,1.23,0,0,1,113.72,90Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M102.32,93.26c.3.17.3.45,0,.63a1.23,1.23,0,0,1-1.09,0c-.3-.18-.3-.46,0-.63A1.17,1.17,0,0,1,102.32,93.26Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M105.17,91.61a.33.33,0,0,1,0,.63,1.23,1.23,0,0,1-1.09,0,.33.33,0,0,1,0-.63A1.23,1.23,0,0,1,105.17,91.61Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M108,90c.3.18.3.46,0,.63a1.17,1.17,0,0,1-1.09,0c-.3-.17-.3-.45,0-.63A1.23,1.23,0,0,1,108,90Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M110.87,88.32c.3.17.3.45,0,.63a1.23,1.23,0,0,1-1.09,0c-.3-.18-.3-.46,0-.63A1.23,1.23,0,0,1,110.87,88.32Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M113.72,86.67c.3.18.3.46,0,.63a1.17,1.17,0,0,1-1.09,0c-.3-.17-.3-.45,0-.63A1.23,1.23,0,0,1,113.72,86.67Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.92,
    cy: 91.92,
    rx: 0.77,
    ry: 0.44
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M102.32,90c.3.18.3.46,0,.63a1.17,1.17,0,0,1-1.09,0c-.3-.17-.3-.45,0-.63A1.23,1.23,0,0,1,102.32,90Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M96.62,90c.3.18.3.46,0,.63a1.17,1.17,0,0,1-1.09,0c-.3-.17-.3-.45,0-.63A1.23,1.23,0,0,1,96.62,90Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M99.47,88.32c.3.17.3.45,0,.63a1.23,1.23,0,0,1-1.09,0c-.3-.18-.3-.46,0-.63A1.23,1.23,0,0,1,99.47,88.32Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M96.59,86.66c.3.17.3.45,0,.63a1.23,1.23,0,0,1-1.09,0c-.3-.18-.3-.46,0-.63A1.17,1.17,0,0,1,96.59,86.66Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M104.39.29,56.41,28l48,27.71,48-27.71Zm48,27.7-48,27.71v55.4l48-27.7Zm-48,27.71L56.41,28V83.4l48,27.7Z",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Products"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "48.67 33.01 96.66 60.71 96.66 116.12 48.67 143.82 0.69 116.12 0.69 60.71 48.67 33.01",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.79,116.24,48.61,88.67m.18-.87V33.24m0,55.18L96.36,116",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "_5",
    "data-name": 5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.67,118.66a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,25.67,118.66Z",
    style: {
      fill: "#fff"
    }
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M25.41,118.6a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.75,
    cy: 118.04,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M26.75,117.83a.51.51,0,0,0-.25.06c-.14.08-.14.21,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.09,
    cy: 117.26,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M28.09,117.06a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.29a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.69,116.34c.14.09.14.22,0,.3a.59.59,0,0,1-.52,0c-.14-.08-.14-.21,0-.3A.59.59,0,0,1,29.69,116.34Z",
    style: {
      fill: "#fff"
    }
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M29.43,116.28a.58.58,0,0,0-.26.06c-.14.09-.14.22,0,.3a.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31,115.57c.14.08.14.21,0,.3a.59.59,0,0,1-.52,0c-.14-.09-.14-.22,0-.3A.59.59,0,0,1,31,115.57Z",
    style: {
      fill: "#fff"
    }
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M30.77,115.51a.55.55,0,0,0-.26.06c-.14.08-.14.21,0,.3a.59.59,0,0,0,.52,0c.14-.09.14-.22,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.33,117.89c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,24.33,117.89Z",
    style: {
      fill: "#fff"
    }
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M24.07,117.83a.51.51,0,0,0-.25.06c-.14.08-.14.21,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.67,117.12a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,25.67,117.12Z",
    style: {
      fill: "#fff"
    }
  }), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M25.41,117.06a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.75,
    cy: 116.49,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M26.75,116.28a.51.51,0,0,0-.25.06c-.14.09-.14.22,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.35,115.57c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.15-.09-.15-.22,0-.3A.57.57,0,0,1,28.35,115.57Z",
    style: {
      fill: "#fff"
    }
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M28.09,115.51a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.69,114.8a.15.15,0,0,1,0,.29.59.59,0,0,1-.52,0,.15.15,0,0,1,0-.29A.59.59,0,0,1,29.69,114.8Z",
    style: {
      fill: "#fff"
    }
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M29.43,114.74a.58.58,0,0,0-.26.06.15.15,0,0,0,0,.29.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23,117.12a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,23,117.12Z",
    style: {
      fill: "#fff"
    }
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M22.74,117.06a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.33,116.34c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,24.33,116.34Z",
    style: {
      fill: "#fff"
    }
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M24.07,116.28a.51.51,0,0,0-.25.06c-.14.09-.14.22,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.67,115.57c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,25.67,115.57Z",
    style: {
      fill: "#fff"
    }
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M25.41,115.51a.51.51,0,0,0-.25.06c-.14.08-.14.21,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27,114.8a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,27,114.8Z",
    style: {
      fill: "#fff"
    }
  }), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M26.75,114.74a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.35,114c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.3A.57.57,0,0,1,28.35,114Z",
    style: {
      fill: "#fff"
    }
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M28.09,114a.51.51,0,0,0-.25.06c-.15.09-.15.22,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.65,116.34c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,21.65,116.34Z",
    style: {
      fill: "#fff"
    }
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4,116.28a.53.53,0,0,0-.26.06c-.14.09-.14.22,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.08.14-.21,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23,115.57c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,23,115.57Z",
    style: {
      fill: "#fff"
    }
  }), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M22.74,115.51a.53.53,0,0,0-.26.06c-.14.08-.14.21,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.09.14-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.33,114.8a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,24.33,114.8Z",
    style: {
      fill: "#fff"
    }
  }), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M24.07,114.74a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.67,114c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,25.67,114Z",
    style: {
      fill: "#fff"
    }
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M25.41,114a.51.51,0,0,0-.25.06c-.14.09-.14.22,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.31,115.57c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,20.31,115.57Z",
    style: {
      fill: "#fff"
    }
  }), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M20.06,115.51a.53.53,0,0,0-.26.06c-.14.08-.14.21,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.09.14-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.65,114.8a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,21.65,114.8Z",
    style: {
      fill: "#fff"
    }
  }), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4,114.74a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23,114c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,23,114Z",
    style: {
      fill: "#fff"
    }
  }), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M22.74,114a.53.53,0,0,0-.26.06c-.14.09-.14.22,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.08.14-.21,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.33,113.25a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,24.33,113.25Z",
    style: {
      fill: "#fff"
    }
  }), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M24.07,113.19a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.3,114a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,20.3,114Z",
    style: {
      fill: "#fff"
    }
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M20.05,114a.53.53,0,0,0-.26.07.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.52.52,0,0,0-.25-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.64,113.24a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,21.64,113.24Z",
    style: {
      fill: "#fff"
    }
  }), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M21.38,113.18a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23,112.47c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3a.57.57,0,0,1,.51,0Z",
    style: {
      fill: "#fff"
    }
  }), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M22.72,112.41a.51.51,0,0,0-.25.06c-.14.08-.14.21,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.09.14-.22,0-.3h0a.53.53,0,0,0-.26-.06Zm.22,0Zm0,0Zm0,0,0,0h0l0,0Zm0,0h0l0,0,0,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.3,112.47c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,20.3,112.47Z",
    style: {
      fill: "#fff"
    }
  }), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M20.05,112.41a.53.53,0,0,0-.26.06c-.14.08-.14.21,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.09.14-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.64,112a.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29C21.27,111.61,21.78,111.91,21.64,112Z",
    style: {
      fill: "#fff"
    }
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M21.19,111.68l-.06,0a.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.13-.07-.26-.31-.45-.31Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.47,131.79a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,48.47,131.79Z",
    style: {
      fill: "#fff"
    }
  }), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M48.22,131.72a.44.44,0,0,0-.26.07.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.43.43,0,0,0-.25-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.81,131a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,49.81,131Z",
    style: {
      fill: "#fff"
    }
  }), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M49.56,131a.53.53,0,0,0-.26.06.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.16.16,0,0,0,0-.3.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.15,130.24a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,51.15,130.24Z",
    style: {
      fill: "#fff"
    }
  }), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M50.89,130.18a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.43.43,0,0,0,.25.07.44.44,0,0,0,.26-.07.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.23,
    cy: 129.61,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M52.23,129.4a.52.52,0,0,0-.25.07.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.83,128.69a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0c-.15-.08-.15-.22,0-.3A.57.57,0,0,1,53.83,128.69Z",
    style: {
      fill: "#fff"
    }
  }), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M53.57,128.63a.51.51,0,0,0-.25.06c-.15.08-.15.22,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.17,127.92c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.15-.09-.15-.22,0-.3A.57.57,0,0,1,55.17,127.92Z",
    style: {
      fill: "#fff"
    }
  }), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M54.91,127.86a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.13,131a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,47.13,131Z",
    style: {
      fill: "#fff"
    }
  }), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M46.88,131a.53.53,0,0,0-.26.06.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.16.16,0,0,0,0-.3.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.47,130.24a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,48.47,130.24Z",
    style: {
      fill: "#fff"
    }
  }), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M48.22,130.18a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.44.44,0,0,0,.26.07.43.43,0,0,0,.25-.07.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.81,129.47a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,49.81,129.47Z",
    style: {
      fill: "#fff"
    }
  }), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M49.56,129.4a.53.53,0,0,0-.26.07.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.52.52,0,0,0-.25-.07Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.89,
    cy: 128.84,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M50.89,128.63a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.49,127.92c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,52.49,127.92Z",
    style: {
      fill: "#fff"
    }
  }), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M52.23,127.86a.51.51,0,0,0-.25.06c-.14.08-.14.21,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.83,127.15a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.57.57,0,0,1,53.83,127.15Z",
    style: {
      fill: "#fff"
    }
  }), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M53.57,127.09a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.29a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.79,130.24c.15.08.15.21,0,.29a.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,45.79,130.24Z",
    style: {
      fill: "#fff"
    }
  }), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M45.54,130.18a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.46.46,0,0,0,.26.07.43.43,0,0,0,.25-.07c.15-.08.15-.21,0-.29a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.13,129.47a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,47.13,129.47Z",
    style: {
      fill: "#fff"
    }
  }), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M46.88,129.4a.53.53,0,0,0-.26.07.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.52.52,0,0,0-.25-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.47,128.69a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,48.47,128.69Z",
    style: {
      fill: "#fff"
    }
  }), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M48.22,128.63a.53.53,0,0,0-.26.06.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.16.16,0,0,0,0-.3.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.81,127.92c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,49.81,127.92Z",
    style: {
      fill: "#fff"
    }
  }), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M49.56,127.86a.53.53,0,0,0-.26.06c-.14.08-.14.21,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.09.14-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.15,127.15a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,51.15,127.15Z",
    style: {
      fill: "#fff"
    }
  }), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M50.89,127.09a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.49,126.37c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,52.49,126.37Z",
    style: {
      fill: "#fff"
    }
  }), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M52.23,126.31a.51.51,0,0,0-.25.06c-.14.09-.14.22,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.45,129.47c.15.08.15.21,0,.29a.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,44.45,129.47Z",
    style: {
      fill: "#fff"
    }
  }), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2,129.4a.56.56,0,0,0-.26.07.15.15,0,0,0,0,.29.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.21,0-.29a.52.52,0,0,0-.25-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.79,128.69c.15.08.15.22,0,.3a.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,45.79,128.69Z",
    style: {
      fill: "#fff"
    }
  }), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M45.54,128.63a.55.55,0,0,0-.26.06.16.16,0,0,0,0,.3.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.13,127.92c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,47.13,127.92Z",
    style: {
      fill: "#fff"
    }
  }), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M46.88,127.86a.53.53,0,0,0-.26.06c-.14.08-.14.21,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.09.14-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.47,127.15a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,48.47,127.15Z",
    style: {
      fill: "#fff"
    }
  }), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M48.22,127.09a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.81,126.37c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,49.81,126.37Z",
    style: {
      fill: "#fff"
    }
  }), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M49.56,126.31a.53.53,0,0,0-.26.06c-.14.09-.14.22,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.08.14-.21,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.15,125.6c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,51.15,125.6Z",
    style: {
      fill: "#fff"
    }
  }), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M50.89,125.54a.51.51,0,0,0-.25.06c-.14.08-.14.21,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.12,128.69a.16.16,0,0,1,0,.3.59.59,0,0,1-.52,0,.16.16,0,0,1,0-.3A.59.59,0,0,1,43.12,128.69Z",
    style: {
      fill: "#fff"
    }
  }), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M42.86,128.63a.55.55,0,0,0-.26.06.16.16,0,0,0,0,.3.55.55,0,0,0,.26.06.58.58,0,0,0,.26-.06.16.16,0,0,0,0-.3.58.58,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.45,127.92c.15.08.15.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,44.45,127.92Z",
    style: {
      fill: "#fff"
    }
  }), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2,127.86a.55.55,0,0,0-.26.06c-.14.08-.14.21,0,.3a.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.09.15-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.79,127.15c.15.08.15.21,0,.29a.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,45.79,127.15Z",
    style: {
      fill: "#fff"
    }
  }), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M45.54,127.09a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.21,0-.29a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.13,126.37c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,47.13,126.37Z",
    style: {
      fill: "#fff"
    }
  }), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M46.88,126.31a.53.53,0,0,0-.26.06c-.14.09-.14.22,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.08.14-.21,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.47,125.6c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,48.47,125.6Z",
    style: {
      fill: "#fff"
    }
  }), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M48.22,125.54a.53.53,0,0,0-.26.06c-.14.08-.14.21,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.09.14-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.81,124.83a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,49.81,124.83Z",
    style: {
      fill: "#fff"
    }
  }), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M49.56,124.77a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.51,
    cy: 128.06,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M41.51,127.85a.55.55,0,0,0-.26.06.16.16,0,0,0,0,.3.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.1,127.14c.15.08.15.21,0,.29a.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,43.1,127.14Z",
    style: {
      fill: "#fff"
    }
  }), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M42.85,127.08a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.46.46,0,0,0,.26.07.43.43,0,0,0,.25-.07c.15-.08.15-.21,0-.29a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.44,126.37a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,44.44,126.37Z",
    style: {
      fill: "#fff"
    }
  }), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M44.19,126.3a.44.44,0,0,0-.26.07.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.43.43,0,0,0-.25-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.78,125.59a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,45.78,125.59Z",
    style: {
      fill: "#fff"
    }
  }), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M45.53,125.53a.53.53,0,0,0-.26.06.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.16.16,0,0,0,0-.3.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.12,124.82a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,47.12,124.82Z",
    style: {
      fill: "#fff"
    }
  }), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M46.87,124.76a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.44.44,0,0,0,.26.07.43.43,0,0,0,.25-.07.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.46,124.05a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,48.46,124.05Z",
    style: {
      fill: "#fff"
    }
  }), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2,124a.52.52,0,0,0-.25.07.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.43,127.14a.15.15,0,0,1,0,.29.53.53,0,0,1-.52,0,.15.15,0,0,1,0-.29A.59.59,0,0,1,40.43,127.14Z",
    style: {
      fill: "#fff"
    }
  }), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M40.17,127.08a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.52.52,0,0,0,.52,0,.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.76,126.37c.15.08.15.21,0,.29a.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,41.76,126.37Z",
    style: {
      fill: "#fff"
    }
  }), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M41.51,126.3a.46.46,0,0,0-.26.07.15.15,0,0,0,0,.29.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.21,0-.29a.43.43,0,0,0-.25-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.1,125.59c.15.08.15.22,0,.3a.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,43.1,125.59Z",
    style: {
      fill: "#fff"
    }
  }), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M42.85,125.53a.55.55,0,0,0-.26.06.16.16,0,0,0,0,.3.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.44,124.82a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,44.44,124.82Z",
    style: {
      fill: "#fff"
    }
  }), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M44.19,124.76a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.44.44,0,0,0,.26.07.43.43,0,0,0,.25-.07.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.78,124.05a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,45.78,124.05Z",
    style: {
      fill: "#fff"
    }
  }), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M45.53,124a.53.53,0,0,0-.26.07.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.52.52,0,0,0-.25-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.12,123.27a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,47.12,123.27Z",
    style: {
      fill: "#fff"
    }
  }), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M46.87,123.21a.53.53,0,0,0-.26.06.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.16.16,0,0,0,0-.3.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.09,126.37a.15.15,0,0,1,0,.29.59.59,0,0,1-.52,0,.15.15,0,0,1,0-.29A.53.53,0,0,1,39.09,126.37Z",
    style: {
      fill: "#fff"
    }
  }), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M38.83,126.3a.48.48,0,0,0-.26.07.15.15,0,0,0,0,.29.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.46.46,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.43,125.59a.16.16,0,0,1,0,.3.59.59,0,0,1-.52,0,.16.16,0,0,1,0-.3A.59.59,0,0,1,40.43,125.59Z",
    style: {
      fill: "#fff"
    }
  }), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M40.17,125.53a.55.55,0,0,0-.26.06.16.16,0,0,0,0,.3.59.59,0,0,0,.52,0,.16.16,0,0,0,0-.3.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.51,
    cy: 124.97,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M41.51,124.76a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.46.46,0,0,0,.26.07.43.43,0,0,0,.25-.07c.15-.08.15-.21,0-.29a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.1,124.05c.15.08.15.21,0,.29a.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,43.1,124.05Z",
    style: {
      fill: "#fff"
    }
  }), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M42.85,124a.56.56,0,0,0-.26.07.15.15,0,0,0,0,.29.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.21,0-.29a.52.52,0,0,0-.25-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.44,123.27a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,44.44,123.27Z",
    style: {
      fill: "#fff"
    }
  }), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M44.19,123.21a.53.53,0,0,0-.26.06.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.16.16,0,0,0,0-.3.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.78,122.5c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,45.78,122.5Z",
    style: {
      fill: "#fff"
    }
  }), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M45.53,122.44a.53.53,0,0,0-.26.06c-.14.08-.14.21,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.09.14-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.75,125.59a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0c-.15-.08-.15-.22,0-.3A.57.57,0,0,1,37.75,125.59Z",
    style: {
      fill: "#fff"
    }
  }), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M37.49,125.53a.51.51,0,0,0-.25.06c-.15.08-.15.22,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.16.16,0,0,0,0-.3.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.09,124.82a.15.15,0,0,1,0,.29.53.53,0,0,1-.52,0,.15.15,0,0,1,0-.29A.59.59,0,0,1,39.09,124.82Z",
    style: {
      fill: "#fff"
    }
  }), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M38.83,124.76a.58.58,0,0,0-.26.06.15.15,0,0,0,0,.29.48.48,0,0,0,.26.07.46.46,0,0,0,.26-.07.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.43,124.05a.15.15,0,0,1,0,.29.59.59,0,0,1-.52,0,.15.15,0,0,1,0-.29A.53.53,0,0,1,40.43,124.05Z",
    style: {
      fill: "#fff"
    }
  }), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M40.17,124a.56.56,0,0,0-.26.07.15.15,0,0,0,0,.29.59.59,0,0,0,.52,0,.15.15,0,0,0,0-.29.56.56,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.51,
    cy: 123.42,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M41.51,123.21a.55.55,0,0,0-.26.06.16.16,0,0,0,0,.3.55.55,0,0,0,.26.06.58.58,0,0,0,.26-.06.16.16,0,0,0,0-.3.58.58,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.41,124.82a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.57.57,0,0,1,36.41,124.82Z",
    style: {
      fill: "#fff"
    }
  }), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M36.15,124.76a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.29a.43.43,0,0,0,.25.07.44.44,0,0,0,.26-.07.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.1,122.5c.15.08.15.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,43.1,122.5Z",
    style: {
      fill: "#fff"
    }
  }), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M42.85,122.44a.55.55,0,0,0-.26.06c-.14.08-.14.21,0,.3a.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.09.15-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.44,121.73a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,44.44,121.73Z",
    style: {
      fill: "#fff"
    }
  }), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M44.19,121.67a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.49,
    cy: 124.19,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M37.49,124a.52.52,0,0,0-.25.07c-.15.08-.15.21,0,.29a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.56.56,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.09,123.27a.16.16,0,0,1,0,.3.59.59,0,0,1-.52,0,.16.16,0,0,1,0-.3A.59.59,0,0,1,39.09,123.27Z",
    style: {
      fill: "#fff"
    }
  }), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M38.83,123.21a.58.58,0,0,0-.26.06.16.16,0,0,0,0,.3.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06.16.16,0,0,0,0-.3.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.43,122.5c.14.08.14.21,0,.3a.59.59,0,0,1-.52,0c-.14-.09-.14-.22,0-.3A.59.59,0,0,1,40.43,122.5Z",
    style: {
      fill: "#fff"
    }
  }), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M40.17,122.44a.55.55,0,0,0-.26.06c-.14.08-.14.21,0,.3a.59.59,0,0,0,.52,0c.14-.09.14-.22,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.07,124.05a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,35.07,124.05Z",
    style: {
      fill: "#fff"
    }
  }), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M34.81,124a.52.52,0,0,0-.25.07.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.41,123.27a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0c-.15-.08-.15-.22,0-.3A.57.57,0,0,1,36.41,123.27Z",
    style: {
      fill: "#fff"
    }
  }), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M36.15,123.21a.51.51,0,0,0-.25.06c-.15.08-.15.22,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.76,121.73c.15.08.15.21,0,.29a.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,41.76,121.73Z",
    style: {
      fill: "#fff"
    }
  }), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M41.51,121.67a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.55.55,0,0,0,.26.06.58.58,0,0,0,.26-.06.15.15,0,0,0,0-.29.58.58,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.1,121c.15.09.15.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,43.1,121Z",
    style: {
      fill: "#fff"
    }
  }), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M42.85,120.89a.55.55,0,0,0-.26.06c-.14.09-.14.22,0,.3a.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.21,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.75,122.5c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.15-.09-.15-.22,0-.3A.57.57,0,0,1,37.75,122.5Z",
    style: {
      fill: "#fff"
    }
  }), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M37.49,122.44a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.09,121.73a.15.15,0,0,1,0,.29.59.59,0,0,1-.52,0,.15.15,0,0,1,0-.29A.59.59,0,0,1,39.09,121.73Z",
    style: {
      fill: "#fff"
    }
  }), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M38.83,121.67a.58.58,0,0,0-.26.06.15.15,0,0,0,0,.29.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.47,
    cy: 123.42,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M33.47,123.21a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.07,122.5c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,35.07,122.5Z",
    style: {
      fill: "#fff"
    }
  }), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M34.81,122.44a.51.51,0,0,0-.25.06c-.14.08-.14.21,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.41,121.73a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.57.57,0,0,1,36.41,121.73Z",
    style: {
      fill: "#fff"
    }
  }), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M36.15,121.67a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.29a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.17,
    cy: 121.1,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M40.17,120.89a.55.55,0,0,0-.26.06c-.14.09-.14.22,0,.3a.59.59,0,0,0,.52,0c.14-.08.14-.21,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.51,
    cy: 120.33,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M41.51,120.12a.55.55,0,0,0-.26.06c-.14.08-.14.21,0,.3a.55.55,0,0,0,.26.06.58.58,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.58.58,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.75,121c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.3A.57.57,0,0,1,37.75,121Z",
    style: {
      fill: "#fff"
    }
  }), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M37.49,120.89a.51.51,0,0,0-.25.06c-.15.09-.15.22,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.39,122.5c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,32.39,122.5Z",
    style: {
      fill: "#fff"
    }
  }), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M32.14,122.44a.53.53,0,0,0-.26.06c-.14.08-.14.21,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.09.14-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.73,121.73a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,33.73,121.73Z",
    style: {
      fill: "#fff"
    }
  }), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M33.47,121.67a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.81,
    cy: 121.1,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M34.81,120.89a.51.51,0,0,0-.25.06c-.14.09-.14.22,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.41,120.18c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.15-.09-.15-.22,0-.3A.57.57,0,0,1,36.41,120.18Z",
    style: {
      fill: "#fff"
    }
  }), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M36.15,120.12a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.09,120.18c.14.08.14.21,0,.3a.59.59,0,0,1-.52,0c-.14-.09-.14-.22,0-.3A.59.59,0,0,1,39.09,120.18Z",
    style: {
      fill: "#fff"
    }
  }), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M38.83,120.12a.58.58,0,0,0-.26.06c-.14.08-.14.21,0,.3a.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.43,119.41a.15.15,0,0,1,0,.29.59.59,0,0,1-.52,0,.15.15,0,0,1,0-.29A.59.59,0,0,1,40.43,119.41Z",
    style: {
      fill: "#fff"
    }
  }), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M40.17,119.35a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.59.59,0,0,0,.52,0,.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31,121.72a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,31,121.72Z",
    style: {
      fill: "#fff"
    }
  }), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M30.78,121.66a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.43.43,0,0,0,.25.07A.44.44,0,0,0,31,122a.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.38,121a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,32.38,121Z",
    style: {
      fill: "#fff"
    }
  }), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M32.12,120.88a.43.43,0,0,0-.25.07.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.44.44,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.72,120.17a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,33.72,120.17Z",
    style: {
      fill: "#fff"
    }
  }), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M33.46,120.11a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.06,119.4a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.57.57,0,0,1,35.06,119.4Z",
    style: {
      fill: "#fff"
    }
  }), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8,119.34a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.29a.43.43,0,0,0,.25.07.46.46,0,0,0,.26-.07.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.4,118.63a.15.15,0,0,1,0,.29.59.59,0,0,1-.52,0,.15.15,0,0,1,0-.29A.53.53,0,0,1,36.4,118.63Z",
    style: {
      fill: "#fff"
    }
  }), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M36.14,118.56a.59.59,0,0,0-.26.07.15.15,0,0,0,0,.29.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.56.56,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.75,119.41a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.57.57,0,0,1,37.75,119.41Z",
    style: {
      fill: "#fff"
    }
  }), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M37.49,119.35a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.29a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.7,121a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,29.7,121Z",
    style: {
      fill: "#fff"
    }
  }), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M29.45,120.88a.44.44,0,0,0-.26.07.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.43.43,0,0,0-.25-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31,120.17a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,31,120.17Z",
    style: {
      fill: "#fff"
    }
  }), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M30.78,120.11a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.38,119.4a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,32.38,119.4Z",
    style: {
      fill: "#fff"
    }
  }), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M32.12,119.34a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.43.43,0,0,0,.25.07.44.44,0,0,0,.26-.07.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.72,118.63a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,33.72,118.63Z",
    style: {
      fill: "#fff"
    }
  }), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M33.46,118.56a.52.52,0,0,0-.25.07.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.06,117.85a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0c-.15-.08-.15-.22,0-.3A.57.57,0,0,1,35.06,117.85Z",
    style: {
      fill: "#fff"
    }
  }), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8,117.79a.51.51,0,0,0-.25.06c-.15.08-.15.22,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.16.16,0,0,0,0-.3.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.14,
    cy: 117.23,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M36.14,117a.58.58,0,0,0-.26.06c-.14.08-.14.21,0,.3a.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.36,120.17a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,28.36,120.17Z",
    style: {
      fill: "#fff"
    }
  }), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M28.11,120.11a.53.53,0,0,0-.26.06.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.16.16,0,0,0,0-.3.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.7,119.4a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,29.7,119.4Z",
    style: {
      fill: "#fff"
    }
  }), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M29.45,119.34a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.44.44,0,0,0,.26.07.43.43,0,0,0,.25-.07.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.78,
    cy: 118.77,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M30.78,118.56a.52.52,0,0,0-.25.07.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.38,117.85a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,32.38,117.85Z",
    style: {
      fill: "#fff"
    }
  }), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M32.12,117.79a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.72,117.08c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,33.72,117.08Z",
    style: {
      fill: "#fff"
    }
  }), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M33.46,117a.51.51,0,0,0-.25.06c-.14.08-.14.21,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.06,116.31a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.52.52,0,0,1,35.06,116.31Z",
    style: {
      fill: "#fff"
    }
  }), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8,116.25a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.29a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27,119.4a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,27,119.4Z",
    style: {
      fill: "#fff"
    }
  }), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M26.77,119.34a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.44.44,0,0,0,.26.07.43.43,0,0,0,.25-.07.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.36,118.63a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,28.36,118.63Z",
    style: {
      fill: "#fff"
    }
  }), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M28.11,118.56a.53.53,0,0,0-.26.07.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.52.52,0,0,0-.25-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.7,117.85a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,29.7,117.85Z",
    style: {
      fill: "#fff"
    }
  }), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M29.45,117.79a.53.53,0,0,0-.26.06.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.16.16,0,0,0,0-.3.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31,117.08c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,31,117.08Z",
    style: {
      fill: "#fff"
    }
  }), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M30.78,117a.51.51,0,0,0-.25.06c-.14.08-.14.21,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.38,116.31a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,32.38,116.31Z",
    style: {
      fill: "#fff"
    }
  }), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M32.12,116.25a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.72,115.53c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,33.72,115.53Z",
    style: {
      fill: "#fff"
    }
  }), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M33.46,115.47a.51.51,0,0,0-.25.06c-.14.09-.14.22,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.09,118.63c.14.09.14.22,0,.3a.59.59,0,0,1-.52,0c-.14-.08-.14-.21,0-.3A.59.59,0,0,1,39.09,118.63Z",
    style: {
      fill: "#fff"
    }
  }), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M38.83,118.57a.58.58,0,0,0-.26.06c-.14.09-.14.22,0,.3a.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.74,117.85a.16.16,0,0,1,0,.3.59.59,0,0,1-.52,0,.16.16,0,0,1,0-.3A.59.59,0,0,1,37.74,117.85Z",
    style: {
      fill: "#fff"
    }
  }), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M37.48,117.79a.55.55,0,0,0-.26.06.16.16,0,0,0,0,.3.59.59,0,0,0,.52,0,.16.16,0,0,0,0-.3.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.57,134.76a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,56.57,134.76Z",
    style: {
      fill: "#fff"
    }
  }), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M56.31,134.7a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.91,134a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,57.91,134Z",
    style: {
      fill: "#fff"
    }
  }), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M57.65,133.93a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.43.43,0,0,0,.25.07.44.44,0,0,0,.26-.07.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.25,133.22a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,59.25,133.22Z",
    style: {
      fill: "#fff"
    }
  }), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M59,133.15a.52.52,0,0,0-.25.07.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.33,
    cy: 132.59,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M60.33,132.38a.51.51,0,0,0-.25.06c-.15.08-.15.22,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.16.16,0,0,0,0-.3.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.93,131.67c.14.08.14.21,0,.3a.59.59,0,0,1-.52,0c-.14-.09-.14-.22,0-.3A.59.59,0,0,1,61.93,131.67Z",
    style: {
      fill: "#fff"
    }
  }), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M61.67,131.61a.58.58,0,0,0-.26.06c-.14.08-.14.21,0,.3a.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.88,134.75c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,53.88,134.75Z",
    style: {
      fill: "#fff"
    }
  }), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M53.62,134.69a.51.51,0,0,0-.25.06c-.14.09-.14.22,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.22,134a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,55.22,134Z",
    style: {
      fill: "#fff"
    }
  }), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M55,133.92a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.56,133.21a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,56.56,133.21Z",
    style: {
      fill: "#fff"
    }
  }), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3,133.15a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.9,132.43c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.3A.57.57,0,0,1,57.9,132.43Z",
    style: {
      fill: "#fff"
    }
  }), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M57.64,132.37a.51.51,0,0,0-.25.06c-.15.09-.15.22,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.24,131.66a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0c-.15-.08-.15-.22,0-.3A.57.57,0,0,1,59.24,131.66Z",
    style: {
      fill: "#fff"
    }
  }), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M59,131.6a.51.51,0,0,0-.25.06c-.15.08-.15.22,0,.3A.51.51,0,0,0,59,132a.55.55,0,0,0,.26-.06.16.16,0,0,0,0-.3.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.58,130.89a.15.15,0,0,1,0,.29.53.53,0,0,1-.52,0,.15.15,0,0,1,0-.29A.59.59,0,0,1,60.58,130.89Z",
    style: {
      fill: "#fff"
    }
  }), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M60.32,130.83a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.52.52,0,0,0,.52,0,.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.54,134a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,52.54,134Z",
    style: {
      fill: "#fff"
    }
  }), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M52.29,133.92A.53.53,0,0,0,52,134a.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.16.16,0,0,0,0-.3.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.88,133.21a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,53.88,133.21Z",
    style: {
      fill: "#fff"
    }
  }), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M53.62,133.15a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.22,132.43c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,55.22,132.43Z",
    style: {
      fill: "#fff"
    }
  }), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M55,132.37a.51.51,0,0,0-.25.06c-.14.09-.14.22,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.56,131.66a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,56.56,131.66Z",
    style: {
      fill: "#fff"
    }
  }), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3,131.6a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.9,130.89a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.57.57,0,0,1,57.9,130.89Z",
    style: {
      fill: "#fff"
    }
  }), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M57.64,130.83a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.29a.43.43,0,0,0,.25.07.46.46,0,0,0,.26-.07.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.24,130.12a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.52.52,0,0,1,59.24,130.12Z",
    style: {
      fill: "#fff"
    }
  }), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M59,130.05a.43.43,0,0,0-.25.07c-.15.08-.15.21,0,.29a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.46.46,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.2,133.21a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,51.2,133.21Z",
    style: {
      fill: "#fff"
    }
  }), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M51,133.15a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.54,132.43c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,52.54,132.43Z",
    style: {
      fill: "#fff"
    }
  }), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M52.29,132.37a.53.53,0,0,0-.26.06c-.14.09-.14.22,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.08.14-.21,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.88,131.66a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,53.88,131.66Z",
    style: {
      fill: "#fff"
    }
  }), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M53.62,131.6a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.22,130.89a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,55.22,130.89Z",
    style: {
      fill: "#fff"
    }
  }), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M55,130.83a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.43.43,0,0,0,.25.07.44.44,0,0,0,.26-.07.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.56,130.12a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,56.56,130.12Z",
    style: {
      fill: "#fff"
    }
  }), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3,130.05a.43.43,0,0,0-.25.07.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.44.44,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.9,129.34a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0c-.15-.08-.15-.22,0-.3A.57.57,0,0,1,57.9,129.34Z",
    style: {
      fill: "#fff"
    }
  }), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M57.64,129.28a.51.51,0,0,0-.25.06c-.15.08-.15.22,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.16.16,0,0,0,0-.3.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.86,132.43c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,49.86,132.43Z",
    style: {
      fill: "#fff"
    }
  }), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M49.61,132.37a.53.53,0,0,0-.26.06c-.14.09-.14.22,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.08.14-.21,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.2,131.66a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,51.2,131.66Z",
    style: {
      fill: "#fff"
    }
  }), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M51,131.6a.53.53,0,0,0-.26.06.16.16,0,0,0,0,.3A.53.53,0,0,0,51,132a.51.51,0,0,0,.25-.06.16.16,0,0,0,0-.3.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.54,130.89a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,52.54,130.89Z",
    style: {
      fill: "#fff"
    }
  }), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M52.29,130.83a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.44.44,0,0,0,.26.07.43.43,0,0,0,.25-.07.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.88,130.12a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,53.88,130.12Z",
    style: {
      fill: "#fff"
    }
  }), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M53.62,130.05a.43.43,0,0,0-.25.07.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.44.44,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.22,129.34a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,55.22,129.34Z",
    style: {
      fill: "#fff"
    }
  }), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M55,129.28a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.56,128.57a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,56.56,128.57Z",
    style: {
      fill: "#fff"
    }
  }), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3,128.51a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.43.43,0,0,0,.25.07.44.44,0,0,0,.26-.07.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.51,127.14a.16.16,0,0,1,0,.3.59.59,0,0,1-.52,0,.16.16,0,0,1,0-.3A.59.59,0,0,1,56.51,127.14Z",
    style: {
      fill: "#fff"
    }
  }), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M56.25,127.08a.55.55,0,0,0-.26.06.16.16,0,0,0,0,.3.59.59,0,0,0,.52,0,.16.16,0,0,0,0-.3.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.84,126.37c.15.08.15.21,0,.29a.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,57.84,126.37Z",
    style: {
      fill: "#fff"
    }
  }), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M57.59,126.31a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.46.46,0,0,0,.26.07.43.43,0,0,0,.25-.07c.15-.08.15-.21,0-.29a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.18,125.6c.15.08.15.21,0,.29a.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,59.18,125.6Z",
    style: {
      fill: "#fff"
    }
  }), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M58.93,125.53a.56.56,0,0,0-.26.07.15.15,0,0,0,0,.29.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.21,0-.29a.52.52,0,0,0-.25-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.52,124.82a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,60.52,124.82Z",
    style: {
      fill: "#fff"
    }
  }), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M60.27,124.76a.53.53,0,0,0-.26.06.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.16.16,0,0,0,0-.3.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.86,124.05c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,61.86,124.05Z",
    style: {
      fill: "#fff"
    }
  }), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M61.61,124a.53.53,0,0,0-.26.06c-.14.08-.14.21,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.09.14-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.2,123.28a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,63.2,123.28Z",
    style: {
      fill: "#fff"
    }
  }), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M63,123.22a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.54,122.5c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,64.54,122.5Z",
    style: {
      fill: "#fff"
    }
  }), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M64.28,122.44a.51.51,0,0,0-.25.06c-.14.09-.14.22,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.88,121.73c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,65.88,121.73Z",
    style: {
      fill: "#fff"
    }
  }), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M65.62,121.67a.51.51,0,0,0-.25.06c-.14.08-.14.21,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.22,121a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,67.22,121Z",
    style: {
      fill: "#fff"
    }
  }), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M67,120.9a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.56,120.18c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.3A.57.57,0,0,1,68.56,120.18Z",
    style: {
      fill: "#fff"
    }
  }), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3,120.12a.51.51,0,0,0-.25.06c-.15.09-.15.22,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69.9,119.41a.16.16,0,0,1,0,.3.59.59,0,0,1-.52,0,.16.16,0,0,1,0-.3A.59.59,0,0,1,69.9,119.41Z",
    style: {
      fill: "#fff"
    }
  }), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M69.64,119.35a.58.58,0,0,0-.26.06.16.16,0,0,0,0,.3.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06.16.16,0,0,0,0-.3.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.24,118.64a.15.15,0,0,1,0,.29.53.53,0,0,1-.52,0,.15.15,0,0,1,0-.29A.59.59,0,0,1,71.24,118.64Z",
    style: {
      fill: "#fff"
    }
  }), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M71,118.58a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.59.59,0,0,0,.52,0,.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.17,126.37a.15.15,0,0,1,0,.29.53.53,0,0,1-.52,0,.15.15,0,0,1,0-.29A.59.59,0,0,1,55.17,126.37Z",
    style: {
      fill: "#fff"
    }
  }), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M54.91,126.31a.58.58,0,0,0-.26.06.15.15,0,0,0,0,.29.48.48,0,0,0,.26.07.46.46,0,0,0,.26-.07.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.51,125.6a.15.15,0,0,1,0,.29.59.59,0,0,1-.52,0,.15.15,0,0,1,0-.29A.53.53,0,0,1,56.51,125.6Z",
    style: {
      fill: "#fff"
    }
  }), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M56.25,125.53a.56.56,0,0,0-.26.07.15.15,0,0,0,0,.29.59.59,0,0,0,.52,0,.15.15,0,0,0,0-.29.56.56,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.84,124.82c.15.08.15.22,0,.3a.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,57.84,124.82Z",
    style: {
      fill: "#fff"
    }
  }), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M57.59,124.76a.55.55,0,0,0-.26.06.16.16,0,0,0,0,.3.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.18,124.05c.15.08.15.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,59.18,124.05Z",
    style: {
      fill: "#fff"
    }
  }), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M58.93,124a.55.55,0,0,0-.26.06c-.14.08-.14.21,0,.3a.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.09.15-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.52,123.28a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,60.52,123.28Z",
    style: {
      fill: "#fff"
    }
  }), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M60.27,123.22a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.86,122.5c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,61.86,122.5Z",
    style: {
      fill: "#fff"
    }
  }), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M61.61,122.44a.53.53,0,0,0-.26.06c-.14.09-.14.22,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.08.14-.21,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.2,121.73c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,63.2,121.73Z",
    style: {
      fill: "#fff"
    }
  }), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M63,121.67a.53.53,0,0,0-.26.06c-.14.08-.14.21,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.09.14-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.54,121a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,64.54,121Z",
    style: {
      fill: "#fff"
    }
  }), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M64.28,120.9A.51.51,0,0,0,64,121a.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.88,120.18c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,65.88,120.18Z",
    style: {
      fill: "#fff"
    }
  }), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M65.62,120.12a.51.51,0,0,0-.25.06c-.14.09-.14.22,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.22,119.41a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,67.22,119.41Z",
    style: {
      fill: "#fff"
    }
  }), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M67,119.35a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.56,118.64a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.57.57,0,0,1,68.56,118.64Z",
    style: {
      fill: "#fff"
    }
  }), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3,118.58a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.29a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69.9,117.86c.14.09.14.22,0,.3a.59.59,0,0,1-.52,0c-.14-.08-.14-.21,0-.3A.59.59,0,0,1,69.9,117.86Z",
    style: {
      fill: "#fff"
    }
  }), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M69.64,117.8a.58.58,0,0,0-.26.06c-.14.09-.14.22,0,.3a.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.57,
    cy: 125.74,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M53.57,125.53a.52.52,0,0,0-.25.07c-.15.08-.15.21,0,.29a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.56.56,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.17,124.82a.16.16,0,0,1,0,.3.59.59,0,0,1-.52,0,.16.16,0,0,1,0-.3A.59.59,0,0,1,55.17,124.82Z",
    style: {
      fill: "#fff"
    }
  }), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M54.91,124.76a.58.58,0,0,0-.26.06.16.16,0,0,0,0,.3.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06.16.16,0,0,0,0-.3.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.51,124.05c.14.08.14.21,0,.3a.59.59,0,0,1-.52,0c-.14-.09-.14-.22,0-.3A.59.59,0,0,1,56.51,124.05Z",
    style: {
      fill: "#fff"
    }
  }), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M56.25,124a.55.55,0,0,0-.26.06c-.14.08-.14.21,0,.3a.59.59,0,0,0,.52,0c.14-.09.14-.22,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.84,123.28c.15.08.15.21,0,.29a.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,57.84,123.28Z",
    style: {
      fill: "#fff"
    }
  }), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M57.59,123.22a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.21,0-.29a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.18,122.5c.15.09.15.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,59.18,122.5Z",
    style: {
      fill: "#fff"
    }
  }), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M58.93,122.44a.55.55,0,0,0-.26.06c-.14.09-.14.22,0,.3a.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.21,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.52,121.73c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,60.52,121.73Z",
    style: {
      fill: "#fff"
    }
  }), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M60.27,121.67a.53.53,0,0,0-.26.06c-.14.08-.14.21,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.09.14-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.86,121a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,61.86,121Z",
    style: {
      fill: "#fff"
    }
  }), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M61.61,120.9a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.2,120.18c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,63.2,120.18Z",
    style: {
      fill: "#fff"
    }
  }), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M63,120.12a.53.53,0,0,0-.26.06c-.14.09-.14.22,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.08.14-.21,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.54,119.41a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,64.54,119.41Z",
    style: {
      fill: "#fff"
    }
  }), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M64.28,119.35a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.88,118.64a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,65.88,118.64Z",
    style: {
      fill: "#fff"
    }
  }), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M65.62,118.58a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.22,117.86c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,67.22,117.86Z",
    style: {
      fill: "#fff"
    }
  }), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M67,117.8a.51.51,0,0,0-.25.06c-.14.09-.14.22,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.49,124.82a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0c-.15-.08-.15-.22,0-.3A.57.57,0,0,1,52.49,124.82Z",
    style: {
      fill: "#fff"
    }
  }), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M52.23,124.76a.51.51,0,0,0-.25.06c-.15.08-.15.22,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.83,124.05c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.15-.09-.15-.22,0-.3A.57.57,0,0,1,53.83,124.05Z",
    style: {
      fill: "#fff"
    }
  }), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M53.57,124a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.17,123.28a.15.15,0,0,1,0,.29.59.59,0,0,1-.52,0,.15.15,0,0,1,0-.29A.53.53,0,0,1,55.17,123.28Z",
    style: {
      fill: "#fff"
    }
  }), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M54.91,123.22a.58.58,0,0,0-.26.06.15.15,0,0,0,0,.29.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.51,122.5c.14.09.14.22,0,.3a.59.59,0,0,1-.52,0c-.14-.08-.14-.21,0-.3A.59.59,0,0,1,56.51,122.5Z",
    style: {
      fill: "#fff"
    }
  }), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M56.25,122.44a.55.55,0,0,0-.26.06c-.14.09-.14.22,0,.3a.59.59,0,0,0,.52,0c.14-.08.14-.21,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.84,121.73c.15.08.15.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,57.84,121.73Z",
    style: {
      fill: "#fff"
    }
  }), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M57.59,121.67a.55.55,0,0,0-.26.06c-.14.08-.14.21,0,.3a.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.09.15-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.93,
    cy: 121.11,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M58.93,120.9a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.21,0-.29a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.52,120.18c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,60.52,120.18Z",
    style: {
      fill: "#fff"
    }
  }), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M60.27,120.12a.53.53,0,0,0-.26.06c-.14.09-.14.22,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.08.14-.21,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.86,119.41a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,61.86,119.41Z",
    style: {
      fill: "#fff"
    }
  }), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M61.61,119.35a.53.53,0,0,0-.26.06.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.16.16,0,0,0,0-.3.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.2,118.64a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,63.2,118.64Z",
    style: {
      fill: "#fff"
    }
  }), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M63,118.58a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29A.53.53,0,0,0,63,119a.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.54,117.86c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,64.54,117.86Z",
    style: {
      fill: "#fff"
    }
  }), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M64.28,117.8a.51.51,0,0,0-.25.06c-.14.09-.14.22,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.88,117.09a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,65.88,117.09Z",
    style: {
      fill: "#fff"
    }
  }), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M65.62,117a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.15,124.05c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,51.15,124.05Z",
    style: {
      fill: "#fff"
    }
  }), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M50.89,124a.51.51,0,0,0-.25.06c-.14.08-.14.21,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.49,123.28a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.52.52,0,0,1,52.49,123.28Z",
    style: {
      fill: "#fff"
    }
  }), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M52.23,123.22a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.29a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.83,122.5c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.3A.57.57,0,0,1,53.83,122.5Z",
    style: {
      fill: "#fff"
    }
  }), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M53.57,122.44a.51.51,0,0,0-.25.06c-.15.09-.15.22,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.17,121.73c.14.08.14.21,0,.3a.59.59,0,0,1-.52,0c-.14-.09-.14-.22,0-.3A.59.59,0,0,1,55.17,121.73Z",
    style: {
      fill: "#fff"
    }
  }), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M54.91,121.67a.58.58,0,0,0-.26.06c-.14.08-.14.21,0,.3a.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.51,121a.15.15,0,0,1,0,.29.59.59,0,0,1-.52,0,.15.15,0,0,1,0-.29A.59.59,0,0,1,56.51,121Z",
    style: {
      fill: "#fff"
    }
  }), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M56.25,120.9A.55.55,0,0,0,56,121a.15.15,0,0,0,0,.29.59.59,0,0,0,.52,0,.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.84,120.18c.15.09.15.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,57.84,120.18Z",
    style: {
      fill: "#fff"
    }
  }), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M57.59,120.12a.55.55,0,0,0-.26.06c-.14.09-.14.22,0,.3a.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.21,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.18,119.41c.15.08.15.22,0,.3a.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,59.18,119.41Z",
    style: {
      fill: "#fff"
    }
  }), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M58.93,119.35a.55.55,0,0,0-.26.06.16.16,0,0,0,0,.3.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.52,118.64a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,60.52,118.64Z",
    style: {
      fill: "#fff"
    }
  }), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M60.27,118.58a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.86,117.86c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,61.86,117.86Z",
    style: {
      fill: "#fff"
    }
  }), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M61.61,117.8a.53.53,0,0,0-.26.06c-.14.09-.14.22,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.08.14-.21,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.2,117.09a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,63.2,117.09Z",
    style: {
      fill: "#fff"
    }
  }), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M63,117a.53.53,0,0,0-.26.06.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.16.16,0,0,0,0-.3A.51.51,0,0,0,63,117Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.54,116.32a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,64.54,116.32Z",
    style: {
      fill: "#fff"
    }
  }), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M64.28,116.26a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.43.43,0,0,0,.25.07.44.44,0,0,0,.26-.07.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.8,123.27a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,49.8,123.27Z",
    style: {
      fill: "#fff"
    }
  }), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M49.54,123.21a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.43.43,0,0,0,.25.07.44.44,0,0,0,.26-.07.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.14,122.5a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.52.52,0,0,1,51.14,122.5Z",
    style: {
      fill: "#fff"
    }
  }), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M50.88,122.43a.43.43,0,0,0-.25.07c-.15.08-.15.21,0,.29a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.46.46,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.48,121.72a.16.16,0,0,1,0,.3.59.59,0,0,1-.52,0,.16.16,0,0,1,0-.3A.59.59,0,0,1,52.48,121.72Z",
    style: {
      fill: "#fff"
    }
  }), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M52.22,121.66a.58.58,0,0,0-.26.06.16.16,0,0,0,0,.3.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06.16.16,0,0,0,0-.3.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.82,121a.15.15,0,0,1,0,.29.53.53,0,0,1-.52,0,.15.15,0,0,1,0-.29A.59.59,0,0,1,53.82,121Z",
    style: {
      fill: "#fff"
    }
  }), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M53.56,120.89a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.52.52,0,0,0,.52,0,.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.16,120.18a.15.15,0,0,1,0,.29.59.59,0,0,1-.52,0,.15.15,0,0,1,0-.29A.53.53,0,0,1,55.16,120.18Z",
    style: {
      fill: "#fff"
    }
  }), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9,120.11a.56.56,0,0,0-.26.07.15.15,0,0,0,0,.29.55.55,0,0,0,.26.06.58.58,0,0,0,.26-.06.15.15,0,0,0,0-.29.59.59,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.49,119.4c.15.08.15.22,0,.3a.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,56.49,119.4Z",
    style: {
      fill: "#fff"
    }
  }), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M56.24,119.34a.55.55,0,0,0-.26.06.16.16,0,0,0,0,.3.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.83,118.63c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,57.83,118.63Z",
    style: {
      fill: "#fff"
    }
  }), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M57.58,118.57a.53.53,0,0,0-.26.06c-.14.08-.14.21,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.09.14-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.17,117.86a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,59.17,117.86Z",
    style: {
      fill: "#fff"
    }
  }), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M58.92,117.8a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.51,117.08c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,60.51,117.08Z",
    style: {
      fill: "#fff"
    }
  }), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M60.26,117a.53.53,0,0,0-.26.06c-.14.09-.14.22,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.08.14-.21,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.85,116.31c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,61.85,116.31Z",
    style: {
      fill: "#fff"
    }
  }), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M61.59,116.25a.51.51,0,0,0-.25.06c-.14.08-.14.21,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.19,115.54a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,63.19,115.54Z",
    style: {
      fill: "#fff"
    }
  }), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M62.93,115.48a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.46,122.5a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,48.46,122.5Z",
    style: {
      fill: "#fff"
    }
  }), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2,122.43a.43.43,0,0,0-.25.07.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.44.44,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.8,121.72a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,49.8,121.72Z",
    style: {
      fill: "#fff"
    }
  }), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M49.54,121.66a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.14,121a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.57.57,0,0,1,51.14,121Z",
    style: {
      fill: "#fff"
    }
  }), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M50.88,120.89a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.29a.43.43,0,0,0,.25.07.46.46,0,0,0,.26-.07.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.48,120.18a.15.15,0,0,1,0,.29.59.59,0,0,1-.52,0,.15.15,0,0,1,0-.29A.53.53,0,0,1,52.48,120.18Z",
    style: {
      fill: "#fff"
    }
  }), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M52.22,120.11a.59.59,0,0,0-.26.07.15.15,0,0,0,0,.29.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.56.56,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.82,119.4a.16.16,0,0,1,0,.3.59.59,0,0,1-.52,0,.16.16,0,0,1,0-.3A.59.59,0,0,1,53.82,119.4Z",
    style: {
      fill: "#fff"
    }
  }), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M53.56,119.34a.55.55,0,0,0-.26.06.16.16,0,0,0,0,.3.59.59,0,0,0,.52,0,.16.16,0,0,0,0-.3.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.16,118.63c.14.08.14.21,0,.3a.59.59,0,0,1-.52,0c-.14-.09-.14-.22,0-.3A.59.59,0,0,1,55.16,118.63Z",
    style: {
      fill: "#fff"
    }
  }), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9,118.57a.55.55,0,0,0-.26.06c-.14.08-.14.21,0,.3a.55.55,0,0,0,.26.06.58.58,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.58.58,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.49,117.86c.15.08.15.21,0,.29a.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,56.49,117.86Z",
    style: {
      fill: "#fff"
    }
  }), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M56.24,117.8a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.21,0-.29a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.83,117.08c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,57.83,117.08Z",
    style: {
      fill: "#fff"
    }
  }), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M57.58,117a.53.53,0,0,0-.26.06c-.14.09-.14.22,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.08.14-.21,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.17,116.31c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,59.17,116.31Z",
    style: {
      fill: "#fff"
    }
  }), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M58.92,116.25a.53.53,0,0,0-.26.06c-.14.08-.14.21,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.09.14-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.51,115.54a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,60.51,115.54Z",
    style: {
      fill: "#fff"
    }
  }), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M60.26,115.48a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.12,121.72a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,47.12,121.72Z",
    style: {
      fill: "#fff"
    }
  }), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M46.86,121.66a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.46,121a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,48.46,121Z",
    style: {
      fill: "#fff"
    }
  }), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2,120.89A.51.51,0,0,0,48,121a.15.15,0,0,0,0,.29.43.43,0,0,0,.25.07.44.44,0,0,0,.26-.07.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.8,120.18a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,49.8,120.18Z",
    style: {
      fill: "#fff"
    }
  }), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M49.54,120.11a.52.52,0,0,0-.25.07.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.14,119.4a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0c-.15-.08-.15-.22,0-.3A.57.57,0,0,1,51.14,119.4Z",
    style: {
      fill: "#fff"
    }
  }), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M50.88,119.34a.51.51,0,0,0-.25.06c-.15.08-.15.22,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.16.16,0,0,0,0-.3.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.48,118.63c.14.08.14.21,0,.3a.59.59,0,0,1-.52,0c-.14-.09-.14-.22,0-.3A.59.59,0,0,1,52.48,118.63Z",
    style: {
      fill: "#fff"
    }
  }), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M52.22,118.57a.58.58,0,0,0-.26.06c-.14.08-.14.21,0,.3a.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.82,117.86a.15.15,0,0,1,0,.29.59.59,0,0,1-.52,0,.15.15,0,0,1,0-.29A.53.53,0,0,1,53.82,117.86Z",
    style: {
      fill: "#fff"
    }
  }), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M53.56,117.8a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.59.59,0,0,0,.52,0,.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.16,117.08c.14.09.14.22,0,.3a.59.59,0,0,1-.52,0c-.14-.08-.14-.21,0-.3A.59.59,0,0,1,55.16,117.08Z",
    style: {
      fill: "#fff"
    }
  }), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9,117a.55.55,0,0,0-.26.06c-.14.09-.14.22,0,.3a.55.55,0,0,0,.26.06.58.58,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.58.58,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.49,116.31c.15.08.15.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,56.49,116.31Z",
    style: {
      fill: "#fff"
    }
  }), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M56.24,116.25a.55.55,0,0,0-.26.06c-.14.08-.14.21,0,.3a.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.09.15-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.83,115.54a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,57.83,115.54Z",
    style: {
      fill: "#fff"
    }
  }), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M57.58,115.48a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.78,121a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,45.78,121Z",
    style: {
      fill: "#fff"
    }
  }), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M45.53,120.89a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.44.44,0,0,0,.26.07.43.43,0,0,0,.25-.07.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.12,120.18a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,47.12,120.18Z",
    style: {
      fill: "#fff"
    }
  }), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M46.86,120.11a.52.52,0,0,0-.25.07.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.2,
    cy: 119.55,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2,119.34a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.8,118.63c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,49.8,118.63Z",
    style: {
      fill: "#fff"
    }
  }), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M49.54,118.57a.51.51,0,0,0-.25.06c-.14.08-.14.21,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.14,117.86a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.52.52,0,0,1,51.14,117.86Z",
    style: {
      fill: "#fff"
    }
  }), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M50.88,117.8a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.29a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.48,117.08c.14.09.14.22,0,.3a.59.59,0,0,1-.52,0c-.14-.08-.14-.21,0-.3A.59.59,0,0,1,52.48,117.08Z",
    style: {
      fill: "#fff"
    }
  }), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M52.22,117a.58.58,0,0,0-.26.06c-.14.09-.14.22,0,.3a.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.3,116.31a.59.59,0,0,1,.52,0c.14.08.14.21,0,.3a.59.59,0,0,1-.52,0c-.14-.09-.14-.22,0-.3Z",
    style: {
      fill: "#fff"
    }
  }), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M53.56,116.25a.55.55,0,0,0-.26.06c-.14.08-.14.21,0,.3a.59.59,0,0,0,.52,0c.14-.09.14-.22,0-.3a.55.55,0,0,0-.26-.06Zm-.22,0-.08,0,0,0,0,0Zm-.08,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.44,120.18a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,44.44,120.18Z",
    style: {
      fill: "#fff"
    }
  }), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M44.19,120.11a.53.53,0,0,0-.26.07.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.52.52,0,0,0-.25-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.78,119.4a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,45.78,119.4Z",
    style: {
      fill: "#fff"
    }
  }), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M45.53,119.34a.53.53,0,0,0-.26.06.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.16.16,0,0,0,0-.3.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.12,118.63c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,47.12,118.63Z",
    style: {
      fill: "#fff"
    }
  }), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M46.86,118.57a.51.51,0,0,0-.25.06c-.14.08-.14.21,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.2,
    cy: 118,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2,117.8a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.8,117.08c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,49.8,117.08Z",
    style: {
      fill: "#fff"
    }
  }), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M49.54,117a.51.51,0,0,0-.25.06c-.14.09-.14.22,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.1,119.4a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,43.1,119.4Z",
    style: {
      fill: "#fff"
    }
  }), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M42.85,119.34a.53.53,0,0,0-.26.06.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.16.16,0,0,0,0-.3.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.44,118.63c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,44.44,118.63Z",
    style: {
      fill: "#fff"
    }
  }), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M44.19,118.57a.53.53,0,0,0-.26.06c-.14.08-.14.21,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.09.14-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.78,117.86a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,45.78,117.86Z",
    style: {
      fill: "#fff"
    }
  }), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M45.53,117.8a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.12,117.08c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,47.12,117.08Z",
    style: {
      fill: "#fff"
    }
  }), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M46.86,117a.51.51,0,0,0-.25.06c-.14.09-.14.22,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.76,118.63c.15.08.15.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,41.76,118.63Z",
    style: {
      fill: "#fff"
    }
  }), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M41.51,118.57a.55.55,0,0,0-.26.06c-.14.08-.14.21,0,.3a.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.09.15-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.1,117.86a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,43.1,117.86Z",
    style: {
      fill: "#fff"
    }
  }), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M42.85,117.8a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.44,117.08c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,44.44,117.08Z",
    style: {
      fill: "#fff"
    }
  }), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M44.19,117a.53.53,0,0,0-.26.06c-.14.09-.14.22,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.08.14-.21,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.43,117.86a.15.15,0,0,1,0,.29.59.59,0,0,1-.52,0,.15.15,0,0,1,0-.29A.59.59,0,0,1,40.43,117.86Z",
    style: {
      fill: "#fff"
    }
  }), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M40.17,117.8a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.55.55,0,0,0,.26.06.58.58,0,0,0,.26-.06.15.15,0,0,0,0-.29.58.58,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.76,117.08c.15.09.15.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,41.76,117.08Z",
    style: {
      fill: "#fff"
    }
  }), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M41.51,117a.55.55,0,0,0-.26.06c-.14.09-.14.22,0,.3a.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.21,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.07,117.08c.15.08.15.21,0,.29a.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,39.07,117.08Z",
    style: {
      fill: "#fff"
    }
  }), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M38.82,117a.46.46,0,0,0-.26.07.15.15,0,0,0,0,.29.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.21,0-.29a.43.43,0,0,0-.25-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.41,116.6a.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3C40,116.22,40.55,116.52,40.41,116.6Z",
    style: {
      fill: "#fff"
    }
  }), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M40,116.29H39.9a.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.13-.07-.25-.31-.44-.31Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.74,116.3a.16.16,0,0,1,0,.3.59.59,0,0,1-.52,0,.16.16,0,0,1,0-.3A.59.59,0,0,1,37.74,116.3Z",
    style: {
      fill: "#fff"
    }
  }), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M37.48,116.24a.55.55,0,0,0-.26.06.16.16,0,0,0,0,.3.55.55,0,0,0,.26.06.58.58,0,0,0,.26-.06.16.16,0,0,0,0-.3.58.58,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.27,130.89a.16.16,0,0,1,0,.3.59.59,0,0,1-.52,0,.16.16,0,0,1,0-.3A.59.59,0,0,1,63.27,130.89Z",
    style: {
      fill: "#fff"
    }
  }), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M63,130.83a.55.55,0,0,0-.26.06.16.16,0,0,0,0,.3.55.55,0,0,0,.26.06.58.58,0,0,0,.26-.06.16.16,0,0,0,0-.3.58.58,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.6,130.12c.15.08.15.21,0,.29a.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,64.6,130.12Z",
    style: {
      fill: "#fff"
    }
  }), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M64.35,130.06a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.46.46,0,0,0,.26.07.43.43,0,0,0,.25-.07c.15-.08.15-.21,0-.29a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.94,129.35a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,65.94,129.35Z",
    style: {
      fill: "#fff"
    }
  }), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M65.69,129.28a.53.53,0,0,0-.26.07.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.21,0-.29a.52.52,0,0,0-.25-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.28,128.57a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,67.28,128.57Z",
    style: {
      fill: "#fff"
    }
  }), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M67,128.51a.53.53,0,0,0-.26.06.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.16.16,0,0,0,0-.3.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.62,127.8c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,68.62,127.8Z",
    style: {
      fill: "#fff"
    }
  }), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M68.37,127.74a.53.53,0,0,0-.26.06c-.14.08-.14.21,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.09.14-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70,127a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,70,127Z",
    style: {
      fill: "#fff"
    }
  }), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7,127a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.3,126.25c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,71.3,126.25Z",
    style: {
      fill: "#fff"
    }
  }), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M71,126.19a.51.51,0,0,0-.25.06c-.14.09-.14.22,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.64,125.48c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,72.64,125.48Z",
    style: {
      fill: "#fff"
    }
  }), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M72.38,125.42a.51.51,0,0,0-.25.06c-.14.08-.14.21,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74,124.71a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.57.57,0,0,1,74,124.71Z",
    style: {
      fill: "#fff"
    }
  }), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M73.72,124.65a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.29a.51.51,0,0,0,.25.06A.55.55,0,0,0,74,125a.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.32,123.93c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.3A.57.57,0,0,1,75.32,123.93Z",
    style: {
      fill: "#fff"
    }
  }), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M75.06,123.87a.51.51,0,0,0-.25.06c-.15.09-.15.22,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.66,123.16a.16.16,0,0,1,0,.3.59.59,0,0,1-.52,0,.16.16,0,0,1,0-.3A.59.59,0,0,1,76.66,123.16Z",
    style: {
      fill: "#fff"
    }
  }), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4,123.1a.55.55,0,0,0-.26.06.16.16,0,0,0,0,.3.59.59,0,0,0,.52,0,.16.16,0,0,0,0-.3.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M78,122.39a.15.15,0,0,1,0,.29.53.53,0,0,1-.52,0,.15.15,0,0,1,0-.29A.59.59,0,0,1,78,122.39Z",
    style: {
      fill: "#fff"
    }
  }), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M77.74,122.33a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.55.55,0,0,0,.26.06.58.58,0,0,0,.26-.06.15.15,0,0,0,0-.29.58.58,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.66,
    cy: 130.26,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M61.66,130.05a.55.55,0,0,0-.26.06.16.16,0,0,0,0,.3.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 63,
    cy: 129.49,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M63,129.28a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.21,0-.29a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.59,128.56c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,64.59,128.56Z",
    style: {
      fill: "#fff"
    }
  }), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M64.34,128.5a.53.53,0,0,0-.26.06c-.14.09-.14.22,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.08.14-.21,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.93,127.79a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,65.93,127.79Z",
    style: {
      fill: "#fff"
    }
  }), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M65.68,127.73a.53.53,0,0,0-.26.06.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.16.16,0,0,0,0-.3.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.27,127a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,67.27,127Z",
    style: {
      fill: "#fff"
    }
  }), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M67,127a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.43.43,0,0,0,.25.07.44.44,0,0,0,.26-.07.15.15,0,0,0,0-.29A.53.53,0,0,0,67,127Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.61,126.25a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,68.61,126.25Z",
    style: {
      fill: "#fff"
    }
  }), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M68.35,126.18a.43.43,0,0,0-.25.07.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.44.44,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70,125.47a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,70,125.47Z",
    style: {
      fill: "#fff"
    }
  }), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M69.69,125.41a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.03,
    cy: 124.85,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M71,124.64a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.29a.43.43,0,0,0,.25.07.46.46,0,0,0,.26-.07.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.63,123.93a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.52.52,0,0,1,72.63,123.93Z",
    style: {
      fill: "#fff"
    }
  }), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M72.37,123.86a.52.52,0,0,0-.25.07c-.15.08-.15.21,0,.29a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.56.56,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74,123.15a.16.16,0,0,1,0,.3.59.59,0,0,1-.52,0,.16.16,0,0,1,0-.3A.59.59,0,0,1,74,123.15Z",
    style: {
      fill: "#fff"
    }
  }), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M73.71,123.09a.58.58,0,0,0-.26.06.16.16,0,0,0,0,.3.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06.16.16,0,0,0,0-.3.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.31,122.38c.14.08.14.21,0,.3a.59.59,0,0,1-.52,0c-.14-.09-.14-.22,0-.3A.59.59,0,0,1,75.31,122.38Z",
    style: {
      fill: "#fff"
    }
  }), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M75.05,122.32a.55.55,0,0,0-.26.06c-.14.08-.14.21,0,.3a.55.55,0,0,0,.26.06.58.58,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.58.58,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.64,121.61c.15.08.15.21,0,.29a.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,76.64,121.61Z",
    style: {
      fill: "#fff"
    }
  }), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M76.39,121.55a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.21,0-.29a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M78,120.83c.15.09.15.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,78,120.83Z",
    style: {
      fill: "#fff"
    }
  }), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M77.73,120.77a.55.55,0,0,0-.26.06c-.14.09-.14.22,0,.3a.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.21,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.58,129.34a.15.15,0,0,1,0,.29.53.53,0,0,1-.52,0,.15.15,0,0,1,0-.29A.59.59,0,0,1,60.58,129.34Z",
    style: {
      fill: "#fff"
    }
  }), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M60.32,129.28a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.55.55,0,0,0,.26.06.58.58,0,0,0,.26-.06.15.15,0,0,0,0-.29.58.58,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.66,
    cy: 128.71,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M61.66,128.5a.55.55,0,0,0-.26.06c-.14.09-.14.22,0,.3a.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.21,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 63,
    cy: 127.94,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M63,127.73a.53.53,0,0,0-.26.06.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.59,127a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,64.59,127Z",
    style: {
      fill: "#fff"
    }
  }), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M64.34,127a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.44.44,0,0,0,.26.07.43.43,0,0,0,.25-.07.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.93,126.25a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,65.93,126.25Z",
    style: {
      fill: "#fff"
    }
  }), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M65.68,126.18a.44.44,0,0,0-.26.07.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.43.43,0,0,0-.25-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.27,125.47a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,67.27,125.47Z",
    style: {
      fill: "#fff"
    }
  }), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M67,125.41a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.61,124.7a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,68.61,124.7Z",
    style: {
      fill: "#fff"
    }
  }), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M68.35,124.64a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.43.43,0,0,0,.25.07.44.44,0,0,0,.26-.07.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70,123.93a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,70,123.93Z",
    style: {
      fill: "#fff"
    }
  }), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M69.69,123.86a.52.52,0,0,0-.25.07.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.29,123.15a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0c-.15-.08-.15-.22,0-.3A.57.57,0,0,1,71.29,123.15Z",
    style: {
      fill: "#fff"
    }
  }), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M71,123.09a.51.51,0,0,0-.25.06c-.15.08-.15.22,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.16.16,0,0,0,0-.3.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.63,122.38c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.15-.09-.15-.22,0-.3A.57.57,0,0,1,72.63,122.38Z",
    style: {
      fill: "#fff"
    }
  }), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M72.37,122.32a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74,121.61a.15.15,0,0,1,0,.29.59.59,0,0,1-.52,0,.15.15,0,0,1,0-.29A.53.53,0,0,1,74,121.61Z",
    style: {
      fill: "#fff"
    }
  }), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M73.71,121.55a.58.58,0,0,0-.26.06.15.15,0,0,0,0,.29.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.31,120.83c.14.09.14.22,0,.3a.59.59,0,0,1-.52,0c-.14-.08-.14-.21,0-.3A.59.59,0,0,1,75.31,120.83Z",
    style: {
      fill: "#fff"
    }
  }), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M75.05,120.77a.55.55,0,0,0-.26.06c-.14.09-.14.22,0,.3a.55.55,0,0,0,.26.06.58.58,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.58.58,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.64,120.06c.15.08.15.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,76.64,120.06Z",
    style: {
      fill: "#fff"
    }
  }), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M76.39,120a.55.55,0,0,0-.26.06c-.14.08-.14.21,0,.3a.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.09.15-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.24,128.56c.14.09.14.22,0,.3a.59.59,0,0,1-.52,0c-.14-.08-.14-.21,0-.3A.59.59,0,0,1,59.24,128.56Z",
    style: {
      fill: "#fff"
    }
  }), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M59,128.5a.55.55,0,0,0-.26.06c-.14.09-.14.22,0,.3a.59.59,0,0,0,.52,0c.14-.08.14-.21,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.58,127.79a.16.16,0,0,1,0,.3.59.59,0,0,1-.52,0,.16.16,0,0,1,0-.3A.59.59,0,0,1,60.58,127.79Z",
    style: {
      fill: "#fff"
    }
  }), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M60.32,127.73a.55.55,0,0,0-.26.06.16.16,0,0,0,0,.3.55.55,0,0,0,.26.06.58.58,0,0,0,.26-.06.16.16,0,0,0,0-.3.58.58,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.66,
    cy: 127.17,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M61.66,127a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.46.46,0,0,0,.26.07.43.43,0,0,0,.25-.07c.15-.08.15-.21,0-.29a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.25,126.25c.15.08.15.21,0,.29a.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,63.25,126.25Z",
    style: {
      fill: "#fff"
    }
  }), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M63,126.18a.44.44,0,0,0-.26.07.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.21,0-.29a.43.43,0,0,0-.25-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.59,125.47a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,64.59,125.47Z",
    style: {
      fill: "#fff"
    }
  }), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M64.34,125.41a.53.53,0,0,0-.26.06.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.16.16,0,0,0,0-.3.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.93,124.7a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,65.93,124.7Z",
    style: {
      fill: "#fff"
    }
  }), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M65.68,124.64a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.44.44,0,0,0,.26.07.43.43,0,0,0,.25-.07.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.27,123.93a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,67.27,123.93Z",
    style: {
      fill: "#fff"
    }
  }), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M67,123.86a.52.52,0,0,0-.25.07.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.61,123.15a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,68.61,123.15Z",
    style: {
      fill: "#fff"
    }
  }), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M68.35,123.09a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70,122.38c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,70,122.38Z",
    style: {
      fill: "#fff"
    }
  }), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M69.69,122.32a.51.51,0,0,0-.25.06c-.14.08-.14.21,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.29,121.61a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.52.52,0,0,1,71.29,121.61Z",
    style: {
      fill: "#fff"
    }
  }), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M71,121.55a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.29A.51.51,0,0,0,71,122a.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.63,120.83c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.3A.57.57,0,0,1,72.63,120.83Z",
    style: {
      fill: "#fff"
    }
  }), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M72.37,120.77a.51.51,0,0,0-.25.06c-.15.09-.15.22,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74,120.06c.14.08.14.21,0,.3a.59.59,0,0,1-.52,0c-.14-.09-.14-.22,0-.3A.59.59,0,0,1,74,120.06Z",
    style: {
      fill: "#fff"
    }
  }), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M73.71,120a.58.58,0,0,0-.26.06c-.14.08-.14.21,0,.3a.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "75.18 119.49 75.27 119.33 75.47 119.09 75.18 119.5 75.18 119.49",
    style: {
      fill: "#fff"
    }
  }), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M75.05,119.23a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.55.55,0,0,0,.26.06.58.58,0,0,0,.26-.06.15.15,0,0,0,0-.29h0a.66.66,0,0,0-.25,0Zm.21,0,0,0h0l0,0Zm0,0h0l0,0,0,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.9,127.79a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0c-.15-.08-.15-.22,0-.3A.57.57,0,0,1,57.9,127.79Z",
    style: {
      fill: "#fff"
    }
  }), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M57.64,127.73a.51.51,0,0,0-.25.06c-.15.08-.15.22,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.16.16,0,0,0,0-.3.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.24,127a.15.15,0,0,1,0,.29.53.53,0,0,1-.52,0,.15.15,0,0,1,0-.29A.59.59,0,0,1,59.24,127Z",
    style: {
      fill: "#fff"
    }
  }), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M59,127a.58.58,0,0,0-.26.06.15.15,0,0,0,0,.29.52.52,0,0,0,.52,0,.15.15,0,0,0,0-.29A.55.55,0,0,0,59,127Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.58,126.25a.15.15,0,0,1,0,.29.59.59,0,0,1-.52,0,.15.15,0,0,1,0-.29A.53.53,0,0,1,60.58,126.25Z",
    style: {
      fill: "#fff"
    }
  }), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M60.32,126.18a.46.46,0,0,0-.26.07.15.15,0,0,0,0,.29.55.55,0,0,0,.26.06.58.58,0,0,0,.26-.06.15.15,0,0,0,0-.29.48.48,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.91,125.47c.15.08.15.22,0,.3a.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,61.91,125.47Z",
    style: {
      fill: "#fff"
    }
  }), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M61.66,125.41a.55.55,0,0,0-.26.06.16.16,0,0,0,0,.3.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.25,124.7c.15.08.15.21,0,.29a.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,63.25,124.7Z",
    style: {
      fill: "#fff"
    }
  }), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M63,124.64a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.44.44,0,0,0,.26.07.43.43,0,0,0,.25-.07c.15-.08.15-.21,0-.29a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.59,123.93a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,64.59,123.93Z",
    style: {
      fill: "#fff"
    }
  }), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M64.34,123.86a.53.53,0,0,0-.26.07.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.52.52,0,0,0-.25-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.93,123.15a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,65.93,123.15Z",
    style: {
      fill: "#fff"
    }
  }), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M65.68,123.09a.53.53,0,0,0-.26.06.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.16.16,0,0,0,0-.3.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.27,122.38c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,67.27,122.38Z",
    style: {
      fill: "#fff"
    }
  }), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M67,122.32a.51.51,0,0,0-.25.06c-.14.08-.14.21,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.61,121.61a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,68.61,121.61Z",
    style: {
      fill: "#fff"
    }
  }), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M68.35,121.55a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70,120.83c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,70,120.83Z",
    style: {
      fill: "#fff"
    }
  }), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M69.69,120.77a.51.51,0,0,0-.25.06c-.14.09-.14.22,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.29,120.06c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.15-.09-.15-.22,0-.3A.57.57,0,0,1,71.29,120.06Z",
    style: {
      fill: "#fff"
    }
  }), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M71,120a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06c.14-.09.14-.22,0-.3A.55.55,0,0,0,71,120Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.63,119.29a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.57.57,0,0,1,72.63,119.29Z",
    style: {
      fill: "#fff"
    }
  }), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M72.37,119.23a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.29a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74,118.51c.14.09.14.22,0,.3a.59.59,0,0,1-.52,0c-.14-.08-.14-.21,0-.3A.59.59,0,0,1,74,118.51Z",
    style: {
      fill: "#fff"
    }
  }), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M73.71,118.45a.58.58,0,0,0-.26.06c-.14.09-.14.22,0,.3a.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "37.45 99.96 37.45 101.87 71.87 121.68 71.87 119.83 37.45 99.96",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.87 119.83 37.45 99.96 41.56 97.58 75.98 117.46 71.87 119.83",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.45,101.87V100l4.11-2.38L76,117.46v1.85l-4.11,2.38Zm0,0,34.41,19.81v-1.85L37.45,100Zm0-1.91,34.42,19.87L76,117.46,41.56,97.59Z",
    style: {
      fill: "#fff"
    }
  }), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M75.73,117.89v1.28l-3.62,2.08h0V120h0l2.62-1.51,1-.57h0M41.56,97.29l-4.11,2.38-.25.15V102l34.41,19.82.26.14.25-.14,4.11-2.37v-2.15l-.25-.14L41.69,97.37l-.13-.08Zm30.31,22.25-12.22-7.05L38,100l3.61-2.08,33.92,19.58-1,.57-2.62,1.51Zm-.26,1.71L37.7,101.72V100.4L71.61,120v1.27Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "31.83 102.97 31.83 104.88 66.25 124.7 66.25 122.85 31.83 102.97",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.25 122.85 31.83 102.97 35.94 100.6 70.36 120.47 66.25 122.85",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.83,104.88V103l4.11-2.37,34.42,19.87v1.86l-4.11,2.37Zm0,0,34.41,19.81v-1.84L31.83,103Zm0-1.9,34.41,19.86,4.12-2.37L35.94,100.6Z",
    style: {
      fill: "#fff"
    }
  }), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M70.11,120.9v1.28l-3.62,2.09h0V123h0l2.63-1.51,1-.58h0M35.94,100.31l-4.11,2.37-.25.15V105L66,124.84l.26.15.25-.15,4.11-2.37v-2.14l-.25-.15-34.29-19.8-.13-.07Zm30.3,22.25L54,115.5,32.33,103l3.61-2.09,33.92,19.58-1,.57-2.63,1.52Zm-.25,1.7L32.08,104.74v-1.33L66,123v1.27Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "26.21 106.22 26.21 108.13 60.63 127.95 60.63 126.1 26.21 106.22",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.63 126.1 26.21 106.22 30.32 103.85 64.74 123.72 60.63 126.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.21,108.13v-1.91l4.11-2.37,34.42,19.87v1.86L60.63,128Zm0,0,34.41,19.81V126.1L26.21,106.23Zm0-1.9,34.42,19.86,4.11-2.37L30.32,103.85Z",
    style: {
      fill: "#fff"
    }
  }), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M64.49,124.15v1.28l-3.62,2.09h0v-1.27h0l2.62-1.51,1-.58h0M30.32,103.56l-4.11,2.37-.25.15v2.2l34.41,19.81.26.15.25-.15L65,125.72v-2.14l-.25-.15-34.29-19.8-.13-.07Zm30.31,22.25-12.22-7.06-21.7-12.52,3.61-2.09,33.92,19.58-1,.57-2.62,1.52Zm-.26,1.7L26.46,108v-1.33l33.91,19.58v1.27Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "20.59 109.48 20.59 111.39 55.01 131.21 55.01 129.36 20.59 109.48 20.59 109.48",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.01 129.36 20.59 109.48 24.7 107.11 59.12 126.98 55.01 129.36",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.59,111.39v-1.91l4.12-2.37L59.12,127v1.86L55,131.21Zm0,0L55,131.2v-1.84L20.59,109.49Zm0-1.9L55,129.35,59.12,127,24.7,107.11Z",
    style: {
      fill: "#fff"
    }
  }), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M58.87,127.41v1.28l-3.62,2.09h0V129.5h0L57.88,128l1-.57h0M24.7,106.82l-4.11,2.37-.25.15v2.2l34.41,19.81.26.15.25-.15L59.37,129v-2.15l-.25-.14-34.29-19.8-.13-.07ZM55,129.07,42.79,122l-21.7-12.53,3.61-2.08L58.62,127l-1,.57L55,129.07Zm-.26,1.7L20.84,111.25v-1.33L54.75,129.5v1.27Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "37.45 93.96 37.45 95.87 71.86 115.69 71.86 113.83 37.45 93.96",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.86 113.83 37.45 93.96 41.56 91.59 75.98 111.46 71.86 113.83",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.45,95.87V94l4.12-2.38L76,111.46v1.85l-4.11,2.38Zm0,0,34.41,19.81v-1.84L37.45,94Zm0-1.91,34.42,19.87L76,111.46,41.56,91.59Z",
    style: {
      fill: "#fff"
    }
  }), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M75.73,111.89v1.28l-3.62,2.09h0V114h0l2.62-1.52,1-.57h0M41.56,91.3l-4.11,2.37-.25.15V96l34.41,19.81.26.15.25-.15,4.11-2.37v-2.15l-.25-.14L41.69,91.37l-.13-.07Zm30.31,22.24-12.22-7.05L38,94l3.61-2.08,33.92,19.58-1,.57-2.62,1.51Zm-.26,1.71L37.7,95.72V94.4L71.61,114v1.27Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "31.83 96.98 31.83 98.88 66.25 118.7 66.25 116.85 31.83 96.98",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.25 116.85 31.83 96.98 35.94 94.6 70.36 114.47 66.25 116.85",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.82,98.89V97l4.12-2.38,34.42,19.87v1.86l-4.11,2.37Zm0,0L66.24,118.7v-1.85L31.83,97Zm0-1.9,34.41,19.87,4.12-2.38L35.94,94.6Z",
    style: {
      fill: "#fff"
    }
  }), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M70.11,114.9v1.28l-3.62,2.09h0V117h0l2.63-1.51,1-.57h0M35.94,94.31l-4.11,2.38-.26.14V99L66,118.84l.26.15.25-.15,4.11-2.37v-2.14l-.25-.15L36.07,94.38l-.13-.07Zm30.3,22.25L54,109.5,32.33,97l3.61-2.09,33.92,19.58-1,.57-2.63,1.52Zm-.25,1.7L32.08,98.74V97.41L66,117v1.27Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "26.21 100.23 26.21 102.14 60.63 121.95 60.63 120.1 26.21 100.23",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "20.59 103.49 20.59 105.39 55.01 125.21 55.01 123.36 20.59 103.49",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.63 120.1 26.21 100.23 30.32 97.85 64.74 117.72 60.63 120.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.21,102.14v-1.91l4.11-2.38,34.42,19.87v1.86L60.63,122Zm0,0L60.62,122V120.1L26.21,100.23Zm0-1.9L60.63,120.1l4.11-2.38L30.32,97.85Z",
    style: {
      fill: "#fff"
    }
  }), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M64.49,118.15v1.28l-3.62,2.09h0v-1.27h0l2.63-1.51,1-.57h0M30.32,97.56l-4.11,2.38-.25.14v2.2l34.41,19.81.26.15.25-.15L65,119.72v-2.14l-.25-.15L30.45,97.63l-.13-.07Zm30.3,22.25-12.21-7.06-21.7-12.52,3.61-2.09,33.92,19.58-1,.57-2.63,1.52Zm-.25,1.7L26.46,102v-1.33l33.91,19.58v1.27Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "55.01 123.36 20.59 103.49 24.7 101.11 59.12 120.98 55.01 123.36",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.59,105.4v-1.91l4.11-2.38L59.12,121v1.86L55,125.21Zm0,0L55,125.21v-1.85L20.59,103.49Zm0-1.9L55,123.36,59.12,121,24.7,101.11Z",
    style: {
      fill: "#fff"
    }
  }), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M58.87,121.41v1.28l-3.62,2.09h0V123.5h0L57.88,122l1-.58h0M24.7,100.82l-4.11,2.38-.25.14v2.2l34.41,19.81.26.15.25-.15L59.37,123v-2.14l-.25-.15-34.29-19.8-.13-.07ZM55,123.07,42.79,116l-21.7-12.52,3.61-2.09L58.62,121l-1,.57L55,123.07Zm-.25,1.7L20.84,105.25v-1.33L54.75,123.5v1.27Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "45.69 124.01 45.69 119.83 50.9 122.85 50.9 126.99 45.69 124.01",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.69,124v-4.18l5.21,3v.29l3.1,1.78-3.1,1.78V127Zm0,0,5.21,3v-4.13l-5.21-3Z",
    style: {
      fill: "#fff"
    }
  }), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M51.15,123.57l2.35,1.35-2.35,1.35v-2.7m-5.71-4.17v4.76l5.71,3.26v-.58l3.35-1.92L51.15,123v-.29l-5.71-3.3Zm5.21,7.15-4.71-2.69v-3.59L50.65,123v3.56Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "24.24 111.57 24.24 107.5 29.45 110.54 29.45 114.6 24.24 111.57",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.24,111.57v-4.08l5.21,3.05v.21l3.1,1.78-3.1,1.78v.29Zm0,0,5.21,3v-4.06l-5.21-3Z",
    style: {
      fill: "#fff"
    }
  }), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7,111.18l2.35,1.35-2.35,1.35v-2.7M24,107.06v4.65L29.7,115v-.59l3.35-1.92L29.7,110.6v-.2L24,107.06Zm5.21,7.1-4.71-2.74v-3.48l4.71,2.75v3.47Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "34.71 117.6 34.71 113.54 39.92 116.58 39.92 120.64 34.71 117.6",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.71,117.61v-4.08l5.22,3v.21L43,118.57l-3.09,1.78v.29Zm0,0,5.21,3v-4l-5.21-3Z",
    style: {
      fill: "#fff"
    }
  }), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M40.17,117.22l2.35,1.35-2.35,1.35v-2.7m-5.71-4.12v4.65l5.72,3.33v-.59l3.34-1.92-3.34-1.93v-.2l-5.72-3.34Zm5.21,7.1L35,117.46V114l4.71,2.74v3.48Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "30.37 102.3 30.37 91.84 39.42 97.07 39.42 107.53 30.37 102.3",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.62 91.41 39.67 86.18 48.73 91.41 39.67 96.64 30.62 91.41",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.09,102.46V91.4l.16-.1,9.42-5.44,9.59,5.53v11.07L39.67,108Zm.06,0,9.49,5.48v-11l-9.49-5.48Zm0-11,9.49,5.48,9.5-5.48-9.5-5.48Z",
    style: {
      fill: "#111"
    }
  }), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M49,91.79v10.53l-9.12,5.26V97.05l0,0,4.48-2.58,4.52-2.61.09,0m-9.34-6.22-9.55,5.51-.28.18v11.35l9.55,5.51.28.16.28-.16,9.56-5.51V91.25l-9.84-5.68Zm0,11-1.41-.81-7.58-4.38,9-5.19,9,5.19L44.15,94,39.67,96.6Zm-.28,10.87-9-5.19V91.9l9,5.19v10.38Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "39.11 111.28 39.11 93.65 54.38 84.84 69.4 93.51 54.13 102.37 54.13 119.95 39.11 111.28",
    style: {
      fill: "#fff"
    }
  }), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M54.38,85.12,68.9,93.51l-14.77,8.57-.25.14v17.3l-14.52-8.38V93.79l15-8.67m0-.57-15.52,9h0v17.92l15.52,8.95V102.51l15.52-9-15.52-9Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.8,111.46v-18l15.58-9,15.58,9v18l-15.58,9Zm.12-.07,15.4,8.89V102.5l-15.4-8.89Zm15.46-9,15.4-8.89-7.61-4.39-7.79-4.5L39,93.51l7.61,4.39Z",
    style: {
      fill: "#111"
    }
  }), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M69.71,93.83v17.49l-15.14,8.74V102.57l.06,0,6.31-3.65,8.59-5,.18-.11M54.38,84.19,38.6,93.3l-.05,0h0v.35h0V111.6l15.52,9,.31.18.31-.18,15.36-8.87.16-.09V93.69h0v-.36L54.38,84.19ZM46.77,97.72l-7.29-4.21,14.9-8.6,7.29,4.21-14.9,8.6Zm7.61,4.39-7.3-4.21L62,89.3l7.3,4.21-8.59,4.95-6.31,3.65Zm-.31,17.74-14.9-8.6V94l14.9,8.6v17.21Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.42,105.36a.79.79,0,0,1-.39-.12l-2.88-1.66a2.26,2.26,0,0,1-.94-1.8.88.88,0,0,1,.34-.79.6.6,0,0,1,.27-.07.79.79,0,0,1,.39.12l2.88,1.66a2.26,2.26,0,0,1,.94,1.8.88.88,0,0,1-.34.79A.5.5,0,0,1,48.42,105.36Zm-3.81-4.26a.74.74,0,0,0-.28.68,2.09,2.09,0,0,0,.88,1.69l2.88,1.67a.76.76,0,0,0,.33.1h.07l.13,0a.7.7,0,0,0,.28-.61v-.15l-2.59-1.5a2.09,2.09,0,0,1-.85-1.48v-.13l-.31-.17a.65.65,0,0,0-.33-.11h-.07Z",
    style: {
      fill: "#fff"
    }
  }), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M45.76,101.65l2.2,1.27a1.87,1.87,0,0,1,.75,1.1l-2.26-1.31a1.68,1.68,0,0,1-.69-1.06m-.94-1a.77.77,0,0,0-.39.11,1.1,1.1,0,0,0-.47,1,2.52,2.52,0,0,0,1.06,2l2.88,1.66a1.06,1.06,0,0,0,.52.15.87.87,0,0,0,.39-.1,1.12,1.12,0,0,0,.47-1,2.48,2.48,0,0,0-1.07-2l-2.87-1.67a1.09,1.09,0,0,0-.52-.15Zm3.6,4.32a.52.52,0,0,1-.21-.07l-2.87-1.66a1.88,1.88,0,0,1-.76-1.48.58.58,0,0,1,.16-.47l.08,0a.4.4,0,0,1,.2.07l.2.12a2.35,2.35,0,0,0,1,1.67l2.46,1.42c0,.23-.09.36-.16.4l-.08,0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M48.67,33l-48,27.7,48,27.71,48-27.71Zm48,27.7-48,27.71v55.4l48-27.7Zm-48,27.71L.69,60.71v55.41l48,27.7Z",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "MARKETING"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "104.5 65.36 152.48 93.07 152.48 148.47 104.5 176.18 56.52 148.47 56.52 93.07 104.5 65.36",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.62,148.59,104.44,121m.18-.87V65.59m0,55.18,47.54,27.6",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.31,151.94a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,107.31,151.94Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.81,151.07a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.58.58,0,0,1,108.81,151.07Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.31,150.2a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.6.6,0,0,1,107.31,150.2Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.33,150.21a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,110.33,150.21Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.24,149.34a.66.66,0,0,1,.58,0,.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0A.17.17,0,0,1,108.24,149.34Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.73,148.47a.63.63,0,0,1,.58,0,.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0A.17.17,0,0,1,106.73,148.47Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.86,154.51a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,114.86,154.51Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.85,154.51a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,111.85,154.51Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.35,153.64a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,113.35,153.64Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.34,153.64a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,110.34,153.64Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.85,152.77a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.6.6,0,0,1,111.85,152.77Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.83,152.77a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.6.6,0,0,1,108.83,152.77Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.34,151.9a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.6.6,0,0,1,110.34,151.9Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.8,153.65a.64.64,0,0,1,.57,0,.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0A.17.17,0,0,1,115.8,153.65Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.88,152.78a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,117.88,152.78Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.39,151.91a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,119.39,151.91Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.9,151a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.6.6,0,0,1,120.9,151Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.41,150.17a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.6.6,0,0,1,122.41,150.17Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.91,149.3a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.58.58,0,0,1,123.91,149.3Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.29,152.78a.64.64,0,0,1,.57,0,.18.18,0,0,1,0,.33.66.66,0,0,1-.58,0A.17.17,0,0,1,114.29,152.78Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.37,151.91a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,116.37,151.91Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.88,151a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.58.58,0,0,1,117.88,151Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.39,150.17a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.6.6,0,0,1,119.39,150.17Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.9,149.3a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.6.6,0,0,1,120.9,149.3Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.41,148.42c.16.1.16.25,0,.34a.66.66,0,0,1-.58,0c-.16-.09-.16-.24,0-.34A.66.66,0,0,1,122.41,148.42Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.91,147.55c.16.1.16.25,0,.34a.64.64,0,0,1-.57,0c-.16-.09-.16-.24,0-.34A.64.64,0,0,1,123.91,147.55Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.78,151.91a.66.66,0,0,1,.58,0,.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0A.17.17,0,0,1,112.78,151.91Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.87,151a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.6.6,0,0,1,114.87,151Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.37,150.17a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.58.58,0,0,1,116.37,150.17Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.88,149.3a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.58.58,0,0,1,117.88,149.3Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.39,148.42c.16.1.16.25,0,.34a.66.66,0,0,1-.58,0c-.16-.09-.16-.24,0-.34A.66.66,0,0,1,119.39,148.42Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.9,147.55c.16.1.16.25,0,.34a.66.66,0,0,1-.58,0c-.16-.09-.16-.24,0-.34A.66.66,0,0,1,120.9,147.55Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.41,146.68c.16.1.16.24,0,.34a.66.66,0,0,1-.58,0c-.16-.1-.16-.24,0-.34A.66.66,0,0,1,122.41,146.68Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.27,151a.66.66,0,0,1,.58,0,.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0A.17.17,0,0,1,111.27,151Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,145.76s2.06-12.31,1-17.9l-10.61,1.27a52.23,52.23,0,0,1-3.83,17.81h0c-.24.55.07,1.21.9,1.69l2.15,1.24a4.45,4.45,0,0,0,4,.16l5.67-3.27a1.2,1.2,0,0,0,.69-1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.63,139.18l-5.87-3.27a.3.3,0,0,0-.44.26c0,1.18-.38,4.57-3.29,11.45h0c-.25.56.06,1.21.9,1.69l.9.53a4.47,4.47,0,0,0,3.75,0l5.67-3.28a1.19,1.19,0,0,0,.69-1s.06-.33.15-.92A16.56,16.56,0,0,1,118.63,139.18Z",
    style: {
      fill: "#fff"
    }
  }), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M114.59,150l5.67-3.27a1.21,1.21,0,0,0,.7-1h0s2.05-12.31,1-17.9l-2.76.33-2.87,1.5s0,11.82-3.79,20.68h0s0,0,0,.05A3.76,3.76,0,0,0,114.59,150Z"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M112.92,150.56a4.75,4.75,0,0,1-2.34-.58l-2.14-1.24c-.78-.45-1.16-1.06-1-1.65h0l.09-.22a52.5,52.5,0,0,0,3.81-17.75V129l10.86-1.3,0,.12c1,5.49-.94,17.52-1,17.94a1.33,1.33,0,0,1-.76,1.1l-5.67,3.28A3.69,3.69,0,0,1,112.92,150.56Zm-5.1-3.79-.09.22c-.23.51.09,1.09.84,1.52l2.14,1.24a4.34,4.34,0,0,0,3.88.17l5.67-3.28a1.07,1.07,0,0,0,.63-.88v0c0-.13,2-12.17,1-17.73l-10.37,1.24a53,53,0,0,1-3.74,17.52Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127.79,122.3a11.76,11.76,0,0,0-5.32-9.21,3.85,3.85,0,0,0-3.6-.46h0a2.5,2.5,0,0,0-.35.21l-3.83,2.25.48,1.27,7,11.77,3.9-2.3a2,2,0,0,0,.35-.21h0A3.9,3.9,0,0,0,127.79,122.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.43,123.83a11.91,11.91,0,0,0-5.29-8.56,3.84,3.84,0,0,0-3.6-.45h0a3.79,3.79,0,0,0-.34.2l-3,1.73L122,128.13l3.9-2.3a2,2,0,0,0,.35-.21h0A3.2,3.2,0,0,0,127.43,123.83Z",
    style: {
      fill: "#fff"
    }
  }), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M122.13,128.31l-7.07-11.88-.54-1.4,3.94-2.31.35-.21a4,4,0,0,1,3.73.46,11.92,11.92,0,0,1,5.38,9.33,4,4,0,0,1-1.42,3.43,2.26,2.26,0,0,1-.37.22Zm-7.28-13.16.45,1.16,6.92,11.63,3.79-2.23a3.12,3.12,0,0,0,1.65-3.41,11.61,11.61,0,0,0-5.26-9.09,3.75,3.75,0,0,0-3.47-.46,2.63,2.63,0,0,0-.33.2Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 118.53,
    cy: 121.55,
    rx: 4.34,
    ry: 7.52,
    transform: "translate(-44.9 75.55) rotate(-30)",
    style: {
      fill: "#fff"
    }
  }), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M120.9,128.56a4.93,4.93,0,0,1-2.44-.75,11.92,11.92,0,0,1-5.39-9.33,3.37,3.37,0,0,1,5.52-3.18,11.9,11.9,0,0,1,5.39,9.32,3.87,3.87,0,0,1-1.62,3.56A2.92,2.92,0,0,1,120.9,128.56Zm-4.75-13.74a2.57,2.57,0,0,0-1.32.34,3.6,3.6,0,0,0-1.49,3.32,11.63,11.63,0,0,0,5.25,9.1,3.11,3.11,0,0,0,5.12-3,11.6,11.6,0,0,0-5.25-9.09A4.72,4.72,0,0,0,116.15,114.82Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M122.33,124.88a10.56,10.56,0,0,0-4.77-8.28,3.48,3.48,0,0,0-3.23-.41h0l-.31.19-10.38,5.92.43,1.14L110.35,134l6.43-3.76c.11-.05,4.23-2.32,4.33-2.39h0A3.48,3.48,0,0,0,122.33,124.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.08,126.42a10.68,10.68,0,0,0-4.75-7.62,3.45,3.45,0,0,0-3.23-.41h0a1.92,1.92,0,0,0-.31.18L104.34,124l6,10,6.43-3.76c.11-.05,4.23-2.32,4.33-2.39h0A2.8,2.8,0,0,0,122.08,126.42Z",
    style: {
      fill: "#fff"
    }
  }), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M121.19,120.77h0c-.1.07-4.22,2.34-4.33,2.39l-6.43,3.76-3.35-.4-3.47-4.22.43,1.14L110.33,134l6.43-3.76c.11-.05,4.23-2.32,4.33-2.39h0a3.49,3.49,0,0,0,1.23-3,9.29,9.29,0,0,0-1.1-4.14Z"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M110.3,134.19,104,123.5l-.49-1.26,10.48-6,.32-.19a3.61,3.61,0,0,1,3.36.42,10.69,10.69,0,0,1,4.85,8.39,3.64,3.64,0,0,1-1.28,3.09c-.14.1-4.32,2.39-4.35,2.4Zm-6.51-11.83.4,1,6.21,10.43,6.31-3.68c.19-.09,4.22-2.32,4.32-2.39a3.38,3.38,0,0,0,1.17-2.87,10.42,10.42,0,0,0-4.71-8.16,3.37,3.37,0,0,0-3.11-.41,2.82,2.82,0,0,0-.29.18Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M111.85,130.86c0,3-2.14,4.28-4.77,2.76a10.57,10.57,0,0,1-4.78-8.28c0-3,2.14-4.28,4.78-2.75A10.56,10.56,0,0,1,111.85,130.86Z",
    style: {
      fill: "#fff"
    }
  }), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M109.21,134.41a4.44,4.44,0,0,1-2.2-.68,10.72,10.72,0,0,1-4.85-8.39,3,3,0,0,1,5-2.87,10.73,10.73,0,0,1,4.85,8.39,3.49,3.49,0,0,1-1.47,3.21A2.64,2.64,0,0,1,109.21,134.41Zm-4.27-12.34a2.29,2.29,0,0,0-1.17.3,3.22,3.22,0,0,0-1.34,3,10.45,10.45,0,0,0,4.71,8.16,2.78,2.78,0,0,0,4.58-2.64A10.42,10.42,0,0,0,107,122.7,4.23,4.23,0,0,0,104.94,122.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110.36,131.05a9.15,9.15,0,0,0-4.13-7.16c-1.34-.77-2.53-.73-3.29,0-1.84,1-7.19,3-14.14-1.6a.53.53,0,0,0-.79.64l10.48,25.86,2.05.41a1.73,1.73,0,0,0,2.06-1.87c-.33-3.37,0-9.61,5.91-13.34C109.62,133.76,110.36,132.72,110.36,131.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.33,134a2.12,2.12,0,0,0,1.59-1.39,9.3,9.3,0,0,0-4.08-6.35c-1.34-.78-2.53-.73-3.28,0-1.83,1-7.13,3-14-1.51l9.76,24.09,2,.41a1.72,1.72,0,0,0,1.77-.75,16.74,16.74,0,0,1,.2-3.22A13,13,0,0,1,108.33,134Z",
    style: {
      fill: "#fff"
    }
  }), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M100.89,149.35a2.21,2.21,0,0,1-.37,0l-2.13-.42L87.89,123a.65.65,0,0,1,.19-.77.66.66,0,0,1,.79,0c6.81,4.55,12,2.65,14,1.61.84-.77,2.09-.76,3.43,0a9.32,9.32,0,0,1,4.21,7.28c0,1.67-.73,2.8-1.94,3-5.83,3.69-6.16,9.86-5.83,13.21a1.87,1.87,0,0,1-1.84,2Zm-2.3-.69,2,.39a1.62,1.62,0,0,0,1.38-.39,1.58,1.58,0,0,0,.51-1.33c-.33-3.42,0-9.71,6-13.48l0,0c1.1-.2,1.75-1.24,1.75-2.78a9,9,0,0,0-4.07-7c-1.24-.72-2.38-.74-3.13,0l0,0c-2,1.06-7.33,3-14.27-1.61a.4.4,0,0,0-.48,0,.39.39,0,0,0-.12.46Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M100.91,154.12a5.18,5.18,0,0,0,.56-.72h0a12.11,12.11,0,0,0,1.84-7c0-8.94-6.28-19.82-14-24.29-3.63-2.1-6.94-2.41-9.43-1.24l-.23.12-.1.06-.31.18-.06,0a3.28,3.28,0,0,0-.31.2c-4,2.77-4.31,8-4.31,8l.73.71v0c0,6.19,3,13.31,7.44,18.59a14.12,14.12,0,0,0,6.22,6.27c3.74,1.67,6.52,1.68,8.5,1.12a6.66,6.66,0,0,0,3.34-2,1.85,1.85,0,0,0,.14-.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.11,153.16c.38-.42,0-1.39,0-1.39l.36.66c1.17-1.69,2.79-2.3,2.79-5.21,0-8.94-6.28-19.82-14-24.29-3.63-2.1-6.94-2.42-9.43-1.24l-.23.12-.11.06a2.38,2.38,0,0,0-.3.18l-.06,0-.31.21c-4,2.77-4.31,8-4.31,8l.73.71v0c0,6.2,3,13.32,7.44,18.6,1.55,2.75,4.17,3.62,6.81,4.79,3.74,1.67,4.82,1.13,6.81.56,1.29-.32,1.85-.3,2.77-1.27,0,0,0-1.9,1-.54C100.12,153.17,100.1,153.17,100.11,153.16Z",
    style: {
      fill: "#fff"
    }
  }), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M103.3,146.52a25.83,25.83,0,0,0-1.88-9.18,11.22,11.22,0,0,1-1.77,5.43h0a4.56,4.56,0,0,1-.55.72l0,0-.13.14a6.75,6.75,0,0,1-3.34,2c-2,.56-4.76.55-8.51-1.12a14.22,14.22,0,0,1-6.22-6.27,34,34,0,0,1-6-10.62,11.76,11.76,0,0,0-.35,2l.73.71v0c0,6.19,3,13.31,7.44,18.59a14.12,14.12,0,0,0,6.22,6.27c3.74,1.67,6.52,1.68,8.5,1.12a6.66,6.66,0,0,0,3.34-2l.13-.14,0,0a4.83,4.83,0,0,0,.56-.71h0A12.11,12.11,0,0,0,103.3,146.52Z"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M94.92,156.71a15,15,0,0,1-6.07-1.47c-2.4-1.06-4.51-3.19-6.28-6.32-4.58-5.47-7.45-12.61-7.45-18.63l-.74-.71v-.06c0-.06.34-5.33,4.36-8.11l.32-.21.06,0,.31-.18,0,0,.06,0,.24-.12c2.62-1.24,6-.8,9.55,1.24,7.77,4.49,14.09,15.44,14.09,24.41a12.34,12.34,0,0,1-1.83,7l0,0a4.38,4.38,0,0,1-.57.74h0l-.15.16a6.94,6.94,0,0,1-3.4,2A9.15,9.15,0,0,1,94.92,156.71ZM74.66,129.47l.72.71v0c0,6,2.84,13.09,7.41,18.54,1.76,3.1,3.83,5.19,6.17,6.23,3.19,1.42,6,1.79,8.42,1.11a6.62,6.62,0,0,0,3.27-1.92l.14-.14.12.07-.1-.09a5.81,5.81,0,0,0,.49-.62h0l0-.09a12,12,0,0,0,1.81-6.87c0-8.88-6.26-19.73-14-24.17-3.46-2-6.77-2.44-9.31-1.23l-.22.11-.11.06-.3.17-.06,0-.31.2C75.22,124.18,74.71,128.88,74.66,129.47Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.63,
    cy: 139.18,
    rx: 10.81,
    ry: 18.72,
    transform: "translate(-57.85 62.46) rotate(-30)",
    style: {
      fill: "#fff"
    }
  }), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M90.91,136.56a27.61,27.61,0,0,1,9.94,10.95c0-.22,0-.44,0-.67,0-8.44-5.93-18.7-13.24-22.92s-13.23-.8-13.23,7.64a26.44,26.44,0,0,0,3.29,12C78,135.59,83.8,132.46,90.91,136.56Z"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M93.54,156.4a12.09,12.09,0,0,1-6-1.83c-7.34-4.23-13.31-14.57-13.31-23,0-4.14,1.4-7.22,3.95-8.69s5.91-1.14,9.49.93C95,128,101,138.35,101,146.82c0,4.13-1.4,7.21-3.94,8.68A7,7,0,0,1,93.54,156.4ZM81.72,122.22a6.69,6.69,0,0,0-3.38.86c-2.45,1.42-3.81,4.42-3.81,8.46,0,8.38,5.91,18.61,13.17,22.8,3.49,2,6.77,2.35,9.22.93s3.81-4.42,3.81-8.45c0-8.39-5.9-18.62-13.16-22.81A12,12,0,0,0,81.72,122.22Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86.47,134.68,91,142.41,99.4,139a32.22,32.22,0,0,0-5.56-9.72l-7.31,5.13A.23.23,0,0,0,86.47,134.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.23,130.88l-6.94,4.88,3.81,6.49L99.16,139A32.24,32.24,0,0,0,94.23,130.88Z",
    style: {
      fill: "#fff"
    }
  }), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M91,142.58l-4.59-7.84a.35.35,0,0,1,.1-.46l7.4-5.2.08.09a32,32,0,0,1,5.59,9.77l0,.12Zm-4.36-8,4.48,7.63,8.16-3.33a31.45,31.45,0,0,0-5.42-9.47l-7.2,5.06a.09.09,0,0,0,0,.11Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.9,140.36a7.15,7.15,0,0,0-3.25-5.61,2.09,2.09,0,0,0-2.57,0h0a2,2,0,0,0-.4.54l-.69,1,.44.76a7.31,7.31,0,0,0,2.93,5.06l.45.78,1.38-.15.22,0h0C91.3,142.5,91.9,141.68,91.9,140.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.62,135.8a2.12,2.12,0,0,0-2.58,0h0a1.57,1.57,0,0,0-.39.54l-.39.53.13.21a7.31,7.31,0,0,0,2.93,5.07l.45.78,1.38-.16.22,0h0a1.86,1.86,0,0,0,1.46-1.81A7.27,7.27,0,0,0,88.62,135.8Z",
    style: {
      fill: "#fff"
    }
  }), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M88.74,143l-.48-.83a7.49,7.49,0,0,1-3-5.11l-.47-.81.75-1a1.67,1.67,0,0,1,.39-.55l0-.08,0,.08a2.35,2.35,0,0,1,2.75,0A7.31,7.31,0,0,1,92,140.36c0,1.35-.6,2.26-1.6,2.42a.85.85,0,0,1-.23,0Zm-3.59-6.73.41.73a7.22,7.22,0,0,0,2.87,5h0l.42.73,1.3-.14.21,0c.86-.15,1.37-1,1.37-2.16a7,7,0,0,0-3.17-5.5,2,2,0,0,0-2.42,0h0a1.8,1.8,0,0,0-.35.5Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.56,
    cy: 139.15,
    rx: 2.33,
    ry: 4.03,
    transform: "translate(-57.84 62.42) rotate(-30)",
    style: {
      fill: "#fff"
    }
  }), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M88.83,143a2.65,2.65,0,0,1-1.34-.41,6.43,6.43,0,0,1-2.92-5.05,1.87,1.87,0,0,1,3.06-1.76,6.45,6.45,0,0,1,2.92,5,2.13,2.13,0,0,1-.91,2A1.58,1.58,0,0,1,88.83,143Zm-2.54-7.36a1.3,1.3,0,0,0-.68.17,1.9,1.9,0,0,0-.77,1.73,6.15,6.15,0,0,0,2.79,4.82,1.85,1.85,0,0,0,1.88.2,1.88,1.88,0,0,0,.77-1.73A6.16,6.16,0,0,0,87.49,136,2.43,2.43,0,0,0,86.29,135.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.63,123.89c-7.31-4.22-13.23-.79-13.23,7.65s5.92,18.7,13.23,22.92,13.24.8,13.24-7.64S94.94,128.11,87.63,123.89Zm0,28.52c-6.33-3.65-11.46-12.54-11.46-19.85s5.13-10.28,11.46-6.62S99.1,138.48,99.1,145.79,94,156.07,87.63,152.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.77,146.83c0-.55,0-1.11-.08-1.67-1.25-7.66-6.57-15.95-13-19.64-7.31-4.22-13.23-.8-13.23,7.64,0,.55,0,1.11.08,1.68,1.24,7.66,6.57,15.95,13,19.63C94.84,158.69,100.77,155.27,100.77,146.83ZM76.33,135.51a17.45,17.45,0,0,1-.26-2.94c0-7.31,5.13-10.27,11.46-6.61,6,3.43,10.85,11.5,11.41,18.52a17.54,17.54,0,0,1,.26,2.94c0,7.31-5.13,10.28-11.47,6.62C81.78,150.6,76.89,142.54,76.33,135.51Z",
    style: {
      fill: "#fff"
    }
  }), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M93.54,156.4a12.09,12.09,0,0,1-6-1.83c-7.34-4.23-13.31-14.57-13.31-23,0-4.14,1.4-7.22,3.95-8.69s5.91-1.14,9.49.93C95,128,101,138.35,101,146.82c0,4.13-1.4,7.21-3.94,8.68A7,7,0,0,1,93.54,156.4ZM81.72,122.22a6.69,6.69,0,0,0-3.38.86c-2.45,1.42-3.81,4.42-3.81,8.46,0,8.38,5.91,18.61,13.17,22.8,3.49,2,6.77,2.35,9.22.93s3.81-4.42,3.81-8.45c0-8.39-5.9-18.62-13.16-22.81A12,12,0,0,0,81.72,122.22Zm11,31.9a10.57,10.57,0,0,1-5.18-1.59C81.21,148.86,76,139.9,76,132.56c0-3.59,1.22-6.27,3.43-7.54s5.13-1,8.24.8c6.36,3.67,11.53,12.63,11.53,20,0,3.59-1.21,6.27-3.42,7.54A6,6,0,0,1,92.75,154.12ZM82.51,124.5a5.8,5.8,0,0,0-2.92.75c-2.12,1.23-3.29,3.82-3.29,7.31,0,7.25,5.12,16.11,11.4,19.74,3,1.74,5.85,2,8,.8S99,149.28,99,145.79c0-7.25-5.11-16.11-11.39-19.74A10.32,10.32,0,0,0,82.51,124.5Z"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M119.7,125.33l-.09,0a.33.33,0,0,0-.4,0l-1.68,1a1.34,1.34,0,0,0-.54,1,.45.45,0,0,0,.16.41h0l.72.44,1.07-1,1-1,.37-.52Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.89,128.3l-.83-.51a.58.58,0,0,1-.2-.51,1.42,1.42,0,0,1,.61-1.15l1.68-1a.45.45,0,0,1,.55,0l.07,0,.69.42-.45.64-1,1Zm1.53-3a.33.33,0,0,0-.14,0l-1.68,1a1.16,1.16,0,0,0-.47.92c0,.23.07.28.09.3l0,0,.61.37,1-.9,1-1,.27-.39-.54-.33A.19.19,0,0,0,119.42,125.35Z",
    style: {
      fill: "#fff"
    }
  }), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M119.93,127.15l-1.68,1c-.3.17-.54,0-.54-.41h0a1.28,1.28,0,0,1,.54-1l1.68-1c.3-.17.54,0,.54.41h0A1.28,1.28,0,0,1,119.93,127.15Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M118,128.32a.46.46,0,0,1-.2,0,.61.61,0,0,1-.26-.56,1.43,1.43,0,0,1,.61-1.15l1.68-1a.46.46,0,0,1,.49,0,.6.6,0,0,1,.25.55,1.43,1.43,0,0,1-.61,1.15l-1.68,1A.6.6,0,0,1,118,128.32Zm2.11-2.54a.3.3,0,0,0-.15,0l-1.68,1a1.15,1.15,0,0,0-.47.91.37.37,0,0,0,.12.32.22.22,0,0,0,.22,0l1.68-1a1.13,1.13,0,0,0,.47-.91c0-.16,0-.28-.12-.32A.08.08,0,0,0,120.14,125.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.08,149.64a47.62,47.62,0,0,0,2.31-8.56,3.66,3.66,0,0,1,1.74-2.52l2.84-1.67,0-.33-3,1.77a3.93,3.93,0,0,0-1.86,2.7,46.45,46.45,0,0,1-2.43,8.82Z",
    style: {
      fill: "#fff"
    }
  }), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    points: "114.63 150.04 114.55 150.25 114.67 150.18 114.63 150.04"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M109.43,127.5s-6.61,2.29-8.82,7.4l-.07.16a30.29,30.29,0,0,1,2.38,7.06,12.38,12.38,0,0,1,5.66-8.16c1.11-.21,1.85-1.25,1.85-2.92A9.24,9.24,0,0,0,109.43,127.5Z"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    points: "123.03 120.94 127.02 118.68 127.66 120.85 127.79 122.86 127.47 124.19 126.88 125.21 125.41 126.22 122.88 127.71 123.71 126.06 123.84 124.36 123.52 122.31 123.03 120.94"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M116.66,130.16l-.14.08v.32l.28-.16,3.44-1.89-.41-.09C118.59,129.11,116.79,130.1,116.66,130.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.63,137.75l-.08.56a29.2,29.2,0,0,1,1.09,3.93l.14-.62A29.86,29.86,0,0,0,101.63,137.75Z",
    style: {
      fill: "#fff"
    }
  }), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M91.25,137.75l2.41-1.26,2.46-1.37.34.71c.9,1.88,1.55,3.67,1.55,3.67l-6.76,2.67.48-.72.17-1.09-.14-1.66Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "97.8 139.53 96.04 140.25 96.23 140.46 97.87 139.79 97.8 139.53",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.5,65.36l-48,27.71,48,27.7,48-27.7Zm48,27.71-48,27.7v55.41l48-27.71Zm-48,27.7-48-27.7v55.4l48,27.71Z",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "BRAND"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "159.88 32.66 207.86 60.37 207.86 115.77 159.88 143.47 111.89 115.77 111.89 60.37 159.88 32.66",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,115.89l48-27.82m0,0-.11-55.41M160,88.07l47.54,27.59",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,123.7a.26.26,0,0,1,0,.49,1,1,0,0,1-.85,0,.26.26,0,0,1,0-.49A1,1,0,0,1,166,123.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.23,122.43a.26.26,0,0,1,0,.49,1,1,0,0,1-.84,0,.26.26,0,0,1,0-.49A1,1,0,0,1,168.23,122.43Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.43,121.17a.25.25,0,0,1,0,.48,1,1,0,0,1-.84,0,.25.25,0,0,1,0-.48A.89.89,0,0,1,170.43,121.17Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.42,
    cy: 122.68,
    rx: 0.59,
    ry: 0.34,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,121.17a.25.25,0,0,1,0,.48,1,1,0,0,1-.85,0,.25.25,0,0,1,0-.48A.91.91,0,0,1,166,121.17Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 167.81,
    cy: 120.14,
    rx: 0.59,
    ry: 0.34,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.64,121.17a.25.25,0,0,1,0,.48,1,1,0,0,1-.84,0,.25.25,0,0,1,0-.48A.89.89,0,0,1,161.64,121.17Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.84,119.9a.25.25,0,0,1,0,.48.89.89,0,0,1-.84,0,.25.25,0,0,1,0-.48A.89.89,0,0,1,163.84,119.9Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,118.63a.25.25,0,0,1,0,.48.91.91,0,0,1-.85,0,.25.25,0,0,1,0-.48A1,1,0,0,1,166,118.63Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.03,
    cy: 120.14,
    rx: 0.59,
    ry: 0.34,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.64,118.63a.25.25,0,0,1,0,.48.89.89,0,0,1-.84,0,.25.25,0,0,1,0-.48A1,1,0,0,1,161.64,118.63Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.42,
    cy: 117.6,
    rx: 0.59,
    ry: 0.34,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.25,118.63a.25.25,0,0,1,0,.48.89.89,0,0,1-.84,0,.25.25,0,0,1,0-.48A1,1,0,0,1,157.25,118.63Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.45,117.36c.23.13.23.35,0,.49a1,1,0,0,1-.84,0c-.24-.14-.24-.36,0-.49A1,1,0,0,1,159.45,117.36Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.64,116.09a.26.26,0,0,1,0,.49,1,1,0,0,1-.84,0,.26.26,0,0,1,0-.49A1,1,0,0,1,161.64,116.09Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,117.35a.25.25,0,0,1,0,.48.89.89,0,0,1-.84,0,.25.25,0,0,1,0-.48A.89.89,0,0,1,155,117.35Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.23,116.08a.25.25,0,0,1,0,.48.89.89,0,0,1-.84,0,.25.25,0,0,1,0-.48A1,1,0,0,1,157.23,116.08Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.43,114.81a.26.26,0,0,1,0,.49,1,1,0,0,1-.84,0c-.24-.14-.24-.35,0-.49A1,1,0,0,1,159.43,114.81Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.84,116.08a.25.25,0,0,1,0,.48.89.89,0,0,1-.84,0c-.24-.13-.24-.35,0-.48A1,1,0,0,1,152.84,116.08Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 154.61,
    cy: 115.05,
    rx: 0.59,
    ry: 0.34,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 156.81,
    cy: 113.79,
    rx: 0.59,
    ry: 0.34,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.64,114.81a.26.26,0,0,1,0,.49,1,1,0,0,1-.84,0,.26.26,0,0,1,0-.49A1,1,0,0,1,150.64,114.81Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.84,113.54a.26.26,0,0,1,0,.49,1,1,0,0,1-.84,0c-.24-.14-.24-.35,0-.49A1,1,0,0,1,152.84,113.54Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,112.27c.23.14.23.36,0,.49a1,1,0,0,1-.84,0c-.23-.13-.23-.35,0-.49A1,1,0,0,1,155,112.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.02,
    cy: 113.79,
    rx: 0.59,
    ry: 0.34,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.64,112.27c.23.14.23.36,0,.49a1,1,0,0,1-.84,0c-.23-.13-.23-.35,0-.49A1,1,0,0,1,150.64,112.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 152.42,
    cy: 111.25,
    rx: 0.59,
    ry: 0.34,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.25,112.27c.23.14.23.36,0,.49a1,1,0,0,1-.84,0c-.24-.13-.24-.35,0-.49A1,1,0,0,1,146.25,112.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.44,111a.25.25,0,0,1,0,.48.89.89,0,0,1-.84,0,.25.25,0,0,1,0-.48A.89.89,0,0,1,148.44,111Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.64,109.74a.25.25,0,0,1,0,.48.89.89,0,0,1-.84,0,.25.25,0,0,1,0-.48A.89.89,0,0,1,150.64,109.74Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 143.63,
    cy: 111.25,
    rx: 0.59,
    ry: 0.34,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.25,109.74a.25.25,0,0,1,0,.48.89.89,0,0,1-.84,0c-.24-.13-.24-.35,0-.48A.89.89,0,0,1,146.25,109.74Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.02,
    cy: 108.71,
    rx: 0.59,
    ry: 0.34,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.85,109.74c.24.13.24.35,0,.48a.89.89,0,0,1-.84,0,.25.25,0,0,1,0-.48A.89.89,0,0,1,141.85,109.74Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.05,108.47c.23.13.23.35,0,.49a1,1,0,0,1-.84,0c-.23-.14-.23-.36,0-.49A1,1,0,0,1,144.05,108.47Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.25,107.2a.26.26,0,0,1,0,.49,1,1,0,0,1-.84,0c-.24-.14-.24-.35,0-.49A1,1,0,0,1,146.25,107.2Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.85,107.2c.24.14.24.35,0,.49a1,1,0,0,1-.84,0,.26.26,0,0,1,0-.49A1,1,0,0,1,141.85,107.2Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.05,105.93a.26.26,0,0,1,0,.49,1,1,0,0,1-.84,0,.26.26,0,0,1,0-.49A1,1,0,0,1,144.05,105.93Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.71,124.77a.25.25,0,0,1,0,.48.89.89,0,0,1-.84,0,.25.25,0,0,1,0-.48A.89.89,0,0,1,172.71,124.77Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.91,123.5a.25.25,0,0,1,0,.48.89.89,0,0,1-.84,0,.25.25,0,0,1,0-.48A1,1,0,0,1,174.91,123.5Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 167.9,
    cy: 125.01,
    rx: 0.59,
    ry: 0.34,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 170.09,
    cy: 123.74,
    rx: 0.59,
    ry: 0.34,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 172.29,
    cy: 122.47,
    rx: 0.59,
    ry: 0.34,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.64,119.91a.25.25,0,0,1,0,.48.89.89,0,0,1-.84,0,.25.25,0,0,1,0-.48A.89.89,0,0,1,172.64,119.91Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.84,118.64a.25.25,0,0,1,0,.48.89.89,0,0,1-.84,0,.25.25,0,0,1,0-.48A1,1,0,0,1,174.84,118.64Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.64,117.37a.26.26,0,0,1,0,.49,1,1,0,0,1-.84,0,.26.26,0,0,1,0-.49A1,1,0,0,1,172.64,117.37Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.41,117.37a1,1,0,0,1,.84,0,.26.26,0,0,1,0,.49,1,1,0,0,1-.84,0C167.18,117.72,167.17,117.51,167.41,117.37Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.45,116.1a.26.26,0,0,1,0,.49,1,1,0,0,1-.84,0c-.24-.14-.24-.35,0-.49A1,1,0,0,1,170.45,116.1Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.21,116.11a.92.92,0,0,1,.84,0c.23.14.23.36,0,.49a1,1,0,0,1-.84,0A.25.25,0,0,1,165.21,116.11Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.25,114.84a.25.25,0,0,1,0,.48,1,1,0,0,1-.84,0,.25.25,0,0,1,0-.48A.89.89,0,0,1,168.25,114.84Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,114.84a.89.89,0,0,1,.84,0c.24.13.24.35,0,.48a.89.89,0,0,1-.84,0A.25.25,0,0,1,163,114.84Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 165.63,
    cy: 113.81,
    rx: 0.59,
    ry: 0.34,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.25,112.78a.89.89,0,0,1-.84,0,.25.25,0,0,1,0-.48C167.64,112.16,168.48,112.65,168.25,112.78Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 161.22,
    cy: 113.8,
    rx: 0.59,
    ry: 0.34,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.42,
    cy: 112.53,
    rx: 0.59,
    ry: 0.34,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,111.5a.89.89,0,0,1-.84,0,.25.25,0,0,1,0-.48C165.43,110.88,166.27,111.37,166,111.5Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.6,112.29a.89.89,0,0,1,.84,0,.25.25,0,0,1,0,.48.89.89,0,0,1-.84,0A.25.25,0,0,1,158.6,112.29Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.64,111a.25.25,0,0,1,0,.48.89.89,0,0,1-.84,0,.25.25,0,0,1,0-.48A.89.89,0,0,1,161.64,111Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.84,110.23a.89.89,0,0,1-.84,0,.25.25,0,0,1,0-.48C163.23,109.61,164.07,110.1,163.84,110.23Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.4,111a.89.89,0,0,1,.84,0c.24.13.24.35,0,.48a.89.89,0,0,1-.84,0C156.17,111.37,156.17,111.15,156.4,111Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.44,109.75c.24.13.24.35,0,.48a.89.89,0,0,1-.84,0,.25.25,0,0,1,0-.48A.89.89,0,0,1,159.44,109.75Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.21,109.75a1,1,0,0,1,.84,0,.25.25,0,0,1,0,.48.92.92,0,0,1-.84,0C154,110.1,154,109.88,154.21,109.75Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.25,108.48c.23.13.23.35,0,.49a1,1,0,0,1-.84,0c-.23-.14-.23-.36,0-.49A1,1,0,0,1,157.25,108.48Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,108.48a1,1,0,0,1,.84,0,.26.26,0,0,1,0,.49,1,1,0,0,1-.84,0A.26.26,0,0,1,152,108.48Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.05,107.21a.26.26,0,0,1,0,.49,1,1,0,0,1-.84,0,.26.26,0,0,1,0-.49A1,1,0,0,1,155.05,107.21Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.81,107.21a1,1,0,0,1,.84,0c.24.14.24.35,0,.49a1,1,0,0,1-.84,0C149.58,107.57,149.58,107.35,149.81,107.21Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.85,105.94c.24.14.24.36,0,.49a1,1,0,0,1-.84,0c-.23-.13-.23-.35,0-.49a1,1,0,0,1,.84,0Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.62,106a.92.92,0,0,1,.84,0c.23.14.23.36,0,.49a1,1,0,0,1-.84,0A.25.25,0,0,1,147.62,106Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.66,104.68a.25.25,0,0,1,0,.48.89.89,0,0,1-.84,0,.25.25,0,0,1,0-.48.89.89,0,0,1,.84,0C150.89,104.81,150.43,104.54,150.66,104.68Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.42,104.68a.89.89,0,0,1,.84,0,.25.25,0,0,1,0,.48.89.89,0,0,1-.84,0A.25.25,0,0,1,145.42,104.68Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.28,122.24a1,1,0,0,1,.84,0,.26.26,0,0,1,0,.49,1,1,0,0,1-.84,0A.26.26,0,0,1,176.28,122.24Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.08,121a1,1,0,0,1,.84,0c.24.14.24.35,0,.49a1,1,0,0,1-.84,0C173.85,121.33,173.85,121.11,174.08,121Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.12,119.71a.25.25,0,0,1,0,.48,1,1,0,0,1-.84,0,.25.25,0,0,1,0-.48A.89.89,0,0,1,177.12,119.71Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.94,85.74c0-7.91-5.56-17.53-12.41-21.48-3.35-1.94-6.38-2.15-8.62-.94h0l-.09,0-.1.06-2.91,1.71a.34.34,0,0,0,0,.58l1.74,1.15a13.29,13.29,0,0,0-.42,3.42c0,7.91,5.55,17.53,12.4,21.48a13.52,13.52,0,0,0,2.68,1.2l.65,2.25a.4.4,0,0,0,.58.24l2.8-1.64.18-.1.18-.11v0C171.66,92.21,172.94,89.52,172.94,85.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.21,95.91a.8.8,0,0,1-.3-.06.79.79,0,0,1-.47-.52l-.59-2a14.67,14.67,0,0,1-2.56-1.18c-6.95-4-12.6-13.8-12.6-21.83a14.17,14.17,0,0,1,.36-3.24l-1.49-1a.73.73,0,0,1-.34-.65.77.77,0,0,1,.37-.63l3.26-1.91h0c2.44-1.23,5.57-.87,8.86,1,6.95,4,12.6,13.81,12.6,21.84,0,3.71-1.21,6.58-3.41,8.1h0l-.51.32-2.79,1.63A.87.87,0,0,1,166.21,95.91ZM149.09,65.43l1.9,1.25-.07.28a12.74,12.74,0,0,0-.41,3.32c0,7.77,5.47,17.24,12.19,21.13a14.64,14.64,0,0,0,2.61,1.17l.21.06.71,2.46,3.13-1.87c2-1.34,3.17-4,3.17-7.49,0-7.77-5.48-17.25-12.2-21.13-3.1-1.79-6-2.12-8.22-.93l-.16.08h0Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.1,114.6l6.07-24.09-7.38-6.43-6.07,24.1c-.1.39.37,1,.67.85l3.68-1.7c.2-.1.51.18.6.52l1.65,6.34C154.46,114.71,155,115,155.1,114.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.89,115.19a1.12,1.12,0,0,1-1-.89L152.27,108a.42.42,0,0,0-.12-.21l-3.59,1.66a.74.74,0,0,1-.79-.15,1.25,1.25,0,0,1-.45-1.17l6.23-24.74,8.08,7L155.5,114.7a.62.62,0,0,1-.61.49Zm-2.74-8.29a.7.7,0,0,1,.31.07,1.18,1.18,0,0,1,.6.77l1.66,6.35a.39.39,0,0,0,.05.13l5.94-23.57L154,84.83l-5.9,23.45a.5.5,0,0,0,.17.34L151.9,107A.7.7,0,0,1,152.15,106.9Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.33,120.7l-5.91-31L156,87.49l5.91,31.05c.1.51.64.86.78.5l1.68-4.41c.09-.23.41-.14.6.18l3.66,6C169,121.26,169.43,121.21,169.33,120.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.12,121.52a1,1,0,0,1-.81-.53l-3.63-5.93-1.58,4.13a.6.6,0,0,1-.64.4,1.16,1.16,0,0,1-.92-1l-6-31.71,8.28,2.42,5.95,31.3a.7.7,0,0,1-.38.85A.66.66,0,0,1,169.12,121.52Zm-4.53-7.43a.94.94,0,0,1,.76.51l3.48,5.67L163.07,90l-6.51-1.9,5.78,30.4a.56.56,0,0,0,.09.19l1.59-4.17a.62.62,0,0,1,.51-.4Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.39,
    cy: 80.41,
    rx: 10.13,
    ry: 17.54,
    transform: "translate(-19.12 89.47) rotate(-30)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.93,96.84a11.63,11.63,0,0,1-5.74-1.76c-6.95-4-12.61-13.81-12.61-21.84,0-4,1.36-6.95,3.84-8.38s5.73-1.12,9.18.87c7,4,12.6,13.81,12.6,21.84,0,4-1.36,7-3.83,8.38A6.84,6.84,0,0,1,162.93,96.84Zm-11.08-32a5.9,5.9,0,0,0-3,.77c-2.21,1.28-3.43,4-3.43,7.67,0,7.77,5.47,17.25,12.2,21.13,3.18,1.84,6.15,2.15,8.36.87s3.43-4,3.43-7.67c0-7.77-5.48-17.25-12.2-21.13A10.89,10.89,0,0,0,151.85,64.8Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "ACTIVE-11",
    "data-name": "ACTIVE",
    cx: 157.64,
    cy: 80.41,
    rx: 7.91,
    ry: 13.7,
    transform: "translate(-19.08 89.59) rotate(-30)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.72,93.33a9.19,9.19,0,0,1-4.53-1.39c-5.46-3.15-9.89-10.83-9.89-17.13,0-3.13,1.08-5.49,3-6.62s4.54-.89,7.26.68C163.05,72,167.49,79.7,167.49,86c0,3.14-1.08,5.49-3.05,6.62A5.36,5.36,0,0,1,161.72,93.33Zm-8.65-25a4.55,4.55,0,0,0-2.32.59c-1.7,1-2.63,3.08-2.63,5.91,0,6,4.25,13.41,9.48,16.42,2.45,1.42,4.74,1.66,6.44.68s2.63-3.08,2.63-5.91c0-6-4.26-13.4-9.48-16.42A8.35,8.35,0,0,0,153.07,68.31Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.51,85.37l-3.85-7.62c-.53-1.06-.44-2.11.2-2.35h0c.65-.24,1.6.42,2.14,1.47l2,4,4.44-3.75c.53-.44,1.48,0,2.13,1h0c.65,1,.75,2.14.22,2.59L156.56,86C156.29,86.19,155.78,85.91,155.51,85.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.34,86.45h-.18a1.61,1.61,0,0,1-1-.89l-3.86-7.62a2.85,2.85,0,0,1-.26-2.2,1.18,1.18,0,0,1,.69-.71c.85-.32,2,.41,2.64,1.66l1.79,3.55,4-3.42a1.22,1.22,0,0,1,1-.26,2.84,2.84,0,0,1,1.77,1.32c.77,1.17.83,2.55.14,3.13l-6.26,5.28A.74.74,0,0,1,156.34,86.45Zm-.46-1.27a.78.78,0,0,0,.46.45h0l6.21-5.26c.32-.27.26-1.2-.3-2.05a2.09,2.09,0,0,0-1.2-1,.39.39,0,0,0-.32.07l-4.84,4.09-2.26-4.47c-.46-.9-1.24-1.41-1.62-1.27a.39.39,0,0,0-.22.25,2.07,2.07,0,0,0,.24,1.53Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.32 79.66 171.28 77.82 172.53 81.4 172.94 86.91 172.53 90.2 169.09 94.04 167.7 94.6 168.83 92.55 169.75 89.18 169.75 84.83 168.32 80.41 168.32 79.66",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.88,32.66l-48,27.7,48,27.71,48-27.7Zm48,27.71-48,27.7v55.4l48-27.7Zm-48,27.7-48-27.71v55.41l48,27.7Z",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormgroupPerformance);
export default __webpack_public_path__ + "static/media/formgroupPerformance.26c715055206e19ee9c57e7f8d0075e0.svg";
export { ForwardRef as ReactComponent };